!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Quagga = e() : t.Quagga = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/", n(n.s = 67);
  }([function (t, e) {
    t.exports = function (t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e) {
    function n(e) {
      return t.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    t.exports = function (t, e, r) {
      return e && n(t.prototype, e), r && n(t, r), t;
    };
  }, function (t, e, n) {
    var r = n(19),
        i = n(1);

    t.exports = function (t, e) {
      return !e || "object" !== r(e) && "function" != typeof e ? i(t) : e;
    };
  }, function (t, e, n) {
    var r = n(140);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && r(t, e);
    };
  }, function (t, e, n) {
    t.exports = {
      EPSILON: n(36),
      create: n(37),
      clone: n(72),
      fromValues: n(73),
      copy: n(74),
      set: n(75),
      equals: n(76),
      exactEquals: n(77),
      add: n(78),
      subtract: n(38),
      sub: n(79),
      multiply: n(39),
      mul: n(80),
      divide: n(40),
      div: n(81),
      inverse: n(82),
      min: n(83),
      max: n(84),
      rotate: n(85),
      floor: n(86),
      ceil: n(87),
      round: n(88),
      scale: n(89),
      scaleAndAdd: n(90),
      distance: n(41),
      dist: n(91),
      squaredDistance: n(42),
      sqrDist: n(92),
      length: n(43),
      len: n(93),
      squaredLength: n(44),
      sqrLen: n(94),
      negate: n(95),
      normalize: n(96),
      dot: n(97),
      cross: n(98),
      lerp: n(99),
      random: n(100),
      transformMat2: n(101),
      transformMat2d: n(102),
      transformMat3: n(103),
      transformMat4: n(104),
      forEach: n(105),
      limit: n(106)
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "imageRef", function () {
      return l;
    }), n.d(e, "computeIntegralImage2", function () {
      return h;
    }), n.d(e, "computeIntegralImage", function () {
      return d;
    }), n.d(e, "thresholdImage", function () {
      return p;
    }), n.d(e, "computeHistogram", function () {
      return v;
    }), n.d(e, "sharpenLine", function () {
      return g;
    }), n.d(e, "determineOtsuThreshold", function () {
      return y;
    }), n.d(e, "otsuThreshold", function () {
      return _;
    }), n.d(e, "computeBinaryImage", function () {
      return m;
    }), n.d(e, "cluster", function () {
      return b;
    }), n.d(e, "Tracer", function () {
      return w;
    }), n.d(e, "DILATE", function () {
      return x;
    }), n.d(e, "ERODE", function () {
      return E;
    }), n.d(e, "dilate", function () {
      return A;
    }), n.d(e, "erode", function () {
      return R;
    }), n.d(e, "subtract", function () {
      return S;
    }), n.d(e, "bitwiseOr", function () {
      return O;
    }), n.d(e, "countNonZero", function () {
      return k;
    }), n.d(e, "topGeneric", function () {
      return C;
    }), n.d(e, "grayArrayFromImage", function () {
      return j;
    }), n.d(e, "grayArrayFromContext", function () {
      return M;
    }), n.d(e, "grayAndHalfSampleFromCanvasData", function () {
      return T;
    }), n.d(e, "computeGray", function () {
      return I;
    }), n.d(e, "loadImageArray", function () {
      return D;
    }), n.d(e, "halfSample", function () {
      return P;
    }), n.d(e, "hsv2rgb", function () {
      return L;
    }), n.d(e, "_computeDivisors", function () {
      return U;
    }), n.d(e, "calculatePatchSize", function () {
      return z;
    }), n.d(e, "_parseCSSDimensionValues", function () {
      return B;
    }), n.d(e, "_dimensionsConverters", function () {
      return N;
    }), n.d(e, "computeImageArea", function () {
      return W;
    });

    var r = n(7),
        i = n(63),
        o = {
      clone: r.clone,
      dot: r.dot
    },
        a = function a(t, e) {
      var n = [],
          r = {
        rad: 0,
        vec: o.clone([0, 0])
      },
          i = {};

      function a(t) {
        i[t.id] = t, n.push(t);
      }

      function u() {
        var t,
            e = 0;

        for (t = 0; t < n.length; t++) {
          e += n[t].rad;
        }

        r.rad = e / n.length, r.vec = o.clone([Math.cos(r.rad), Math.sin(r.rad)]);
      }

      return a(t), u(), {
        add: function add(t) {
          i[t.id] || (a(t), u());
        },
        fits: function fits(t) {
          return Math.abs(o.dot(t.point.vec, r.vec)) > e;
        },
        getPoints: function getPoints() {
          return n;
        },
        getCenter: function getCenter() {
          return r;
        }
      };
    },
        u = function u(t, e, n) {
      return {
        rad: t[n],
        point: t,
        id: e
      };
    },
        c = n(9),
        s = {
      clone: r.clone
    },
        f = {
      clone: i.clone
    };

    function l(t, e) {
      return {
        x: t,
        y: e,
        toVec2: function toVec2() {
          return s.clone([this.x, this.y]);
        },
        toVec3: function toVec3() {
          return f.clone([this.x, this.y, 1]);
        },
        round: function round() {
          return this.x = this.x > 0 ? Math.floor(this.x + .5) : Math.floor(this.x - .5), this.y = this.y > 0 ? Math.floor(this.y + .5) : Math.floor(this.y - .5), this;
        }
      };
    }

    function h(t, e) {
      var n,
          r,
          i = t.data,
          o = t.size.x,
          a = t.size.y,
          u = e.data,
          c = 0,
          s = 0,
          f = 0,
          l = 0,
          h = 0;

      for (f = o, c = 0, r = 1; r < a; r++) {
        c += i[s], u[f] += c, s += o, f += o;
      }

      for (s = 0, f = 1, c = 0, n = 1; n < o; n++) {
        c += i[s], u[f] += c, s++, f++;
      }

      for (r = 1; r < a; r++) {
        for (s = r * o + 1, f = (r - 1) * o + 1, l = r * o, h = (r - 1) * o, n = 1; n < o; n++) {
          u[s] += i[s] + u[f] + u[l] - u[h], s++, f++, l++, h++;
        }
      }
    }

    function d(t, e) {
      for (var n = t.data, r = t.size.x, i = t.size.y, o = e.data, a = 0, u = 0; u < r; u++) {
        a += n[u], o[u] = a;
      }

      for (var c = 1; c < i; c++) {
        a = 0;

        for (var s = 0; s < r; s++) {
          a += n[c * r + s], o[c * r + s] = a + o[(c - 1) * r + s];
        }
      }
    }

    function p(t, e, n) {
      n || (n = t);

      for (var r = t.data, i = r.length, o = n.data; i--;) {
        o[i] = r[i] < e ? 1 : 0;
      }
    }

    function v(t, e) {
      e || (e = 8);

      for (var n = t.data, r = n.length, i = 8 - e, o = new Int32Array(1 << e); r--;) {
        o[n[r] >> i]++;
      }

      return o;
    }

    function g(t) {
      var e,
          n,
          r = t.length,
          i = t[0],
          o = t[1];

      for (e = 1; e < r - 1; e++) {
        n = t[e + 1], t[e - 1] = 2 * o - i - n & 255, i = o, o = n;
      }

      return t;
    }

    function y(t) {
      var e,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8,
          r = 8 - n;

      function i(t, n) {
        for (var r = 0, i = t; i <= n; i++) {
          r += e[i];
        }

        return r;
      }

      function o(t, n) {
        for (var r = 0, i = t; i <= n; i++) {
          r += i * e[i];
        }

        return r;
      }

      function a() {
        var r,
            a,
            u,
            s,
            f = [0],
            l = (1 << n) - 1;
        e = v(t, n);

        for (var h = 1; h < l; h++) {
          0 === (u = (r = i(0, h)) * (a = i(h + 1, l))) && (u = 1), s = o(0, h) * a - o(h + 1, l) * r, f[h] = s * s / u;
        }

        return c.a.maxIndex(f);
      }

      var u = a();
      return u << r;
    }

    function _(t, e) {
      var n = y(t);
      return p(t, n, e), n;
    }

    function m(t, e, n) {
      d(t, e), n || (n = t);
      var r,
          i,
          o,
          a,
          u,
          c,
          s = t.data,
          f = n.data,
          l = t.size.x,
          h = t.size.y,
          p = e.data;

      for (r = 0; r <= 3; r++) {
        for (i = 0; i < l; i++) {
          f[r * l + i] = 0, f[(h - 1 - r) * l + i] = 0;
        }
      }

      for (r = 3; r < h - 3; r++) {
        for (i = 0; i <= 3; i++) {
          f[r * l + i] = 0, f[r * l + (l - 1 - i)] = 0;
        }
      }

      for (r = 4; r < h - 3 - 1; r++) {
        for (i = 4; i < l - 3; i++) {
          o = p[(r - 3 - 1) * l + (i - 3 - 1)], a = p[(r - 3 - 1) * l + (i + 3)], u = p[(r + 3) * l + (i - 3 - 1)], c = (p[(r + 3) * l + (i + 3)] - u - a + o) / 49, f[r * l + i] = s[r * l + i] > c + 5 ? 0 : 1;
        }
      }
    }

    function b(t, e, n) {
      var r,
          i,
          o,
          c,
          s = [];

      function f(t) {
        var e = !1;

        for (i = 0; i < s.length; i++) {
          (o = s[i]).fits(t) && (o.add(t), e = !0);
        }

        return e;
      }

      for (n || (n = "rad"), r = 0; r < t.length; r++) {
        f(c = u(t[r], r, n)) || s.push(a(c, e));
      }

      return s;
    }

    var w = {
      trace: function trace(t, e) {
        var n,
            r = [],
            i = [],
            o = 0,
            a = 0;

        function u(n, r) {
          var i,
              o,
              a,
              u = Math.abs(e[1] / 10),
              c = !1;
          var s,
              f,
              l = t[n];

          for (a = r ? {
            x: l.x + e[0],
            y: l.y + e[1]
          } : {
            x: l.x - e[0],
            y: l.y - e[1]
          }, i = t[o = r ? n + 1 : n - 1]; i && !0 != (f = a, c = (s = i).x > f.x - 1 && s.x < f.x + 1 && s.y > f.y - u && s.y < f.y + u) && Math.abs(i.y - l.y) < e[1];) {
            i = t[o = r ? o + 1 : o - 1];
          }

          return c ? o : null;
        }

        for (n = 0; n < 10; n++) {
          for (a = o = Math.floor(Math.random() * t.length), (r = []).push(t[a]); null !== (a = u(a, !0));) {
            r.push(t[a]);
          }

          if (o > 0) for (a = o; null !== (a = u(a, !1));) {
            r.push(t[a]);
          }
          r.length > i.length && (i = r);
        }

        return i;
      }
    },
        x = 1,
        E = 2;

    function A(t, e) {
      var n,
          r,
          i,
          o,
          a,
          u,
          c,
          s = t.data,
          f = e.data,
          l = t.size.y,
          h = t.size.x;

      for (n = 1; n < l - 1; n++) {
        for (r = 1; r < h - 1; r++) {
          a = n + 1, c = r + 1, i = s[(o = n - 1) * h + (u = r - 1)] + s[o * h + c] + s[n * h + r] + s[a * h + u] + s[a * h + c], f[n * h + r] = i > 0 ? 1 : 0;
        }
      }
    }

    function R(t, e) {
      var n,
          r,
          i,
          o,
          a,
          u,
          c,
          s = t.data,
          f = e.data,
          l = t.size.y,
          h = t.size.x;

      for (n = 1; n < l - 1; n++) {
        for (r = 1; r < h - 1; r++) {
          a = n + 1, c = r + 1, i = s[(o = n - 1) * h + (u = r - 1)] + s[o * h + c] + s[n * h + r] + s[a * h + u] + s[a * h + c], f[n * h + r] = 5 === i ? 1 : 0;
        }
      }
    }

    function S(t, e, n) {
      n || (n = t);

      for (var r = t.data.length, i = t.data, o = e.data, a = n.data; r--;) {
        a[r] = i[r] - o[r];
      }
    }

    function O(t, e, n) {
      n || (n = t);

      for (var r = t.data.length, i = t.data, o = e.data, a = n.data; r--;) {
        a[r] = i[r] || o[r];
      }
    }

    function k(t) {
      for (var e = t.data.length, n = t.data, r = 0; e--;) {
        r += n[e];
      }

      return r;
    }

    function C(t, e, n) {
      var r,
          i,
          o,
          a,
          u = 0,
          c = 0,
          s = [];

      for (r = 0; r < e; r++) {
        s[r] = {
          score: 0,
          item: null
        };
      }

      for (r = 0; r < t.length; r++) {
        if ((i = n.apply(this, [t[r]])) > c) for ((o = s[u]).score = i, o.item = t[r], c = Number.MAX_VALUE, a = 0; a < e; a++) {
          s[a].score < c && (c = s[a].score, u = a);
        }
      }

      return s;
    }

    function j(t, e, n, r) {
      n.drawImage(t, e, 0, t.width, t.height), I(n.getImageData(e, 0, t.width, t.height).data, r);
    }

    function M(t, e, n, r) {
      I(t.getImageData(n.x, n.y, e.x, e.y).data, r);
    }

    function T(t, e, n) {
      for (var r, i = 0, o = e.x, a = Math.floor(t.length / 4), u = e.x / 2, c = 0, s = e.x; o < a;) {
        for (r = 0; r < u; r++) {
          n[c] = (.299 * t[4 * i + 0] + .587 * t[4 * i + 1] + .114 * t[4 * i + 2] + (.299 * t[4 * (i + 1) + 0] + .587 * t[4 * (i + 1) + 1] + .114 * t[4 * (i + 1) + 2]) + (.299 * t[4 * o + 0] + .587 * t[4 * o + 1] + .114 * t[4 * o + 2]) + (.299 * t[4 * (o + 1) + 0] + .587 * t[4 * (o + 1) + 1] + .114 * t[4 * (o + 1) + 2])) / 4, c++, i += 2, o += 2;
        }

        i += s, o += s;
      }
    }

    function I(t, e, n) {
      var r = t.length / 4 | 0;
      if (n && !0 === n.singleChannel) for (var i = 0; i < r; i++) {
        e[i] = t[4 * i + 0];
      } else for (var o = 0; o < r; o++) {
        e[o] = .299 * t[4 * o + 0] + .587 * t[4 * o + 1] + .114 * t[4 * o + 2];
      }
    }

    function D(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document && document.createElement("canvas"),
          r = new Image();
      r.callback = e, r.onload = function () {
        n.width = this.width, n.height = this.height;
        var t = n.getContext("2d");
        t.drawImage(this, 0, 0);
        var e = new Uint8Array(this.width * this.height);
        t.drawImage(this, 0, 0), I(t.getImageData(0, 0, this.width, this.height).data, e), this.callback(e, {
          x: this.width,
          y: this.height
        }, this);
      }, r.src = t;
    }

    function P(t, e) {
      for (var n = t.data, r = t.size.x, i = e.data, o = 0, a = r, u = n.length, c = r / 2, s = 0; a < u;) {
        for (var f = 0; f < c; f++) {
          i[s] = Math.floor((n[o] + n[o + 1] + n[a] + n[a + 1]) / 4), s++, o += 2, a += 2;
        }

        o += r, a += r;
      }
    }

    function L(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [0, 0, 0],
          n = t[0],
          r = t[1],
          i = t[2],
          o = i * r,
          a = o * (1 - Math.abs(n / 60 % 2 - 1)),
          u = i - o,
          c = 0,
          s = 0,
          f = 0;
      return n < 60 ? (c = o, s = a) : n < 120 ? (c = a, s = o) : n < 180 ? (s = o, f = a) : n < 240 ? (s = a, f = o) : n < 300 ? (c = a, f = o) : n < 360 && (c = o, f = a), e[0] = 255 * (c + u) | 0, e[1] = 255 * (s + u) | 0, e[2] = 255 * (f + u) | 0, e;
    }

    function U(t) {
      for (var e = [], n = [], r = 1; r < Math.sqrt(t) + 1; r++) {
        t % r == 0 && (n.push(r), r !== t / r && e.unshift(Math.floor(t / r)));
      }

      return n.concat(e);
    }

    function z(t, e) {
      var n,
          r = U(e.x),
          i = U(e.y),
          o = Math.max(e.x, e.y),
          a = function (t, e) {
        for (var n = 0, r = 0, i = []; n < t.length && r < e.length;) {
          t[n] === e[r] ? (i.push(t[n]), n++, r++) : t[n] > e[r] ? r++ : n++;
        }

        return i;
      }(r, i),
          u = [8, 10, 15, 20, 32, 60, 80],
          c = {
        "x-small": 5,
        small: 4,
        medium: 3,
        large: 2,
        "x-large": 1
      },
          s = c[t] || c.medium,
          f = u[s],
          l = Math.floor(o / f);

      function h(t) {
        for (var e = 0, n = t[Math.floor(t.length / 2)]; e < t.length - 1 && t[e] < l;) {
          e++;
        }

        return e > 0 && (n = Math.abs(t[e] - l) > Math.abs(t[e - 1] - l) ? t[e - 1] : t[e]), l / n < u[s + 1] / u[s] && l / n > u[s - 1] / u[s] ? {
          x: n,
          y: n
        } : null;
      }

      return (n = h(a)) || (n = h(U(o))) || (n = h(U(l * f))), n;
    }

    function B(t) {
      return {
        value: parseFloat(t),
        unit: (t.indexOf("%"), t.length, "%")
      };
    }

    var N = {
      top: function top(t, e) {
        return "%" === t.unit ? Math.floor(e.height * (t.value / 100)) : null;
      },
      right: function right(t, e) {
        return "%" === t.unit ? Math.floor(e.width - e.width * (t.value / 100)) : null;
      },
      bottom: function bottom(t, e) {
        return "%" === t.unit ? Math.floor(e.height - e.height * (t.value / 100)) : null;
      },
      left: function left(t, e) {
        return "%" === t.unit ? Math.floor(e.width * (t.value / 100)) : null;
      }
    };

    function W(t, e, n) {
      var r = {
        width: t,
        height: e
      },
          i = Object.keys(n).reduce(function (t, e) {
        var i = B(n[e]),
            o = N[e](i, r);
        return t[e] = o, t;
      }, {});
      return {
        sx: i.left,
        sy: i.top,
        sw: i.right - i.left,
        sh: i.bottom - i.top
      };
    }
  }, function (t, e, n) {
    "use strict";

    e.a = {
      init: function init(t, e) {
        for (var n = t.length; n--;) {
          t[n] = e;
        }
      },
      shuffle: function shuffle(t) {
        for (var e = t.length - 1; e >= 0; e--) {
          var n = Math.floor(Math.random() * e),
              r = t[e];
          t[e] = t[n], t[n] = r;
        }

        return t;
      },
      toPointList: function toPointList(t) {
        var e = t.reduce(function (t, e) {
          var n = "[".concat(e.join(","), "]");
          return t.push(n), t;
        }, []);
        return "[".concat(e.join(",\r\n"), "]");
      },
      threshold: function threshold(t, e, n) {
        return t.reduce(function (r, i) {
          return n.apply(t, [i]) >= e && r.push(i), r;
        }, []);
      },
      maxIndex: function maxIndex(t) {
        for (var e = 0, n = 0; n < t.length; n++) {
          t[n] > t[e] && (e = n);
        }

        return e;
      },
      max: function max(t) {
        for (var e = 0, n = 0; n < t.length; n++) {
          t[n] > e && (e = t[n]);
        }

        return e;
      },
      sum: function sum(t) {
        for (var e = t.length, n = 0; e--;) {
          n += t[e];
        }

        return n;
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(25),
        i = n.n(r),
        o = n(3),
        a = n.n(o),
        u = n(4),
        c = n.n(u),
        s = n(0),
        f = n.n(s),
        l = n(7),
        h = n(8),
        d = n(9),
        p = {
      clone: l.clone
    };

    function v(t) {
      if (t < 0) throw new Error("expected positive number, received ".concat(t));
    }

    var g = function () {
      function t(e, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Uint8Array,
            i = arguments.length > 3 ? arguments[3] : void 0;
        a()(this, t), f()(this, "data", void 0), f()(this, "size", void 0), f()(this, "indexMapping", void 0), n ? this.data = n : (this.data = new r(e.x * e.y), i && d.a.init(this.data, 0)), this.size = e;
      }

      return c()(t, [{
        key: "inImageWithBorder",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return v(e), t.x >= 0 && t.y >= 0 && t.x < this.size.x + 2 * e && t.y < this.size.y + 2 * e;
        }
      }, {
        key: "subImageAsCopy",
        value: function value(t, e) {
          v(e.x), v(e.y);

          for (var n = t.size, r = n.x, i = n.y, o = 0; o < r; o++) {
            for (var a = 0; a < i; a++) {
              t.data[a * r + o] = this.data[(e.y + a) * this.size.x + e.x + o];
            }
          }

          return t;
        }
      }, {
        key: "get",
        value: function value(t, e) {
          return this.data[e * this.size.x + t];
        }
      }, {
        key: "getSafe",
        value: function value(t, e) {
          if (!this.indexMapping) {
            this.indexMapping = {
              x: [],
              y: []
            };

            for (var n = 0; n < this.size.x; n++) {
              this.indexMapping.x[n] = n, this.indexMapping.x[n + this.size.x] = n;
            }

            for (var r = 0; r < this.size.y; r++) {
              this.indexMapping.y[r] = r, this.indexMapping.y[r + this.size.y] = r;
            }
          }

          return this.data[this.indexMapping.y[e + this.size.y] * this.size.x + this.indexMapping.x[t + this.size.x]];
        }
      }, {
        key: "set",
        value: function value(t, e, n) {
          return this.data[e * this.size.x + t] = n, delete this.indexMapping, this;
        }
      }, {
        key: "zeroBorder",
        value: function value() {
          for (var t = this.size, e = t.x, n = t.y, r = 0; r < e; r++) {
            this.data[r] = this.data[(n - 1) * e + r] = 0;
          }

          for (var i = 1; i < n - 1; i++) {
            this.data[i * e] = this.data[i * e + (e - 1)] = 0;
          }

          return delete this.indexMapping, this;
        }
      }, {
        key: "moments",
        value: function value(t) {
          var e,
              n,
              r,
              i,
              o,
              a,
              u,
              c,
              s,
              f,
              l = this.data,
              h = this.size.y,
              d = this.size.x,
              v = [],
              g = [],
              y = Math.PI,
              _ = y / 4;

          if (t <= 0) return g;

          for (o = 0; o < t; o++) {
            v[o] = {
              m00: 0,
              m01: 0,
              m10: 0,
              m11: 0,
              m02: 0,
              m20: 0,
              theta: 0,
              rad: 0
            };
          }

          for (n = 0; n < h; n++) {
            for (i = n * n, e = 0; e < d; e++) {
              (r = l[n * d + e]) > 0 && ((a = v[r - 1]).m00 += 1, a.m01 += n, a.m10 += e, a.m11 += e * n, a.m02 += i, a.m20 += e * e);
            }
          }

          for (o = 0; o < t; o++) {
            a = v[o], isNaN(a.m00) || 0 === a.m00 || (c = a.m10 / a.m00, s = a.m01 / a.m00, u = a.m11 / a.m00 - c * s, f = (a.m02 / a.m00 - s * s - (a.m20 / a.m00 - c * c)) / (2 * u), f = .5 * Math.atan(f) + (u >= 0 ? _ : -_) + y, a.theta = (180 * f / y + 90) % 180 - 90, a.theta < 0 && (a.theta += 180), a.rad = f > y ? f - y : f, a.vec = p.clone([Math.cos(f), Math.sin(f)]), g.push(a));
          }

          return g;
        }
      }, {
        key: "getAsRGBA",
        value: function value() {
          for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, e = new Uint8ClampedArray(4 * this.size.x * this.size.y), n = 0; n < this.size.y; n++) {
            for (var r = 0; r < this.size.x; r++) {
              var i = n * this.size.x + r,
                  o = this.get(r, n) * t;
              e[4 * i + 0] = o, e[4 * i + 1] = o, e[4 * i + 2] = o, e[4 * i + 3] = 255;
            }
          }

          return e;
        }
      }, {
        key: "show",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = t.getContext("2d");
          if (!n) throw new Error("Unable to get canvas context");
          var r = n.getImageData(0, 0, t.width, t.height),
              i = this.getAsRGBA(e);
          t.width = this.size.x, t.height = this.size.y;
          var o = new ImageData(i, r.width, r.height);
          n.putImageData(o, 0, 0);
        }
      }, {
        key: "overlay",
        value: function value(t, e, n) {
          var r = e < 0 || e > 360 ? 360 : e,
              o = [0, 1, 1],
              a = [0, 0, 0],
              u = [255, 255, 255],
              c = [0, 0, 0],
              s = t.getContext("2d");
          if (!s) throw new Error("Unable to get canvas context");

          for (var f = s.getImageData(n.x, n.y, this.size.x, this.size.y), l = f.data, d = this.data.length; d--;) {
            o[0] = this.data[d] * r;
            var p = 4 * d,
                v = o[0] <= 0 ? u : o[0] >= 360 ? c : Object(h.hsv2rgb)(o, a),
                g = i()(v, 3);
            l[p] = g[0], l[p + 1] = g[1], l[p + 2] = g[2], l[p + 3] = 255;
          }

          s.putImageData(f, n.x, n.y);
        }
      }]), t;
    }();

    e.a = g;
  }, function (t, e, n) {
    (function (t, r) {
      var i;
      /**
       * @license
       * Lodash <https://lodash.com/>
       * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */

      (function () {
        var o = "Expected a function",
            a = "__lodash_placeholder__",
            u = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
            c = "[object Arguments]",
            s = "[object Array]",
            f = "[object Boolean]",
            l = "[object Date]",
            h = "[object Error]",
            d = "[object Function]",
            p = "[object GeneratorFunction]",
            v = "[object Map]",
            g = "[object Number]",
            y = "[object Object]",
            _ = "[object RegExp]",
            m = "[object Set]",
            b = "[object String]",
            w = "[object Symbol]",
            x = "[object WeakMap]",
            E = "[object ArrayBuffer]",
            A = "[object DataView]",
            R = "[object Float32Array]",
            S = "[object Float64Array]",
            O = "[object Int8Array]",
            k = "[object Int16Array]",
            C = "[object Int32Array]",
            j = "[object Uint8Array]",
            M = "[object Uint16Array]",
            T = "[object Uint32Array]",
            I = /\b__p \+= '';/g,
            D = /\b(__p \+=) '' \+/g,
            P = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            L = /&(?:amp|lt|gt|quot|#39);/g,
            U = /[&<>"']/g,
            z = RegExp(L.source),
            B = RegExp(U.source),
            N = /<%-([\s\S]+?)%>/g,
            W = /<%([\s\S]+?)%>/g,
            F = /<%=([\s\S]+?)%>/g,
            q = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            V = /^\w*$/,
            Y = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            G = /[\\^$.*+?()[\]{}|]/g,
            H = RegExp(G.source),
            $ = /^\s+|\s+$/g,
            X = /^\s+/,
            Z = /\s+$/,
            Q = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            K = /\{\n\/\* \[wrapped with (.+)\] \*/,
            J = /,? & /,
            tt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            et = /\\(\\)?/g,
            nt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            rt = /\w*$/,
            it = /^[-+]0x[0-9a-f]+$/i,
            ot = /^0b[01]+$/i,
            at = /^\[object .+?Constructor\]$/,
            ut = /^0o[0-7]+$/i,
            ct = /^(?:0|[1-9]\d*)$/,
            st = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            ft = /($^)/,
            lt = /['\n\r\u2028\u2029\\]/g,
            ht = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            dt = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            pt = "[\\ud800-\\udfff]",
            vt = "[" + dt + "]",
            gt = "[" + ht + "]",
            yt = "\\d+",
            _t = "[\\u2700-\\u27bf]",
            mt = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            bt = "[^\\ud800-\\udfff" + dt + yt + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            wt = "\\ud83c[\\udffb-\\udfff]",
            xt = "[^\\ud800-\\udfff]",
            Et = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            At = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Rt = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            St = "(?:" + mt + "|" + bt + ")",
            Ot = "(?:" + Rt + "|" + bt + ")",
            kt = "(?:" + gt + "|" + wt + ")" + "?",
            Ct = "[\\ufe0e\\ufe0f]?" + kt + ("(?:\\u200d(?:" + [xt, Et, At].join("|") + ")[\\ufe0e\\ufe0f]?" + kt + ")*"),
            jt = "(?:" + [_t, Et, At].join("|") + ")" + Ct,
            Mt = "(?:" + [xt + gt + "?", gt, Et, At, pt].join("|") + ")",
            Tt = RegExp("['’]", "g"),
            It = RegExp(gt, "g"),
            Dt = RegExp(wt + "(?=" + wt + ")|" + Mt + Ct, "g"),
            Pt = RegExp([Rt + "?" + mt + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [vt, Rt, "$"].join("|") + ")", Ot + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [vt, Rt + St, "$"].join("|") + ")", Rt + "?" + St + "+(?:['’](?:d|ll|m|re|s|t|ve))?", Rt + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", yt, jt].join("|"), "g"),
            Lt = RegExp("[\\u200d\\ud800-\\udfff" + ht + "\\ufe0e\\ufe0f]"),
            Ut = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            zt = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            Bt = -1,
            Nt = {};
        Nt[R] = Nt[S] = Nt[O] = Nt[k] = Nt[C] = Nt[j] = Nt["[object Uint8ClampedArray]"] = Nt[M] = Nt[T] = !0, Nt[c] = Nt[s] = Nt[E] = Nt[f] = Nt[A] = Nt[l] = Nt[h] = Nt[d] = Nt[v] = Nt[g] = Nt[y] = Nt[_] = Nt[m] = Nt[b] = Nt[x] = !1;
        var Wt = {};
        Wt[c] = Wt[s] = Wt[E] = Wt[A] = Wt[f] = Wt[l] = Wt[R] = Wt[S] = Wt[O] = Wt[k] = Wt[C] = Wt[v] = Wt[g] = Wt[y] = Wt[_] = Wt[m] = Wt[b] = Wt[w] = Wt[j] = Wt["[object Uint8ClampedArray]"] = Wt[M] = Wt[T] = !0, Wt[h] = Wt[d] = Wt[x] = !1;

        var Ft = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            qt = parseFloat,
            Vt = parseInt,
            Yt = "object" == typeof t && t && t.Object === Object && t,
            Gt = "object" == typeof self && self && self.Object === Object && self,
            Ht = Yt || Gt || Function("return this")(),
            $t = e && !e.nodeType && e,
            Xt = $t && "object" == typeof r && r && !r.nodeType && r,
            Zt = Xt && Xt.exports === $t,
            Qt = Zt && Yt.process,
            Kt = function () {
          try {
            var t = Xt && Xt.require && Xt.require("util").types;

            return t || Qt && Qt.binding && Qt.binding("util");
          } catch (t) {}
        }(),
            Jt = Kt && Kt.isArrayBuffer,
            te = Kt && Kt.isDate,
            ee = Kt && Kt.isMap,
            ne = Kt && Kt.isRegExp,
            re = Kt && Kt.isSet,
            ie = Kt && Kt.isTypedArray;

        function oe(t, e, n) {
          switch (n.length) {
            case 0:
              return t.call(e);

            case 1:
              return t.call(e, n[0]);

            case 2:
              return t.call(e, n[0], n[1]);

            case 3:
              return t.call(e, n[0], n[1], n[2]);
          }

          return t.apply(e, n);
        }

        function ae(t, e, n, r) {
          for (var i = -1, o = null == t ? 0 : t.length; ++i < o;) {
            var a = t[i];
            e(r, a, n(a), t);
          }

          return r;
        }

        function ue(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
            ;
          }

          return t;
        }

        function ce(t, e) {
          for (var n = null == t ? 0 : t.length; n-- && !1 !== e(t[n], n, t);) {
            ;
          }

          return t;
        }

        function se(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
            if (!e(t[n], n, t)) return !1;
          }

          return !0;
        }

        function fe(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = 0, o = []; ++n < r;) {
            var a = t[n];
            e(a, n, t) && (o[i++] = a);
          }

          return o;
        }

        function le(t, e) {
          return !!(null == t ? 0 : t.length) && we(t, e, 0) > -1;
        }

        function he(t, e, n) {
          for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
            if (n(e, t[r])) return !0;
          }

          return !1;
        }

        function de(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
            i[n] = e(t[n], n, t);
          }

          return i;
        }

        function pe(t, e) {
          for (var n = -1, r = e.length, i = t.length; ++n < r;) {
            t[i + n] = e[n];
          }

          return t;
        }

        function ve(t, e, n, r) {
          var i = -1,
              o = null == t ? 0 : t.length;

          for (r && o && (n = t[++i]); ++i < o;) {
            n = e(n, t[i], i, t);
          }

          return n;
        }

        function ge(t, e, n, r) {
          var i = null == t ? 0 : t.length;

          for (r && i && (n = t[--i]); i--;) {
            n = e(n, t[i], i, t);
          }

          return n;
        }

        function ye(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
            if (e(t[n], n, t)) return !0;
          }

          return !1;
        }

        var _e = Re("length");

        function me(t, e, n) {
          var r;
          return n(t, function (t, n, i) {
            if (e(t, n, i)) return r = n, !1;
          }), r;
        }

        function be(t, e, n, r) {
          for (var i = t.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
            if (e(t[o], o, t)) return o;
          }

          return -1;
        }

        function we(t, e, n) {
          return e == e ? function (t, e, n) {
            var r = n - 1,
                i = t.length;

            for (; ++r < i;) {
              if (t[r] === e) return r;
            }

            return -1;
          }(t, e, n) : be(t, Ee, n);
        }

        function xe(t, e, n, r) {
          for (var i = n - 1, o = t.length; ++i < o;) {
            if (r(t[i], e)) return i;
          }

          return -1;
        }

        function Ee(t) {
          return t != t;
        }

        function Ae(t, e) {
          var n = null == t ? 0 : t.length;
          return n ? ke(t, e) / n : NaN;
        }

        function Re(t) {
          return function (e) {
            return null == e ? void 0 : e[t];
          };
        }

        function Se(t) {
          return function (e) {
            return null == t ? void 0 : t[e];
          };
        }

        function Oe(t, e, n, r, i) {
          return i(t, function (t, i, o) {
            n = r ? (r = !1, t) : e(n, t, i, o);
          }), n;
        }

        function ke(t, e) {
          for (var n, r = -1, i = t.length; ++r < i;) {
            var o = e(t[r]);
            void 0 !== o && (n = void 0 === n ? o : n + o);
          }

          return n;
        }

        function Ce(t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        }

        function je(t) {
          return function (e) {
            return t(e);
          };
        }

        function Me(t, e) {
          return de(e, function (e) {
            return t[e];
          });
        }

        function Te(t, e) {
          return t.has(e);
        }

        function Ie(t, e) {
          for (var n = -1, r = t.length; ++n < r && we(e, t[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function De(t, e) {
          for (var n = t.length; n-- && we(e, t[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function Pe(t, e) {
          for (var n = t.length, r = 0; n--;) {
            t[n] === e && ++r;
          }

          return r;
        }

        var Le = Se({
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "Ç": "C",
          "ç": "c",
          "Ð": "D",
          "ð": "d",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "Ñ": "N",
          "ñ": "n",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "Ý": "Y",
          "ý": "y",
          "ÿ": "y",
          "Æ": "Ae",
          "æ": "ae",
          "Þ": "Th",
          "þ": "th",
          "ß": "ss",
          "Ā": "A",
          "Ă": "A",
          "Ą": "A",
          "ā": "a",
          "ă": "a",
          "ą": "a",
          "Ć": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Č": "C",
          "ć": "c",
          "ĉ": "c",
          "ċ": "c",
          "č": "c",
          "Ď": "D",
          "Đ": "D",
          "ď": "d",
          "đ": "d",
          "Ē": "E",
          "Ĕ": "E",
          "Ė": "E",
          "Ę": "E",
          "Ě": "E",
          "ē": "e",
          "ĕ": "e",
          "ė": "e",
          "ę": "e",
          "ě": "e",
          "Ĝ": "G",
          "Ğ": "G",
          "Ġ": "G",
          "Ģ": "G",
          "ĝ": "g",
          "ğ": "g",
          "ġ": "g",
          "ģ": "g",
          "Ĥ": "H",
          "Ħ": "H",
          "ĥ": "h",
          "ħ": "h",
          "Ĩ": "I",
          "Ī": "I",
          "Ĭ": "I",
          "Į": "I",
          "İ": "I",
          "ĩ": "i",
          "ī": "i",
          "ĭ": "i",
          "į": "i",
          "ı": "i",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "ĸ": "k",
          "Ĺ": "L",
          "Ļ": "L",
          "Ľ": "L",
          "Ŀ": "L",
          "Ł": "L",
          "ĺ": "l",
          "ļ": "l",
          "ľ": "l",
          "ŀ": "l",
          "ł": "l",
          "Ń": "N",
          "Ņ": "N",
          "Ň": "N",
          "Ŋ": "N",
          "ń": "n",
          "ņ": "n",
          "ň": "n",
          "ŋ": "n",
          "Ō": "O",
          "Ŏ": "O",
          "Ő": "O",
          "ō": "o",
          "ŏ": "o",
          "ő": "o",
          "Ŕ": "R",
          "Ŗ": "R",
          "Ř": "R",
          "ŕ": "r",
          "ŗ": "r",
          "ř": "r",
          "Ś": "S",
          "Ŝ": "S",
          "Ş": "S",
          "Š": "S",
          "ś": "s",
          "ŝ": "s",
          "ş": "s",
          "š": "s",
          "Ţ": "T",
          "Ť": "T",
          "Ŧ": "T",
          "ţ": "t",
          "ť": "t",
          "ŧ": "t",
          "Ũ": "U",
          "Ū": "U",
          "Ŭ": "U",
          "Ů": "U",
          "Ű": "U",
          "Ų": "U",
          "ũ": "u",
          "ū": "u",
          "ŭ": "u",
          "ů": "u",
          "ű": "u",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "Ż": "Z",
          "Ž": "Z",
          "ź": "z",
          "ż": "z",
          "ž": "z",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Œ": "Oe",
          "œ": "oe",
          "ŉ": "'n",
          "ſ": "s"
        }),
            Ue = Se({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });

        function ze(t) {
          return "\\" + Ft[t];
        }

        function Be(t) {
          return Lt.test(t);
        }

        function Ne(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t, r) {
            n[++e] = [r, t];
          }), n;
        }

        function We(t, e) {
          return function (n) {
            return t(e(n));
          };
        }

        function Fe(t, e) {
          for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
            var u = t[n];
            u !== e && u !== a || (t[n] = a, o[i++] = n);
          }

          return o;
        }

        function qe(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t) {
            n[++e] = t;
          }), n;
        }

        function Ve(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t) {
            n[++e] = [t, t];
          }), n;
        }

        function Ye(t) {
          return Be(t) ? function (t) {
            var e = Dt.lastIndex = 0;

            for (; Dt.test(t);) {
              ++e;
            }

            return e;
          }(t) : _e(t);
        }

        function Ge(t) {
          return Be(t) ? function (t) {
            return t.match(Dt) || [];
          }(t) : function (t) {
            return t.split("");
          }(t);
        }

        var He = Se({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        });

        var $e = function t(e) {
          var n,
              r = (e = null == e ? Ht : $e.defaults(Ht.Object(), e, $e.pick(Ht, zt))).Array,
              i = e.Date,
              ht = e.Error,
              dt = e.Function,
              pt = e.Math,
              vt = e.Object,
              gt = e.RegExp,
              yt = e.String,
              _t = e.TypeError,
              mt = r.prototype,
              bt = dt.prototype,
              wt = vt.prototype,
              xt = e["__core-js_shared__"],
              Et = bt.toString,
              At = wt.hasOwnProperty,
              Rt = 0,
              St = (n = /[^.]+$/.exec(xt && xt.keys && xt.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
              Ot = wt.toString,
              kt = Et.call(vt),
              Ct = Ht._,
              jt = gt("^" + Et.call(At).replace(G, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              Mt = Zt ? e.Buffer : void 0,
              Dt = e.Symbol,
              Lt = e.Uint8Array,
              Ft = Mt ? Mt.allocUnsafe : void 0,
              Yt = We(vt.getPrototypeOf, vt),
              Gt = vt.create,
              $t = wt.propertyIsEnumerable,
              Xt = mt.splice,
              Qt = Dt ? Dt.isConcatSpreadable : void 0,
              Kt = Dt ? Dt.iterator : void 0,
              _e = Dt ? Dt.toStringTag : void 0,
              Se = function () {
            try {
              var t = Ji(vt, "defineProperty");
              return t({}, "", {}), t;
            } catch (t) {}
          }(),
              Xe = e.clearTimeout !== Ht.clearTimeout && e.clearTimeout,
              Ze = i && i.now !== Ht.Date.now && i.now,
              Qe = e.setTimeout !== Ht.setTimeout && e.setTimeout,
              Ke = pt.ceil,
              Je = pt.floor,
              tn = vt.getOwnPropertySymbols,
              en = Mt ? Mt.isBuffer : void 0,
              nn = e.isFinite,
              rn = mt.join,
              on = We(vt.keys, vt),
              an = pt.max,
              un = pt.min,
              cn = i.now,
              sn = e.parseInt,
              fn = pt.random,
              ln = mt.reverse,
              hn = Ji(e, "DataView"),
              dn = Ji(e, "Map"),
              pn = Ji(e, "Promise"),
              vn = Ji(e, "Set"),
              gn = Ji(e, "WeakMap"),
              yn = Ji(vt, "create"),
              _n = gn && new gn(),
              mn = {},
              bn = Oo(hn),
              wn = Oo(dn),
              xn = Oo(pn),
              En = Oo(vn),
              An = Oo(gn),
              Rn = Dt ? Dt.prototype : void 0,
              Sn = Rn ? Rn.valueOf : void 0,
              On = Rn ? Rn.toString : void 0;

          function kn(t) {
            if (Va(t) && !Ia(t) && !(t instanceof Tn)) {
              if (t instanceof Mn) return t;
              if (At.call(t, "__wrapped__")) return ko(t);
            }

            return new Mn(t);
          }

          var Cn = function () {
            function t() {}

            return function (e) {
              if (!qa(e)) return {};
              if (Gt) return Gt(e);
              t.prototype = e;
              var n = new t();
              return t.prototype = void 0, n;
            };
          }();

          function jn() {}

          function Mn(t, e) {
            this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
          }

          function Tn(t) {
            this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
          }

          function In(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function Dn(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function Pn(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function Ln(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.__data__ = new Pn(); ++e < n;) {
              this.add(t[e]);
            }
          }

          function Un(t) {
            var e = this.__data__ = new Dn(t);
            this.size = e.size;
          }

          function zn(t, e) {
            var n = Ia(t),
                r = !n && Ta(t),
                i = !n && !r && Ua(t),
                o = !n && !r && !i && Ka(t),
                a = n || r || i || o,
                u = a ? Ce(t.length, yt) : [],
                c = u.length;

            for (var s in t) {
              !e && !At.call(t, s) || a && ("length" == s || i && ("offset" == s || "parent" == s) || o && ("buffer" == s || "byteLength" == s || "byteOffset" == s) || ao(s, c)) || u.push(s);
            }

            return u;
          }

          function Bn(t) {
            var e = t.length;
            return e ? t[Lr(0, e - 1)] : void 0;
          }

          function Nn(t, e) {
            return Ao(yi(t), Xn(e, 0, t.length));
          }

          function Wn(t) {
            return Ao(yi(t));
          }

          function Fn(t, e, n) {
            (void 0 !== n && !Ca(t[e], n) || void 0 === n && !(e in t)) && Hn(t, e, n);
          }

          function qn(t, e, n) {
            var r = t[e];
            At.call(t, e) && Ca(r, n) && (void 0 !== n || e in t) || Hn(t, e, n);
          }

          function Vn(t, e) {
            for (var n = t.length; n--;) {
              if (Ca(t[n][0], e)) return n;
            }

            return -1;
          }

          function Yn(t, e, n, r) {
            return tr(t, function (t, i, o) {
              e(r, t, n(t), o);
            }), r;
          }

          function Gn(t, e) {
            return t && _i(e, bu(e), t);
          }

          function Hn(t, e, n) {
            "__proto__" == e && Se ? Se(t, e, {
              configurable: !0,
              enumerable: !0,
              value: n,
              writable: !0
            }) : t[e] = n;
          }

          function $n(t, e) {
            for (var n = -1, i = e.length, o = r(i), a = null == t; ++n < i;) {
              o[n] = a ? void 0 : vu(t, e[n]);
            }

            return o;
          }

          function Xn(t, e, n) {
            return t == t && (void 0 !== n && (t = t <= n ? t : n), void 0 !== e && (t = t >= e ? t : e)), t;
          }

          function Zn(t, e, n, r, i, o) {
            var a,
                u = 1 & e,
                s = 2 & e,
                h = 4 & e;
            if (n && (a = i ? n(t, r, i, o) : n(t)), void 0 !== a) return a;
            if (!qa(t)) return t;
            var x = Ia(t);

            if (x) {
              if (a = function (t) {
                var e = t.length,
                    n = new t.constructor(e);
                e && "string" == typeof t[0] && At.call(t, "index") && (n.index = t.index, n.input = t.input);
                return n;
              }(t), !u) return yi(t, a);
            } else {
              var I = no(t),
                  D = I == d || I == p;
              if (Ua(t)) return li(t, u);

              if (I == y || I == c || D && !i) {
                if (a = s || D ? {} : io(t), !u) return s ? function (t, e) {
                  return _i(t, eo(t), e);
                }(t, function (t, e) {
                  return t && _i(e, wu(e), t);
                }(a, t)) : function (t, e) {
                  return _i(t, to(t), e);
                }(t, Gn(a, t));
              } else {
                if (!Wt[I]) return i ? t : {};

                a = function (t, e, n) {
                  var r = t.constructor;

                  switch (e) {
                    case E:
                      return hi(t);

                    case f:
                    case l:
                      return new r(+t);

                    case A:
                      return function (t, e) {
                        var n = e ? hi(t.buffer) : t.buffer;
                        return new t.constructor(n, t.byteOffset, t.byteLength);
                      }(t, n);

                    case R:
                    case S:
                    case O:
                    case k:
                    case C:
                    case j:
                    case "[object Uint8ClampedArray]":
                    case M:
                    case T:
                      return di(t, n);

                    case v:
                      return new r();

                    case g:
                    case b:
                      return new r(t);

                    case _:
                      return function (t) {
                        var e = new t.constructor(t.source, rt.exec(t));
                        return e.lastIndex = t.lastIndex, e;
                      }(t);

                    case m:
                      return new r();

                    case w:
                      return i = t, Sn ? vt(Sn.call(i)) : {};
                  }

                  var i;
                }(t, I, u);
              }
            }

            o || (o = new Un());
            var P = o.get(t);
            if (P) return P;
            o.set(t, a), Xa(t) ? t.forEach(function (r) {
              a.add(Zn(r, e, n, r, t, o));
            }) : Ya(t) && t.forEach(function (r, i) {
              a.set(i, Zn(r, e, n, i, t, o));
            });
            var L = x ? void 0 : (h ? s ? Gi : Yi : s ? wu : bu)(t);
            return ue(L || t, function (r, i) {
              L && (r = t[i = r]), qn(a, i, Zn(r, e, n, i, t, o));
            }), a;
          }

          function Qn(t, e, n) {
            var r = n.length;
            if (null == t) return !r;

            for (t = vt(t); r--;) {
              var i = n[r],
                  o = e[i],
                  a = t[i];
              if (void 0 === a && !(i in t) || !o(a)) return !1;
            }

            return !0;
          }

          function Kn(t, e, n) {
            if ("function" != typeof t) throw new _t(o);
            return bo(function () {
              t.apply(void 0, n);
            }, e);
          }

          function Jn(t, e, n, r) {
            var i = -1,
                o = le,
                a = !0,
                u = t.length,
                c = [],
                s = e.length;
            if (!u) return c;
            n && (e = de(e, je(n))), r ? (o = he, a = !1) : e.length >= 200 && (o = Te, a = !1, e = new Ln(e));

            t: for (; ++i < u;) {
              var f = t[i],
                  l = null == n ? f : n(f);

              if (f = r || 0 !== f ? f : 0, a && l == l) {
                for (var h = s; h--;) {
                  if (e[h] === l) continue t;
                }

                c.push(f);
              } else o(e, l, r) || c.push(f);
            }

            return c;
          }

          kn.templateSettings = {
            escape: N,
            evaluate: W,
            interpolate: F,
            variable: "",
            imports: {
              _: kn
            }
          }, kn.prototype = jn.prototype, kn.prototype.constructor = kn, Mn.prototype = Cn(jn.prototype), Mn.prototype.constructor = Mn, Tn.prototype = Cn(jn.prototype), Tn.prototype.constructor = Tn, In.prototype.clear = function () {
            this.__data__ = yn ? yn(null) : {}, this.size = 0;
          }, In.prototype.delete = function (t) {
            var e = this.has(t) && delete this.__data__[t];
            return this.size -= e ? 1 : 0, e;
          }, In.prototype.get = function (t) {
            var e = this.__data__;

            if (yn) {
              var n = e[t];
              return "__lodash_hash_undefined__" === n ? void 0 : n;
            }

            return At.call(e, t) ? e[t] : void 0;
          }, In.prototype.has = function (t) {
            var e = this.__data__;
            return yn ? void 0 !== e[t] : At.call(e, t);
          }, In.prototype.set = function (t, e) {
            var n = this.__data__;
            return this.size += this.has(t) ? 0 : 1, n[t] = yn && void 0 === e ? "__lodash_hash_undefined__" : e, this;
          }, Dn.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, Dn.prototype.delete = function (t) {
            var e = this.__data__,
                n = Vn(e, t);
            return !(n < 0) && (n == e.length - 1 ? e.pop() : Xt.call(e, n, 1), --this.size, !0);
          }, Dn.prototype.get = function (t) {
            var e = this.__data__,
                n = Vn(e, t);
            return n < 0 ? void 0 : e[n][1];
          }, Dn.prototype.has = function (t) {
            return Vn(this.__data__, t) > -1;
          }, Dn.prototype.set = function (t, e) {
            var n = this.__data__,
                r = Vn(n, t);
            return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
          }, Pn.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new In(),
              map: new (dn || Dn)(),
              string: new In()
            };
          }, Pn.prototype.delete = function (t) {
            var e = Qi(this, t).delete(t);
            return this.size -= e ? 1 : 0, e;
          }, Pn.prototype.get = function (t) {
            return Qi(this, t).get(t);
          }, Pn.prototype.has = function (t) {
            return Qi(this, t).has(t);
          }, Pn.prototype.set = function (t, e) {
            var n = Qi(this, t),
                r = n.size;
            return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
          }, Ln.prototype.add = Ln.prototype.push = function (t) {
            return this.__data__.set(t, "__lodash_hash_undefined__"), this;
          }, Ln.prototype.has = function (t) {
            return this.__data__.has(t);
          }, Un.prototype.clear = function () {
            this.__data__ = new Dn(), this.size = 0;
          }, Un.prototype.delete = function (t) {
            var e = this.__data__,
                n = e.delete(t);
            return this.size = e.size, n;
          }, Un.prototype.get = function (t) {
            return this.__data__.get(t);
          }, Un.prototype.has = function (t) {
            return this.__data__.has(t);
          }, Un.prototype.set = function (t, e) {
            var n = this.__data__;

            if (n instanceof Dn) {
              var r = n.__data__;
              if (!dn || r.length < 199) return r.push([t, e]), this.size = ++n.size, this;
              n = this.__data__ = new Pn(r);
            }

            return n.set(t, e), this.size = n.size, this;
          };
          var tr = wi(cr),
              er = wi(sr, !0);

          function nr(t, e) {
            var n = !0;
            return tr(t, function (t, r, i) {
              return n = !!e(t, r, i);
            }), n;
          }

          function rr(t, e, n) {
            for (var r = -1, i = t.length; ++r < i;) {
              var o = t[r],
                  a = e(o);
              if (null != a && (void 0 === u ? a == a && !Qa(a) : n(a, u))) var u = a,
                  c = o;
            }

            return c;
          }

          function ir(t, e) {
            var n = [];
            return tr(t, function (t, r, i) {
              e(t, r, i) && n.push(t);
            }), n;
          }

          function or(t, e, n, r, i) {
            var o = -1,
                a = t.length;

            for (n || (n = oo), i || (i = []); ++o < a;) {
              var u = t[o];
              e > 0 && n(u) ? e > 1 ? or(u, e - 1, n, r, i) : pe(i, u) : r || (i[i.length] = u);
            }

            return i;
          }

          var ar = xi(),
              ur = xi(!0);

          function cr(t, e) {
            return t && ar(t, e, bu);
          }

          function sr(t, e) {
            return t && ur(t, e, bu);
          }

          function fr(t, e) {
            return fe(e, function (e) {
              return Na(t[e]);
            });
          }

          function lr(t, e) {
            for (var n = 0, r = (e = ui(e, t)).length; null != t && n < r;) {
              t = t[So(e[n++])];
            }

            return n && n == r ? t : void 0;
          }

          function hr(t, e, n) {
            var r = e(t);
            return Ia(t) ? r : pe(r, n(t));
          }

          function dr(t) {
            return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : _e && _e in vt(t) ? function (t) {
              var e = At.call(t, _e),
                  n = t[_e];

              try {
                t[_e] = void 0;
                var r = !0;
              } catch (t) {}

              var i = Ot.call(t);
              r && (e ? t[_e] = n : delete t[_e]);
              return i;
            }(t) : function (t) {
              return Ot.call(t);
            }(t);
          }

          function pr(t, e) {
            return t > e;
          }

          function vr(t, e) {
            return null != t && At.call(t, e);
          }

          function gr(t, e) {
            return null != t && e in vt(t);
          }

          function yr(t, e, n) {
            for (var i = n ? he : le, o = t[0].length, a = t.length, u = a, c = r(a), s = 1 / 0, f = []; u--;) {
              var l = t[u];
              u && e && (l = de(l, je(e))), s = un(l.length, s), c[u] = !n && (e || o >= 120 && l.length >= 120) ? new Ln(u && l) : void 0;
            }

            l = t[0];
            var h = -1,
                d = c[0];

            t: for (; ++h < o && f.length < s;) {
              var p = l[h],
                  v = e ? e(p) : p;

              if (p = n || 0 !== p ? p : 0, !(d ? Te(d, v) : i(f, v, n))) {
                for (u = a; --u;) {
                  var g = c[u];
                  if (!(g ? Te(g, v) : i(t[u], v, n))) continue t;
                }

                d && d.push(v), f.push(p);
              }
            }

            return f;
          }

          function _r(t, e, n) {
            var r = null == (t = go(t, e = ui(e, t))) ? t : t[So(Bo(e))];
            return null == r ? void 0 : oe(r, t, n);
          }

          function mr(t) {
            return Va(t) && dr(t) == c;
          }

          function br(t, e, n, r, i) {
            return t === e || (null == t || null == e || !Va(t) && !Va(e) ? t != t && e != e : function (t, e, n, r, i, o) {
              var a = Ia(t),
                  u = Ia(e),
                  d = a ? s : no(t),
                  p = u ? s : no(e),
                  x = (d = d == c ? y : d) == y,
                  R = (p = p == c ? y : p) == y,
                  S = d == p;

              if (S && Ua(t)) {
                if (!Ua(e)) return !1;
                a = !0, x = !1;
              }

              if (S && !x) return o || (o = new Un()), a || Ka(t) ? qi(t, e, n, r, i, o) : function (t, e, n, r, i, o, a) {
                switch (n) {
                  case A:
                    if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                    t = t.buffer, e = e.buffer;

                  case E:
                    return !(t.byteLength != e.byteLength || !o(new Lt(t), new Lt(e)));

                  case f:
                  case l:
                  case g:
                    return Ca(+t, +e);

                  case h:
                    return t.name == e.name && t.message == e.message;

                  case _:
                  case b:
                    return t == e + "";

                  case v:
                    var u = Ne;

                  case m:
                    var c = 1 & r;
                    if (u || (u = qe), t.size != e.size && !c) return !1;
                    var s = a.get(t);
                    if (s) return s == e;
                    r |= 2, a.set(t, e);
                    var d = qi(u(t), u(e), r, i, o, a);
                    return a.delete(t), d;

                  case w:
                    if (Sn) return Sn.call(t) == Sn.call(e);
                }

                return !1;
              }(t, e, d, n, r, i, o);

              if (!(1 & n)) {
                var O = x && At.call(t, "__wrapped__"),
                    k = R && At.call(e, "__wrapped__");

                if (O || k) {
                  var C = O ? t.value() : t,
                      j = k ? e.value() : e;
                  return o || (o = new Un()), i(C, j, n, r, o);
                }
              }

              if (!S) return !1;
              return o || (o = new Un()), function (t, e, n, r, i, o) {
                var a = 1 & n,
                    u = Yi(t),
                    c = u.length,
                    s = Yi(e).length;
                if (c != s && !a) return !1;
                var f = c;

                for (; f--;) {
                  var l = u[f];
                  if (!(a ? l in e : At.call(e, l))) return !1;
                }

                var h = o.get(t),
                    d = o.get(e);
                if (h && d) return h == e && d == t;
                var p = !0;
                o.set(t, e), o.set(e, t);
                var v = a;

                for (; ++f < c;) {
                  l = u[f];
                  var g = t[l],
                      y = e[l];
                  if (r) var _ = a ? r(y, g, l, e, t, o) : r(g, y, l, t, e, o);

                  if (!(void 0 === _ ? g === y || i(g, y, n, r, o) : _)) {
                    p = !1;
                    break;
                  }

                  v || (v = "constructor" == l);
                }

                if (p && !v) {
                  var m = t.constructor,
                      b = e.constructor;
                  m == b || !("constructor" in t) || !("constructor" in e) || "function" == typeof m && m instanceof m && "function" == typeof b && b instanceof b || (p = !1);
                }

                return o.delete(t), o.delete(e), p;
              }(t, e, n, r, i, o);
            }(t, e, n, r, br, i));
          }

          function wr(t, e, n, r) {
            var i = n.length,
                o = i,
                a = !r;
            if (null == t) return !o;

            for (t = vt(t); i--;) {
              var u = n[i];
              if (a && u[2] ? u[1] !== t[u[0]] : !(u[0] in t)) return !1;
            }

            for (; ++i < o;) {
              var c = (u = n[i])[0],
                  s = t[c],
                  f = u[1];

              if (a && u[2]) {
                if (void 0 === s && !(c in t)) return !1;
              } else {
                var l = new Un();
                if (r) var h = r(s, f, c, t, e, l);
                if (!(void 0 === h ? br(f, s, 3, r, l) : h)) return !1;
              }
            }

            return !0;
          }

          function xr(t) {
            return !(!qa(t) || (e = t, St && St in e)) && (Na(t) ? jt : at).test(Oo(t));
            var e;
          }

          function Er(t) {
            return "function" == typeof t ? t : null == t ? Gu : "object" == typeof t ? Ia(t) ? Cr(t[0], t[1]) : kr(t) : ec(t);
          }

          function Ar(t) {
            if (!lo(t)) return on(t);
            var e = [];

            for (var n in vt(t)) {
              At.call(t, n) && "constructor" != n && e.push(n);
            }

            return e;
          }

          function Rr(t) {
            if (!qa(t)) return function (t) {
              var e = [];
              if (null != t) for (var n in vt(t)) {
                e.push(n);
              }
              return e;
            }(t);
            var e = lo(t),
                n = [];

            for (var r in t) {
              ("constructor" != r || !e && At.call(t, r)) && n.push(r);
            }

            return n;
          }

          function Sr(t, e) {
            return t < e;
          }

          function Or(t, e) {
            var n = -1,
                i = Pa(t) ? r(t.length) : [];
            return tr(t, function (t, r, o) {
              i[++n] = e(t, r, o);
            }), i;
          }

          function kr(t) {
            var e = Ki(t);
            return 1 == e.length && e[0][2] ? po(e[0][0], e[0][1]) : function (n) {
              return n === t || wr(n, t, e);
            };
          }

          function Cr(t, e) {
            return co(t) && ho(e) ? po(So(t), e) : function (n) {
              var r = vu(n, t);
              return void 0 === r && r === e ? gu(n, t) : br(e, r, 3);
            };
          }

          function jr(t, e, n, r, i) {
            t !== e && ar(e, function (o, a) {
              if (i || (i = new Un()), qa(o)) !function (t, e, n, r, i, o, a) {
                var u = _o(t, n),
                    c = _o(e, n),
                    s = a.get(c);

                if (s) return void Fn(t, n, s);
                var f = o ? o(u, c, n + "", t, e, a) : void 0,
                    l = void 0 === f;

                if (l) {
                  var h = Ia(c),
                      d = !h && Ua(c),
                      p = !h && !d && Ka(c);
                  f = c, h || d || p ? Ia(u) ? f = u : La(u) ? f = yi(u) : d ? (l = !1, f = li(c, !0)) : p ? (l = !1, f = di(c, !0)) : f = [] : Ha(c) || Ta(c) ? (f = u, Ta(u) ? f = au(u) : qa(u) && !Na(u) || (f = io(c))) : l = !1;
                }

                l && (a.set(c, f), i(f, c, r, o, a), a.delete(c));
                Fn(t, n, f);
              }(t, e, a, n, jr, r, i);else {
                var u = r ? r(_o(t, a), o, a + "", t, e, i) : void 0;
                void 0 === u && (u = o), Fn(t, a, u);
              }
            }, wu);
          }

          function Mr(t, e) {
            var n = t.length;
            if (n) return ao(e += e < 0 ? n : 0, n) ? t[e] : void 0;
          }

          function Tr(t, e, n) {
            e = e.length ? de(e, function (t) {
              return Ia(t) ? function (e) {
                return lr(e, 1 === t.length ? t[0] : t);
              } : t;
            }) : [Gu];
            var r = -1;
            return e = de(e, je(Zi())), function (t, e) {
              var n = t.length;

              for (t.sort(e); n--;) {
                t[n] = t[n].value;
              }

              return t;
            }(Or(t, function (t, n, i) {
              return {
                criteria: de(e, function (e) {
                  return e(t);
                }),
                index: ++r,
                value: t
              };
            }), function (t, e) {
              return function (t, e, n) {
                var r = -1,
                    i = t.criteria,
                    o = e.criteria,
                    a = i.length,
                    u = n.length;

                for (; ++r < a;) {
                  var c = pi(i[r], o[r]);

                  if (c) {
                    if (r >= u) return c;
                    var s = n[r];
                    return c * ("desc" == s ? -1 : 1);
                  }
                }

                return t.index - e.index;
              }(t, e, n);
            });
          }

          function Ir(t, e, n) {
            for (var r = -1, i = e.length, o = {}; ++r < i;) {
              var a = e[r],
                  u = lr(t, a);
              n(u, a) && Wr(o, ui(a, t), u);
            }

            return o;
          }

          function Dr(t, e, n, r) {
            var i = r ? xe : we,
                o = -1,
                a = e.length,
                u = t;

            for (t === e && (e = yi(e)), n && (u = de(t, je(n))); ++o < a;) {
              for (var c = 0, s = e[o], f = n ? n(s) : s; (c = i(u, f, c, r)) > -1;) {
                u !== t && Xt.call(u, c, 1), Xt.call(t, c, 1);
              }
            }

            return t;
          }

          function Pr(t, e) {
            for (var n = t ? e.length : 0, r = n - 1; n--;) {
              var i = e[n];

              if (n == r || i !== o) {
                var o = i;
                ao(i) ? Xt.call(t, i, 1) : Jr(t, i);
              }
            }

            return t;
          }

          function Lr(t, e) {
            return t + Je(fn() * (e - t + 1));
          }

          function Ur(t, e) {
            var n = "";
            if (!t || e < 1 || e > 9007199254740991) return n;

            do {
              e % 2 && (n += t), (e = Je(e / 2)) && (t += t);
            } while (e);

            return n;
          }

          function zr(t, e) {
            return wo(vo(t, e, Gu), t + "");
          }

          function Br(t) {
            return Bn(Cu(t));
          }

          function Nr(t, e) {
            var n = Cu(t);
            return Ao(n, Xn(e, 0, n.length));
          }

          function Wr(t, e, n, r) {
            if (!qa(t)) return t;

            for (var i = -1, o = (e = ui(e, t)).length, a = o - 1, u = t; null != u && ++i < o;) {
              var c = So(e[i]),
                  s = n;
              if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;

              if (i != a) {
                var f = u[c];
                void 0 === (s = r ? r(f, c, u) : void 0) && (s = qa(f) ? f : ao(e[i + 1]) ? [] : {});
              }

              qn(u, c, s), u = u[c];
            }

            return t;
          }

          var Fr = _n ? function (t, e) {
            return _n.set(t, e), t;
          } : Gu,
              qr = Se ? function (t, e) {
            return Se(t, "toString", {
              configurable: !0,
              enumerable: !1,
              value: qu(e),
              writable: !0
            });
          } : Gu;

          function Vr(t) {
            return Ao(Cu(t));
          }

          function Yr(t, e, n) {
            var i = -1,
                o = t.length;
            e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

            for (var a = r(o); ++i < o;) {
              a[i] = t[i + e];
            }

            return a;
          }

          function Gr(t, e) {
            var n;
            return tr(t, function (t, r, i) {
              return !(n = e(t, r, i));
            }), !!n;
          }

          function Hr(t, e, n) {
            var r = 0,
                i = null == t ? r : t.length;

            if ("number" == typeof e && e == e && i <= 2147483647) {
              for (; r < i;) {
                var o = r + i >>> 1,
                    a = t[o];
                null !== a && !Qa(a) && (n ? a <= e : a < e) ? r = o + 1 : i = o;
              }

              return i;
            }

            return $r(t, e, Gu, n);
          }

          function $r(t, e, n, r) {
            var i = 0,
                o = null == t ? 0 : t.length;
            if (0 === o) return 0;

            for (var a = (e = n(e)) != e, u = null === e, c = Qa(e), s = void 0 === e; i < o;) {
              var f = Je((i + o) / 2),
                  l = n(t[f]),
                  h = void 0 !== l,
                  d = null === l,
                  p = l == l,
                  v = Qa(l);
              if (a) var g = r || p;else g = s ? p && (r || h) : u ? p && h && (r || !d) : c ? p && h && !d && (r || !v) : !d && !v && (r ? l <= e : l < e);
              g ? i = f + 1 : o = f;
            }

            return un(o, 4294967294);
          }

          function Xr(t, e) {
            for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
              var a = t[n],
                  u = e ? e(a) : a;

              if (!n || !Ca(u, c)) {
                var c = u;
                o[i++] = 0 === a ? 0 : a;
              }
            }

            return o;
          }

          function Zr(t) {
            return "number" == typeof t ? t : Qa(t) ? NaN : +t;
          }

          function Qr(t) {
            if ("string" == typeof t) return t;
            if (Ia(t)) return de(t, Qr) + "";
            if (Qa(t)) return On ? On.call(t) : "";
            var e = t + "";
            return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
          }

          function Kr(t, e, n) {
            var r = -1,
                i = le,
                o = t.length,
                a = !0,
                u = [],
                c = u;
            if (n) a = !1, i = he;else if (o >= 200) {
              var s = e ? null : Ui(t);
              if (s) return qe(s);
              a = !1, i = Te, c = new Ln();
            } else c = e ? [] : u;

            t: for (; ++r < o;) {
              var f = t[r],
                  l = e ? e(f) : f;

              if (f = n || 0 !== f ? f : 0, a && l == l) {
                for (var h = c.length; h--;) {
                  if (c[h] === l) continue t;
                }

                e && c.push(l), u.push(f);
              } else i(c, l, n) || (c !== u && c.push(l), u.push(f));
            }

            return u;
          }

          function Jr(t, e) {
            return null == (t = go(t, e = ui(e, t))) || delete t[So(Bo(e))];
          }

          function ti(t, e, n, r) {
            return Wr(t, e, n(lr(t, e)), r);
          }

          function ei(t, e, n, r) {
            for (var i = t.length, o = r ? i : -1; (r ? o-- : ++o < i) && e(t[o], o, t);) {
              ;
            }

            return n ? Yr(t, r ? 0 : o, r ? o + 1 : i) : Yr(t, r ? o + 1 : 0, r ? i : o);
          }

          function ni(t, e) {
            var n = t;
            return n instanceof Tn && (n = n.value()), ve(e, function (t, e) {
              return e.func.apply(e.thisArg, pe([t], e.args));
            }, n);
          }

          function ri(t, e, n) {
            var i = t.length;
            if (i < 2) return i ? Kr(t[0]) : [];

            for (var o = -1, a = r(i); ++o < i;) {
              for (var u = t[o], c = -1; ++c < i;) {
                c != o && (a[o] = Jn(a[o] || u, t[c], e, n));
              }
            }

            return Kr(or(a, 1), e, n);
          }

          function ii(t, e, n) {
            for (var r = -1, i = t.length, o = e.length, a = {}; ++r < i;) {
              var u = r < o ? e[r] : void 0;
              n(a, t[r], u);
            }

            return a;
          }

          function oi(t) {
            return La(t) ? t : [];
          }

          function ai(t) {
            return "function" == typeof t ? t : Gu;
          }

          function ui(t, e) {
            return Ia(t) ? t : co(t, e) ? [t] : Ro(uu(t));
          }

          var ci = zr;

          function si(t, e, n) {
            var r = t.length;
            return n = void 0 === n ? r : n, !e && n >= r ? t : Yr(t, e, n);
          }

          var fi = Xe || function (t) {
            return Ht.clearTimeout(t);
          };

          function li(t, e) {
            if (e) return t.slice();
            var n = t.length,
                r = Ft ? Ft(n) : new t.constructor(n);
            return t.copy(r), r;
          }

          function hi(t) {
            var e = new t.constructor(t.byteLength);
            return new Lt(e).set(new Lt(t)), e;
          }

          function di(t, e) {
            var n = e ? hi(t.buffer) : t.buffer;
            return new t.constructor(n, t.byteOffset, t.length);
          }

          function pi(t, e) {
            if (t !== e) {
              var n = void 0 !== t,
                  r = null === t,
                  i = t == t,
                  o = Qa(t),
                  a = void 0 !== e,
                  u = null === e,
                  c = e == e,
                  s = Qa(e);
              if (!u && !s && !o && t > e || o && a && c && !u && !s || r && a && c || !n && c || !i) return 1;
              if (!r && !o && !s && t < e || s && n && i && !r && !o || u && n && i || !a && i || !c) return -1;
            }

            return 0;
          }

          function vi(t, e, n, i) {
            for (var o = -1, a = t.length, u = n.length, c = -1, s = e.length, f = an(a - u, 0), l = r(s + f), h = !i; ++c < s;) {
              l[c] = e[c];
            }

            for (; ++o < u;) {
              (h || o < a) && (l[n[o]] = t[o]);
            }

            for (; f--;) {
              l[c++] = t[o++];
            }

            return l;
          }

          function gi(t, e, n, i) {
            for (var o = -1, a = t.length, u = -1, c = n.length, s = -1, f = e.length, l = an(a - c, 0), h = r(l + f), d = !i; ++o < l;) {
              h[o] = t[o];
            }

            for (var p = o; ++s < f;) {
              h[p + s] = e[s];
            }

            for (; ++u < c;) {
              (d || o < a) && (h[p + n[u]] = t[o++]);
            }

            return h;
          }

          function yi(t, e) {
            var n = -1,
                i = t.length;

            for (e || (e = r(i)); ++n < i;) {
              e[n] = t[n];
            }

            return e;
          }

          function _i(t, e, n, r) {
            var i = !n;
            n || (n = {});

            for (var o = -1, a = e.length; ++o < a;) {
              var u = e[o],
                  c = r ? r(n[u], t[u], u, n, t) : void 0;
              void 0 === c && (c = t[u]), i ? Hn(n, u, c) : qn(n, u, c);
            }

            return n;
          }

          function mi(t, e) {
            return function (n, r) {
              var i = Ia(n) ? ae : Yn,
                  o = e ? e() : {};
              return i(n, t, Zi(r, 2), o);
            };
          }

          function bi(t) {
            return zr(function (e, n) {
              var r = -1,
                  i = n.length,
                  o = i > 1 ? n[i - 1] : void 0,
                  a = i > 2 ? n[2] : void 0;

              for (o = t.length > 3 && "function" == typeof o ? (i--, o) : void 0, a && uo(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), e = vt(e); ++r < i;) {
                var u = n[r];
                u && t(e, u, r, o);
              }

              return e;
            });
          }

          function wi(t, e) {
            return function (n, r) {
              if (null == n) return n;
              if (!Pa(n)) return t(n, r);

              for (var i = n.length, o = e ? i : -1, a = vt(n); (e ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
                ;
              }

              return n;
            };
          }

          function xi(t) {
            return function (e, n, r) {
              for (var i = -1, o = vt(e), a = r(e), u = a.length; u--;) {
                var c = a[t ? u : ++i];
                if (!1 === n(o[c], c, o)) break;
              }

              return e;
            };
          }

          function Ei(t) {
            return function (e) {
              var n = Be(e = uu(e)) ? Ge(e) : void 0,
                  r = n ? n[0] : e.charAt(0),
                  i = n ? si(n, 1).join("") : e.slice(1);
              return r[t]() + i;
            };
          }

          function Ai(t) {
            return function (e) {
              return ve(Nu(Tu(e).replace(Tt, "")), t, "");
            };
          }

          function Ri(t) {
            return function () {
              var e = arguments;

              switch (e.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(e[0]);

                case 2:
                  return new t(e[0], e[1]);

                case 3:
                  return new t(e[0], e[1], e[2]);

                case 4:
                  return new t(e[0], e[1], e[2], e[3]);

                case 5:
                  return new t(e[0], e[1], e[2], e[3], e[4]);

                case 6:
                  return new t(e[0], e[1], e[2], e[3], e[4], e[5]);

                case 7:
                  return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
              }

              var n = Cn(t.prototype),
                  r = t.apply(n, e);
              return qa(r) ? r : n;
            };
          }

          function Si(t) {
            return function (e, n, r) {
              var i = vt(e);

              if (!Pa(e)) {
                var o = Zi(n, 3);
                e = bu(e), n = function n(t) {
                  return o(i[t], t, i);
                };
              }

              var a = t(e, n, r);
              return a > -1 ? i[o ? e[a] : a] : void 0;
            };
          }

          function Oi(t) {
            return Vi(function (e) {
              var n = e.length,
                  r = n,
                  i = Mn.prototype.thru;

              for (t && e.reverse(); r--;) {
                var a = e[r];
                if ("function" != typeof a) throw new _t(o);
                if (i && !u && "wrapper" == $i(a)) var u = new Mn([], !0);
              }

              for (r = u ? r : n; ++r < n;) {
                var c = $i(a = e[r]),
                    s = "wrapper" == c ? Hi(a) : void 0;
                u = s && so(s[0]) && 424 == s[1] && !s[4].length && 1 == s[9] ? u[$i(s[0])].apply(u, s[3]) : 1 == a.length && so(a) ? u[c]() : u.thru(a);
              }

              return function () {
                var t = arguments,
                    r = t[0];
                if (u && 1 == t.length && Ia(r)) return u.plant(r).value();

                for (var i = 0, o = n ? e[i].apply(this, t) : r; ++i < n;) {
                  o = e[i].call(this, o);
                }

                return o;
              };
            });
          }

          function ki(t, e, n, i, o, a, u, c, s, f) {
            var l = 128 & e,
                h = 1 & e,
                d = 2 & e,
                p = 24 & e,
                v = 512 & e,
                g = d ? void 0 : Ri(t);
            return function y() {
              for (var _ = arguments.length, m = r(_), b = _; b--;) {
                m[b] = arguments[b];
              }

              if (p) var w = Xi(y),
                  x = Pe(m, w);

              if (i && (m = vi(m, i, o, p)), a && (m = gi(m, a, u, p)), _ -= x, p && _ < f) {
                var E = Fe(m, w);
                return Pi(t, e, ki, y.placeholder, n, m, E, c, s, f - _);
              }

              var A = h ? n : this,
                  R = d ? A[t] : t;
              return _ = m.length, c ? m = yo(m, c) : v && _ > 1 && m.reverse(), l && s < _ && (m.length = s), this && this !== Ht && this instanceof y && (R = g || Ri(R)), R.apply(A, m);
            };
          }

          function Ci(t, e) {
            return function (n, r) {
              return function (t, e, n, r) {
                return cr(t, function (t, i, o) {
                  e(r, n(t), i, o);
                }), r;
              }(n, t, e(r), {});
            };
          }

          function ji(t, e) {
            return function (n, r) {
              var i;
              if (void 0 === n && void 0 === r) return e;

              if (void 0 !== n && (i = n), void 0 !== r) {
                if (void 0 === i) return r;
                "string" == typeof n || "string" == typeof r ? (n = Qr(n), r = Qr(r)) : (n = Zr(n), r = Zr(r)), i = t(n, r);
              }

              return i;
            };
          }

          function Mi(t) {
            return Vi(function (e) {
              return e = de(e, je(Zi())), zr(function (n) {
                var r = this;
                return t(e, function (t) {
                  return oe(t, r, n);
                });
              });
            });
          }

          function Ti(t, e) {
            var n = (e = void 0 === e ? " " : Qr(e)).length;
            if (n < 2) return n ? Ur(e, t) : e;
            var r = Ur(e, Ke(t / Ye(e)));
            return Be(e) ? si(Ge(r), 0, t).join("") : r.slice(0, t);
          }

          function Ii(t) {
            return function (e, n, i) {
              return i && "number" != typeof i && uo(e, n, i) && (n = i = void 0), e = nu(e), void 0 === n ? (n = e, e = 0) : n = nu(n), function (t, e, n, i) {
                for (var o = -1, a = an(Ke((e - t) / (n || 1)), 0), u = r(a); a--;) {
                  u[i ? a : ++o] = t, t += n;
                }

                return u;
              }(e, n, i = void 0 === i ? e < n ? 1 : -1 : nu(i), t);
            };
          }

          function Di(t) {
            return function (e, n) {
              return "string" == typeof e && "string" == typeof n || (e = ou(e), n = ou(n)), t(e, n);
            };
          }

          function Pi(t, e, n, r, i, o, a, u, c, s) {
            var f = 8 & e;
            e |= f ? 32 : 64, 4 & (e &= ~(f ? 64 : 32)) || (e &= -4);
            var l = [t, e, i, f ? o : void 0, f ? a : void 0, f ? void 0 : o, f ? void 0 : a, u, c, s],
                h = n.apply(void 0, l);
            return so(t) && mo(h, l), h.placeholder = r, xo(h, t, e);
          }

          function Li(t) {
            var e = pt[t];
            return function (t, n) {
              if (t = ou(t), (n = null == n ? 0 : un(ru(n), 292)) && nn(t)) {
                var r = (uu(t) + "e").split("e");
                return +((r = (uu(e(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
              }

              return e(t);
            };
          }

          var Ui = vn && 1 / qe(new vn([, -0]))[1] == 1 / 0 ? function (t) {
            return new vn(t);
          } : Qu;

          function zi(t) {
            return function (e) {
              var n = no(e);
              return n == v ? Ne(e) : n == m ? Ve(e) : function (t, e) {
                return de(e, function (e) {
                  return [e, t[e]];
                });
              }(e, t(e));
            };
          }

          function Bi(t, e, n, i, u, c, s, f) {
            var l = 2 & e;
            if (!l && "function" != typeof t) throw new _t(o);
            var h = i ? i.length : 0;

            if (h || (e &= -97, i = u = void 0), s = void 0 === s ? s : an(ru(s), 0), f = void 0 === f ? f : ru(f), h -= u ? u.length : 0, 64 & e) {
              var d = i,
                  p = u;
              i = u = void 0;
            }

            var v = l ? void 0 : Hi(t),
                g = [t, e, n, i, u, d, p, c, s, f];
            if (v && function (t, e) {
              var n = t[1],
                  r = e[1],
                  i = n | r,
                  o = i < 131,
                  u = 128 == r && 8 == n || 128 == r && 256 == n && t[7].length <= e[8] || 384 == r && e[7].length <= e[8] && 8 == n;
              if (!o && !u) return t;
              1 & r && (t[2] = e[2], i |= 1 & n ? 0 : 4);
              var c = e[3];

              if (c) {
                var s = t[3];
                t[3] = s ? vi(s, c, e[4]) : c, t[4] = s ? Fe(t[3], a) : e[4];
              }

              (c = e[5]) && (s = t[5], t[5] = s ? gi(s, c, e[6]) : c, t[6] = s ? Fe(t[5], a) : e[6]);
              (c = e[7]) && (t[7] = c);
              128 & r && (t[8] = null == t[8] ? e[8] : un(t[8], e[8]));
              null == t[9] && (t[9] = e[9]);
              t[0] = e[0], t[1] = i;
            }(g, v), t = g[0], e = g[1], n = g[2], i = g[3], u = g[4], !(f = g[9] = void 0 === g[9] ? l ? 0 : t.length : an(g[9] - h, 0)) && 24 & e && (e &= -25), e && 1 != e) y = 8 == e || 16 == e ? function (t, e, n) {
              var i = Ri(t);
              return function o() {
                for (var a = arguments.length, u = r(a), c = a, s = Xi(o); c--;) {
                  u[c] = arguments[c];
                }

                var f = a < 3 && u[0] !== s && u[a - 1] !== s ? [] : Fe(u, s);
                if ((a -= f.length) < n) return Pi(t, e, ki, o.placeholder, void 0, u, f, void 0, void 0, n - a);
                var l = this && this !== Ht && this instanceof o ? i : t;
                return oe(l, this, u);
              };
            }(t, e, f) : 32 != e && 33 != e || u.length ? ki.apply(void 0, g) : function (t, e, n, i) {
              var o = 1 & e,
                  a = Ri(t);
              return function e() {
                for (var u = -1, c = arguments.length, s = -1, f = i.length, l = r(f + c), h = this && this !== Ht && this instanceof e ? a : t; ++s < f;) {
                  l[s] = i[s];
                }

                for (; c--;) {
                  l[s++] = arguments[++u];
                }

                return oe(h, o ? n : this, l);
              };
            }(t, e, n, i);else var y = function (t, e, n) {
              var r = 1 & e,
                  i = Ri(t);
              return function e() {
                var o = this && this !== Ht && this instanceof e ? i : t;
                return o.apply(r ? n : this, arguments);
              };
            }(t, e, n);
            return xo((v ? Fr : mo)(y, g), t, e);
          }

          function Ni(t, e, n, r) {
            return void 0 === t || Ca(t, wt[n]) && !At.call(r, n) ? e : t;
          }

          function Wi(t, e, n, r, i, o) {
            return qa(t) && qa(e) && (o.set(e, t), jr(t, e, void 0, Wi, o), o.delete(e)), t;
          }

          function Fi(t) {
            return Ha(t) ? void 0 : t;
          }

          function qi(t, e, n, r, i, o) {
            var a = 1 & n,
                u = t.length,
                c = e.length;
            if (u != c && !(a && c > u)) return !1;
            var s = o.get(t),
                f = o.get(e);
            if (s && f) return s == e && f == t;
            var l = -1,
                h = !0,
                d = 2 & n ? new Ln() : void 0;

            for (o.set(t, e), o.set(e, t); ++l < u;) {
              var p = t[l],
                  v = e[l];
              if (r) var g = a ? r(v, p, l, e, t, o) : r(p, v, l, t, e, o);

              if (void 0 !== g) {
                if (g) continue;
                h = !1;
                break;
              }

              if (d) {
                if (!ye(e, function (t, e) {
                  if (!Te(d, e) && (p === t || i(p, t, n, r, o))) return d.push(e);
                })) {
                  h = !1;
                  break;
                }
              } else if (p !== v && !i(p, v, n, r, o)) {
                h = !1;
                break;
              }
            }

            return o.delete(t), o.delete(e), h;
          }

          function Vi(t) {
            return wo(vo(t, void 0, Do), t + "");
          }

          function Yi(t) {
            return hr(t, bu, to);
          }

          function Gi(t) {
            return hr(t, wu, eo);
          }

          var Hi = _n ? function (t) {
            return _n.get(t);
          } : Qu;

          function $i(t) {
            for (var e = t.name + "", n = mn[e], r = At.call(mn, e) ? n.length : 0; r--;) {
              var i = n[r],
                  o = i.func;
              if (null == o || o == t) return i.name;
            }

            return e;
          }

          function Xi(t) {
            return (At.call(kn, "placeholder") ? kn : t).placeholder;
          }

          function Zi() {
            var t = kn.iteratee || Hu;
            return t = t === Hu ? Er : t, arguments.length ? t(arguments[0], arguments[1]) : t;
          }

          function Qi(t, e) {
            var n,
                r,
                i = t.__data__;
            return ("string" == (r = typeof (n = e)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof e ? "string" : "hash"] : i.map;
          }

          function Ki(t) {
            for (var e = bu(t), n = e.length; n--;) {
              var r = e[n],
                  i = t[r];
              e[n] = [r, i, ho(i)];
            }

            return e;
          }

          function Ji(t, e) {
            var n = function (t, e) {
              return null == t ? void 0 : t[e];
            }(t, e);

            return xr(n) ? n : void 0;
          }

          var to = tn ? function (t) {
            return null == t ? [] : (t = vt(t), fe(tn(t), function (e) {
              return $t.call(t, e);
            }));
          } : ic,
              eo = tn ? function (t) {
            for (var e = []; t;) {
              pe(e, to(t)), t = Yt(t);
            }

            return e;
          } : ic,
              no = dr;

          function ro(t, e, n) {
            for (var r = -1, i = (e = ui(e, t)).length, o = !1; ++r < i;) {
              var a = So(e[r]);
              if (!(o = null != t && n(t, a))) break;
              t = t[a];
            }

            return o || ++r != i ? o : !!(i = null == t ? 0 : t.length) && Fa(i) && ao(a, i) && (Ia(t) || Ta(t));
          }

          function io(t) {
            return "function" != typeof t.constructor || lo(t) ? {} : Cn(Yt(t));
          }

          function oo(t) {
            return Ia(t) || Ta(t) || !!(Qt && t && t[Qt]);
          }

          function ao(t, e) {
            var n = typeof t;
            return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && ct.test(t)) && t > -1 && t % 1 == 0 && t < e;
          }

          function uo(t, e, n) {
            if (!qa(n)) return !1;
            var r = typeof e;
            return !!("number" == r ? Pa(n) && ao(e, n.length) : "string" == r && e in n) && Ca(n[e], t);
          }

          function co(t, e) {
            if (Ia(t)) return !1;
            var n = typeof t;
            return !("number" != n && "symbol" != n && "boolean" != n && null != t && !Qa(t)) || V.test(t) || !q.test(t) || null != e && t in vt(e);
          }

          function so(t) {
            var e = $i(t),
                n = kn[e];
            if ("function" != typeof n || !(e in Tn.prototype)) return !1;
            if (t === n) return !0;
            var r = Hi(n);
            return !!r && t === r[0];
          }

          (hn && no(new hn(new ArrayBuffer(1))) != A || dn && no(new dn()) != v || pn && "[object Promise]" != no(pn.resolve()) || vn && no(new vn()) != m || gn && no(new gn()) != x) && (no = function no(t) {
            var e = dr(t),
                n = e == y ? t.constructor : void 0,
                r = n ? Oo(n) : "";
            if (r) switch (r) {
              case bn:
                return A;

              case wn:
                return v;

              case xn:
                return "[object Promise]";

              case En:
                return m;

              case An:
                return x;
            }
            return e;
          });
          var fo = xt ? Na : oc;

          function lo(t) {
            var e = t && t.constructor;
            return t === ("function" == typeof e && e.prototype || wt);
          }

          function ho(t) {
            return t == t && !qa(t);
          }

          function po(t, e) {
            return function (n) {
              return null != n && n[t] === e && (void 0 !== e || t in vt(n));
            };
          }

          function vo(t, e, n) {
            return e = an(void 0 === e ? t.length - 1 : e, 0), function () {
              for (var i = arguments, o = -1, a = an(i.length - e, 0), u = r(a); ++o < a;) {
                u[o] = i[e + o];
              }

              o = -1;

              for (var c = r(e + 1); ++o < e;) {
                c[o] = i[o];
              }

              return c[e] = n(u), oe(t, this, c);
            };
          }

          function go(t, e) {
            return e.length < 2 ? t : lr(t, Yr(e, 0, -1));
          }

          function yo(t, e) {
            for (var n = t.length, r = un(e.length, n), i = yi(t); r--;) {
              var o = e[r];
              t[r] = ao(o, n) ? i[o] : void 0;
            }

            return t;
          }

          function _o(t, e) {
            if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
          }

          var mo = Eo(Fr),
              bo = Qe || function (t, e) {
            return Ht.setTimeout(t, e);
          },
              wo = Eo(qr);

          function xo(t, e, n) {
            var r = e + "";
            return wo(t, function (t, e) {
              var n = e.length;
              if (!n) return t;
              var r = n - 1;
              return e[r] = (n > 1 ? "& " : "") + e[r], e = e.join(n > 2 ? ", " : " "), t.replace(Q, "{\n/* [wrapped with " + e + "] */\n");
            }(r, function (t, e) {
              return ue(u, function (n) {
                var r = "_." + n[0];
                e & n[1] && !le(t, r) && t.push(r);
              }), t.sort();
            }(function (t) {
              var e = t.match(K);
              return e ? e[1].split(J) : [];
            }(r), n)));
          }

          function Eo(t) {
            var e = 0,
                n = 0;
            return function () {
              var r = cn(),
                  i = 16 - (r - n);

              if (n = r, i > 0) {
                if (++e >= 800) return arguments[0];
              } else e = 0;

              return t.apply(void 0, arguments);
            };
          }

          function Ao(t, e) {
            var n = -1,
                r = t.length,
                i = r - 1;

            for (e = void 0 === e ? r : e; ++n < e;) {
              var o = Lr(n, i),
                  a = t[o];
              t[o] = t[n], t[n] = a;
            }

            return t.length = e, t;
          }

          var Ro = function (t) {
            var e = Ea(t, function (t) {
              return 500 === n.size && n.clear(), t;
            }),
                n = e.cache;
            return e;
          }(function (t) {
            var e = [];
            return 46 === t.charCodeAt(0) && e.push(""), t.replace(Y, function (t, n, r, i) {
              e.push(r ? i.replace(et, "$1") : n || t);
            }), e;
          });

          function So(t) {
            if ("string" == typeof t || Qa(t)) return t;
            var e = t + "";
            return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
          }

          function Oo(t) {
            if (null != t) {
              try {
                return Et.call(t);
              } catch (t) {}

              try {
                return t + "";
              } catch (t) {}
            }

            return "";
          }

          function ko(t) {
            if (t instanceof Tn) return t.clone();
            var e = new Mn(t.__wrapped__, t.__chain__);
            return e.__actions__ = yi(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
          }

          var Co = zr(function (t, e) {
            return La(t) ? Jn(t, or(e, 1, La, !0)) : [];
          }),
              jo = zr(function (t, e) {
            var n = Bo(e);
            return La(n) && (n = void 0), La(t) ? Jn(t, or(e, 1, La, !0), Zi(n, 2)) : [];
          }),
              Mo = zr(function (t, e) {
            var n = Bo(e);
            return La(n) && (n = void 0), La(t) ? Jn(t, or(e, 1, La, !0), void 0, n) : [];
          });

          function To(t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = null == n ? 0 : ru(n);
            return i < 0 && (i = an(r + i, 0)), be(t, Zi(e, 3), i);
          }

          function Io(t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = r - 1;
            return void 0 !== n && (i = ru(n), i = n < 0 ? an(r + i, 0) : un(i, r - 1)), be(t, Zi(e, 3), i, !0);
          }

          function Do(t) {
            return (null == t ? 0 : t.length) ? or(t, 1) : [];
          }

          function Po(t) {
            return t && t.length ? t[0] : void 0;
          }

          var Lo = zr(function (t) {
            var e = de(t, oi);
            return e.length && e[0] === t[0] ? yr(e) : [];
          }),
              Uo = zr(function (t) {
            var e = Bo(t),
                n = de(t, oi);
            return e === Bo(n) ? e = void 0 : n.pop(), n.length && n[0] === t[0] ? yr(n, Zi(e, 2)) : [];
          }),
              zo = zr(function (t) {
            var e = Bo(t),
                n = de(t, oi);
            return (e = "function" == typeof e ? e : void 0) && n.pop(), n.length && n[0] === t[0] ? yr(n, void 0, e) : [];
          });

          function Bo(t) {
            var e = null == t ? 0 : t.length;
            return e ? t[e - 1] : void 0;
          }

          var No = zr(Wo);

          function Wo(t, e) {
            return t && t.length && e && e.length ? Dr(t, e) : t;
          }

          var Fo = Vi(function (t, e) {
            var n = null == t ? 0 : t.length,
                r = $n(t, e);
            return Pr(t, de(e, function (t) {
              return ao(t, n) ? +t : t;
            }).sort(pi)), r;
          });

          function qo(t) {
            return null == t ? t : ln.call(t);
          }

          var Vo = zr(function (t) {
            return Kr(or(t, 1, La, !0));
          }),
              Yo = zr(function (t) {
            var e = Bo(t);
            return La(e) && (e = void 0), Kr(or(t, 1, La, !0), Zi(e, 2));
          }),
              Go = zr(function (t) {
            var e = Bo(t);
            return e = "function" == typeof e ? e : void 0, Kr(or(t, 1, La, !0), void 0, e);
          });

          function Ho(t) {
            if (!t || !t.length) return [];
            var e = 0;
            return t = fe(t, function (t) {
              if (La(t)) return e = an(t.length, e), !0;
            }), Ce(e, function (e) {
              return de(t, Re(e));
            });
          }

          function $o(t, e) {
            if (!t || !t.length) return [];
            var n = Ho(t);
            return null == e ? n : de(n, function (t) {
              return oe(e, void 0, t);
            });
          }

          var Xo = zr(function (t, e) {
            return La(t) ? Jn(t, e) : [];
          }),
              Zo = zr(function (t) {
            return ri(fe(t, La));
          }),
              Qo = zr(function (t) {
            var e = Bo(t);
            return La(e) && (e = void 0), ri(fe(t, La), Zi(e, 2));
          }),
              Ko = zr(function (t) {
            var e = Bo(t);
            return e = "function" == typeof e ? e : void 0, ri(fe(t, La), void 0, e);
          }),
              Jo = zr(Ho);
          var ta = zr(function (t) {
            var e = t.length,
                n = e > 1 ? t[e - 1] : void 0;
            return n = "function" == typeof n ? (t.pop(), n) : void 0, $o(t, n);
          });

          function ea(t) {
            var e = kn(t);
            return e.__chain__ = !0, e;
          }

          function na(t, e) {
            return e(t);
          }

          var ra = Vi(function (t) {
            var e = t.length,
                n = e ? t[0] : 0,
                r = this.__wrapped__,
                i = function i(e) {
              return $n(e, t);
            };

            return !(e > 1 || this.__actions__.length) && r instanceof Tn && ao(n) ? ((r = r.slice(n, +n + (e ? 1 : 0))).__actions__.push({
              func: na,
              args: [i],
              thisArg: void 0
            }), new Mn(r, this.__chain__).thru(function (t) {
              return e && !t.length && t.push(void 0), t;
            })) : this.thru(i);
          });
          var ia = mi(function (t, e, n) {
            At.call(t, n) ? ++t[n] : Hn(t, n, 1);
          });
          var oa = Si(To),
              aa = Si(Io);

          function ua(t, e) {
            return (Ia(t) ? ue : tr)(t, Zi(e, 3));
          }

          function ca(t, e) {
            return (Ia(t) ? ce : er)(t, Zi(e, 3));
          }

          var sa = mi(function (t, e, n) {
            At.call(t, n) ? t[n].push(e) : Hn(t, n, [e]);
          });
          var fa = zr(function (t, e, n) {
            var i = -1,
                o = "function" == typeof e,
                a = Pa(t) ? r(t.length) : [];
            return tr(t, function (t) {
              a[++i] = o ? oe(e, t, n) : _r(t, e, n);
            }), a;
          }),
              la = mi(function (t, e, n) {
            Hn(t, n, e);
          });

          function ha(t, e) {
            return (Ia(t) ? de : Or)(t, Zi(e, 3));
          }

          var da = mi(function (t, e, n) {
            t[n ? 0 : 1].push(e);
          }, function () {
            return [[], []];
          });

          var pa = zr(function (t, e) {
            if (null == t) return [];
            var n = e.length;
            return n > 1 && uo(t, e[0], e[1]) ? e = [] : n > 2 && uo(e[0], e[1], e[2]) && (e = [e[0]]), Tr(t, or(e, 1), []);
          }),
              va = Ze || function () {
            return Ht.Date.now();
          };

          function ga(t, e, n) {
            return e = n ? void 0 : e, Bi(t, 128, void 0, void 0, void 0, void 0, e = t && null == e ? t.length : e);
          }

          function ya(t, e) {
            var n;
            if ("function" != typeof e) throw new _t(o);
            return t = ru(t), function () {
              return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = void 0), n;
            };
          }

          var _a = zr(function (t, e, n) {
            var r = 1;

            if (n.length) {
              var i = Fe(n, Xi(_a));
              r |= 32;
            }

            return Bi(t, r, e, n, i);
          }),
              ma = zr(function (t, e, n) {
            var r = 3;

            if (n.length) {
              var i = Fe(n, Xi(ma));
              r |= 32;
            }

            return Bi(e, r, t, n, i);
          });

          function ba(t, e, n) {
            var r,
                i,
                a,
                u,
                c,
                s,
                f = 0,
                l = !1,
                h = !1,
                d = !0;
            if ("function" != typeof t) throw new _t(o);

            function p(e) {
              var n = r,
                  o = i;
              return r = i = void 0, f = e, u = t.apply(o, n);
            }

            function v(t) {
              return f = t, c = bo(y, e), l ? p(t) : u;
            }

            function g(t) {
              var n = t - s;
              return void 0 === s || n >= e || n < 0 || h && t - f >= a;
            }

            function y() {
              var t = va();
              if (g(t)) return _(t);
              c = bo(y, function (t) {
                var n = e - (t - s);
                return h ? un(n, a - (t - f)) : n;
              }(t));
            }

            function _(t) {
              return c = void 0, d && r ? p(t) : (r = i = void 0, u);
            }

            function m() {
              var t = va(),
                  n = g(t);

              if (r = arguments, i = this, s = t, n) {
                if (void 0 === c) return v(s);
                if (h) return fi(c), c = bo(y, e), p(s);
              }

              return void 0 === c && (c = bo(y, e)), u;
            }

            return e = ou(e) || 0, qa(n) && (l = !!n.leading, a = (h = "maxWait" in n) ? an(ou(n.maxWait) || 0, e) : a, d = "trailing" in n ? !!n.trailing : d), m.cancel = function () {
              void 0 !== c && fi(c), f = 0, r = s = i = c = void 0;
            }, m.flush = function () {
              return void 0 === c ? u : _(va());
            }, m;
          }

          var wa = zr(function (t, e) {
            return Kn(t, 1, e);
          }),
              xa = zr(function (t, e, n) {
            return Kn(t, ou(e) || 0, n);
          });

          function Ea(t, e) {
            if ("function" != typeof t || null != e && "function" != typeof e) throw new _t(o);

            var n = function n() {
              var r = arguments,
                  i = e ? e.apply(this, r) : r[0],
                  o = n.cache;
              if (o.has(i)) return o.get(i);
              var a = t.apply(this, r);
              return n.cache = o.set(i, a) || o, a;
            };

            return n.cache = new (Ea.Cache || Pn)(), n;
          }

          function Aa(t) {
            if ("function" != typeof t) throw new _t(o);
            return function () {
              var e = arguments;

              switch (e.length) {
                case 0:
                  return !t.call(this);

                case 1:
                  return !t.call(this, e[0]);

                case 2:
                  return !t.call(this, e[0], e[1]);

                case 3:
                  return !t.call(this, e[0], e[1], e[2]);
              }

              return !t.apply(this, e);
            };
          }

          Ea.Cache = Pn;
          var Ra = ci(function (t, e) {
            var n = (e = 1 == e.length && Ia(e[0]) ? de(e[0], je(Zi())) : de(or(e, 1), je(Zi()))).length;
            return zr(function (r) {
              for (var i = -1, o = un(r.length, n); ++i < o;) {
                r[i] = e[i].call(this, r[i]);
              }

              return oe(t, this, r);
            });
          }),
              Sa = zr(function (t, e) {
            return Bi(t, 32, void 0, e, Fe(e, Xi(Sa)));
          }),
              Oa = zr(function (t, e) {
            return Bi(t, 64, void 0, e, Fe(e, Xi(Oa)));
          }),
              ka = Vi(function (t, e) {
            return Bi(t, 256, void 0, void 0, void 0, e);
          });

          function Ca(t, e) {
            return t === e || t != t && e != e;
          }

          var ja = Di(pr),
              Ma = Di(function (t, e) {
            return t >= e;
          }),
              Ta = mr(function () {
            return arguments;
          }()) ? mr : function (t) {
            return Va(t) && At.call(t, "callee") && !$t.call(t, "callee");
          },
              Ia = r.isArray,
              Da = Jt ? je(Jt) : function (t) {
            return Va(t) && dr(t) == E;
          };

          function Pa(t) {
            return null != t && Fa(t.length) && !Na(t);
          }

          function La(t) {
            return Va(t) && Pa(t);
          }

          var Ua = en || oc,
              za = te ? je(te) : function (t) {
            return Va(t) && dr(t) == l;
          };

          function Ba(t) {
            if (!Va(t)) return !1;
            var e = dr(t);
            return e == h || "[object DOMException]" == e || "string" == typeof t.message && "string" == typeof t.name && !Ha(t);
          }

          function Na(t) {
            if (!qa(t)) return !1;
            var e = dr(t);
            return e == d || e == p || "[object AsyncFunction]" == e || "[object Proxy]" == e;
          }

          function Wa(t) {
            return "number" == typeof t && t == ru(t);
          }

          function Fa(t) {
            return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
          }

          function qa(t) {
            var e = typeof t;
            return null != t && ("object" == e || "function" == e);
          }

          function Va(t) {
            return null != t && "object" == typeof t;
          }

          var Ya = ee ? je(ee) : function (t) {
            return Va(t) && no(t) == v;
          };

          function Ga(t) {
            return "number" == typeof t || Va(t) && dr(t) == g;
          }

          function Ha(t) {
            if (!Va(t) || dr(t) != y) return !1;
            var e = Yt(t);
            if (null === e) return !0;
            var n = At.call(e, "constructor") && e.constructor;
            return "function" == typeof n && n instanceof n && Et.call(n) == kt;
          }

          var $a = ne ? je(ne) : function (t) {
            return Va(t) && dr(t) == _;
          };
          var Xa = re ? je(re) : function (t) {
            return Va(t) && no(t) == m;
          };

          function Za(t) {
            return "string" == typeof t || !Ia(t) && Va(t) && dr(t) == b;
          }

          function Qa(t) {
            return "symbol" == typeof t || Va(t) && dr(t) == w;
          }

          var Ka = ie ? je(ie) : function (t) {
            return Va(t) && Fa(t.length) && !!Nt[dr(t)];
          };
          var Ja = Di(Sr),
              tu = Di(function (t, e) {
            return t <= e;
          });

          function eu(t) {
            if (!t) return [];
            if (Pa(t)) return Za(t) ? Ge(t) : yi(t);
            if (Kt && t[Kt]) return function (t) {
              for (var e, n = []; !(e = t.next()).done;) {
                n.push(e.value);
              }

              return n;
            }(t[Kt]());
            var e = no(t);
            return (e == v ? Ne : e == m ? qe : Cu)(t);
          }

          function nu(t) {
            return t ? (t = ou(t)) === 1 / 0 || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
          }

          function ru(t) {
            var e = nu(t),
                n = e % 1;
            return e == e ? n ? e - n : e : 0;
          }

          function iu(t) {
            return t ? Xn(ru(t), 0, 4294967295) : 0;
          }

          function ou(t) {
            if ("number" == typeof t) return t;
            if (Qa(t)) return NaN;

            if (qa(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = qa(e) ? e + "" : e;
            }

            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace($, "");
            var n = ot.test(t);
            return n || ut.test(t) ? Vt(t.slice(2), n ? 2 : 8) : it.test(t) ? NaN : +t;
          }

          function au(t) {
            return _i(t, wu(t));
          }

          function uu(t) {
            return null == t ? "" : Qr(t);
          }

          var cu = bi(function (t, e) {
            if (lo(e) || Pa(e)) _i(e, bu(e), t);else for (var n in e) {
              At.call(e, n) && qn(t, n, e[n]);
            }
          }),
              su = bi(function (t, e) {
            _i(e, wu(e), t);
          }),
              fu = bi(function (t, e, n, r) {
            _i(e, wu(e), t, r);
          }),
              lu = bi(function (t, e, n, r) {
            _i(e, bu(e), t, r);
          }),
              hu = Vi($n);
          var du = zr(function (t, e) {
            t = vt(t);
            var n = -1,
                r = e.length,
                i = r > 2 ? e[2] : void 0;

            for (i && uo(e[0], e[1], i) && (r = 1); ++n < r;) {
              for (var o = e[n], a = wu(o), u = -1, c = a.length; ++u < c;) {
                var s = a[u],
                    f = t[s];
                (void 0 === f || Ca(f, wt[s]) && !At.call(t, s)) && (t[s] = o[s]);
              }
            }

            return t;
          }),
              pu = zr(function (t) {
            return t.push(void 0, Wi), oe(Eu, void 0, t);
          });

          function vu(t, e, n) {
            var r = null == t ? void 0 : lr(t, e);
            return void 0 === r ? n : r;
          }

          function gu(t, e) {
            return null != t && ro(t, e, gr);
          }

          var yu = Ci(function (t, e, n) {
            null != e && "function" != typeof e.toString && (e = Ot.call(e)), t[e] = n;
          }, qu(Gu)),
              _u = Ci(function (t, e, n) {
            null != e && "function" != typeof e.toString && (e = Ot.call(e)), At.call(t, e) ? t[e].push(n) : t[e] = [n];
          }, Zi),
              mu = zr(_r);

          function bu(t) {
            return Pa(t) ? zn(t) : Ar(t);
          }

          function wu(t) {
            return Pa(t) ? zn(t, !0) : Rr(t);
          }

          var xu = bi(function (t, e, n) {
            jr(t, e, n);
          }),
              Eu = bi(function (t, e, n, r) {
            jr(t, e, n, r);
          }),
              Au = Vi(function (t, e) {
            var n = {};
            if (null == t) return n;
            var r = !1;
            e = de(e, function (e) {
              return e = ui(e, t), r || (r = e.length > 1), e;
            }), _i(t, Gi(t), n), r && (n = Zn(n, 7, Fi));

            for (var i = e.length; i--;) {
              Jr(n, e[i]);
            }

            return n;
          });
          var Ru = Vi(function (t, e) {
            return null == t ? {} : function (t, e) {
              return Ir(t, e, function (e, n) {
                return gu(t, n);
              });
            }(t, e);
          });

          function Su(t, e) {
            if (null == t) return {};
            var n = de(Gi(t), function (t) {
              return [t];
            });
            return e = Zi(e), Ir(t, n, function (t, n) {
              return e(t, n[0]);
            });
          }

          var Ou = zi(bu),
              ku = zi(wu);

          function Cu(t) {
            return null == t ? [] : Me(t, bu(t));
          }

          var ju = Ai(function (t, e, n) {
            return e = e.toLowerCase(), t + (n ? Mu(e) : e);
          });

          function Mu(t) {
            return Bu(uu(t).toLowerCase());
          }

          function Tu(t) {
            return (t = uu(t)) && t.replace(st, Le).replace(It, "");
          }

          var Iu = Ai(function (t, e, n) {
            return t + (n ? "-" : "") + e.toLowerCase();
          }),
              Du = Ai(function (t, e, n) {
            return t + (n ? " " : "") + e.toLowerCase();
          }),
              Pu = Ei("toLowerCase");
          var Lu = Ai(function (t, e, n) {
            return t + (n ? "_" : "") + e.toLowerCase();
          });
          var Uu = Ai(function (t, e, n) {
            return t + (n ? " " : "") + Bu(e);
          });
          var zu = Ai(function (t, e, n) {
            return t + (n ? " " : "") + e.toUpperCase();
          }),
              Bu = Ei("toUpperCase");

          function Nu(t, e, n) {
            return t = uu(t), void 0 === (e = n ? void 0 : e) ? function (t) {
              return Ut.test(t);
            }(t) ? function (t) {
              return t.match(Pt) || [];
            }(t) : function (t) {
              return t.match(tt) || [];
            }(t) : t.match(e) || [];
          }

          var Wu = zr(function (t, e) {
            try {
              return oe(t, void 0, e);
            } catch (t) {
              return Ba(t) ? t : new ht(t);
            }
          }),
              Fu = Vi(function (t, e) {
            return ue(e, function (e) {
              e = So(e), Hn(t, e, _a(t[e], t));
            }), t;
          });

          function qu(t) {
            return function () {
              return t;
            };
          }

          var Vu = Oi(),
              Yu = Oi(!0);

          function Gu(t) {
            return t;
          }

          function Hu(t) {
            return Er("function" == typeof t ? t : Zn(t, 1));
          }

          var $u = zr(function (t, e) {
            return function (n) {
              return _r(n, t, e);
            };
          }),
              Xu = zr(function (t, e) {
            return function (n) {
              return _r(t, n, e);
            };
          });

          function Zu(t, e, n) {
            var r = bu(e),
                i = fr(e, r);
            null != n || qa(e) && (i.length || !r.length) || (n = e, e = t, t = this, i = fr(e, bu(e)));
            var o = !(qa(n) && "chain" in n && !n.chain),
                a = Na(t);
            return ue(i, function (n) {
              var r = e[n];
              t[n] = r, a && (t.prototype[n] = function () {
                var e = this.__chain__;

                if (o || e) {
                  var n = t(this.__wrapped__),
                      i = n.__actions__ = yi(this.__actions__);
                  return i.push({
                    func: r,
                    args: arguments,
                    thisArg: t
                  }), n.__chain__ = e, n;
                }

                return r.apply(t, pe([this.value()], arguments));
              });
            }), t;
          }

          function Qu() {}

          var Ku = Mi(de),
              Ju = Mi(se),
              tc = Mi(ye);

          function ec(t) {
            return co(t) ? Re(So(t)) : function (t) {
              return function (e) {
                return lr(e, t);
              };
            }(t);
          }

          var nc = Ii(),
              rc = Ii(!0);

          function ic() {
            return [];
          }

          function oc() {
            return !1;
          }

          var ac = ji(function (t, e) {
            return t + e;
          }, 0),
              uc = Li("ceil"),
              cc = ji(function (t, e) {
            return t / e;
          }, 1),
              sc = Li("floor");
          var fc,
              lc = ji(function (t, e) {
            return t * e;
          }, 1),
              hc = Li("round"),
              dc = ji(function (t, e) {
            return t - e;
          }, 0);
          return kn.after = function (t, e) {
            if ("function" != typeof e) throw new _t(o);
            return t = ru(t), function () {
              if (--t < 1) return e.apply(this, arguments);
            };
          }, kn.ary = ga, kn.assign = cu, kn.assignIn = su, kn.assignInWith = fu, kn.assignWith = lu, kn.at = hu, kn.before = ya, kn.bind = _a, kn.bindAll = Fu, kn.bindKey = ma, kn.castArray = function () {
            if (!arguments.length) return [];
            var t = arguments[0];
            return Ia(t) ? t : [t];
          }, kn.chain = ea, kn.chunk = function (t, e, n) {
            e = (n ? uo(t, e, n) : void 0 === e) ? 1 : an(ru(e), 0);
            var i = null == t ? 0 : t.length;
            if (!i || e < 1) return [];

            for (var o = 0, a = 0, u = r(Ke(i / e)); o < i;) {
              u[a++] = Yr(t, o, o += e);
            }

            return u;
          }, kn.compact = function (t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = 0, i = []; ++e < n;) {
              var o = t[e];
              o && (i[r++] = o);
            }

            return i;
          }, kn.concat = function () {
            var t = arguments.length;
            if (!t) return [];

            for (var e = r(t - 1), n = arguments[0], i = t; i--;) {
              e[i - 1] = arguments[i];
            }

            return pe(Ia(n) ? yi(n) : [n], or(e, 1));
          }, kn.cond = function (t) {
            var e = null == t ? 0 : t.length,
                n = Zi();
            return t = e ? de(t, function (t) {
              if ("function" != typeof t[1]) throw new _t(o);
              return [n(t[0]), t[1]];
            }) : [], zr(function (n) {
              for (var r = -1; ++r < e;) {
                var i = t[r];
                if (oe(i[0], this, n)) return oe(i[1], this, n);
              }
            });
          }, kn.conforms = function (t) {
            return function (t) {
              var e = bu(t);
              return function (n) {
                return Qn(n, t, e);
              };
            }(Zn(t, 1));
          }, kn.constant = qu, kn.countBy = ia, kn.create = function (t, e) {
            var n = Cn(t);
            return null == e ? n : Gn(n, e);
          }, kn.curry = function t(e, n, r) {
            var i = Bi(e, 8, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
            return i.placeholder = t.placeholder, i;
          }, kn.curryRight = function t(e, n, r) {
            var i = Bi(e, 16, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
            return i.placeholder = t.placeholder, i;
          }, kn.debounce = ba, kn.defaults = du, kn.defaultsDeep = pu, kn.defer = wa, kn.delay = xa, kn.difference = Co, kn.differenceBy = jo, kn.differenceWith = Mo, kn.drop = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? Yr(t, (e = n || void 0 === e ? 1 : ru(e)) < 0 ? 0 : e, r) : [];
          }, kn.dropRight = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? Yr(t, 0, (e = r - (e = n || void 0 === e ? 1 : ru(e))) < 0 ? 0 : e) : [];
          }, kn.dropRightWhile = function (t, e) {
            return t && t.length ? ei(t, Zi(e, 3), !0, !0) : [];
          }, kn.dropWhile = function (t, e) {
            return t && t.length ? ei(t, Zi(e, 3), !0) : [];
          }, kn.fill = function (t, e, n, r) {
            var i = null == t ? 0 : t.length;
            return i ? (n && "number" != typeof n && uo(t, e, n) && (n = 0, r = i), function (t, e, n, r) {
              var i = t.length;

              for ((n = ru(n)) < 0 && (n = -n > i ? 0 : i + n), (r = void 0 === r || r > i ? i : ru(r)) < 0 && (r += i), r = n > r ? 0 : iu(r); n < r;) {
                t[n++] = e;
              }

              return t;
            }(t, e, n, r)) : [];
          }, kn.filter = function (t, e) {
            return (Ia(t) ? fe : ir)(t, Zi(e, 3));
          }, kn.flatMap = function (t, e) {
            return or(ha(t, e), 1);
          }, kn.flatMapDeep = function (t, e) {
            return or(ha(t, e), 1 / 0);
          }, kn.flatMapDepth = function (t, e, n) {
            return n = void 0 === n ? 1 : ru(n), or(ha(t, e), n);
          }, kn.flatten = Do, kn.flattenDeep = function (t) {
            return (null == t ? 0 : t.length) ? or(t, 1 / 0) : [];
          }, kn.flattenDepth = function (t, e) {
            return (null == t ? 0 : t.length) ? or(t, e = void 0 === e ? 1 : ru(e)) : [];
          }, kn.flip = function (t) {
            return Bi(t, 512);
          }, kn.flow = Vu, kn.flowRight = Yu, kn.fromPairs = function (t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = {}; ++e < n;) {
              var i = t[e];
              r[i[0]] = i[1];
            }

            return r;
          }, kn.functions = function (t) {
            return null == t ? [] : fr(t, bu(t));
          }, kn.functionsIn = function (t) {
            return null == t ? [] : fr(t, wu(t));
          }, kn.groupBy = sa, kn.initial = function (t) {
            return (null == t ? 0 : t.length) ? Yr(t, 0, -1) : [];
          }, kn.intersection = Lo, kn.intersectionBy = Uo, kn.intersectionWith = zo, kn.invert = yu, kn.invertBy = _u, kn.invokeMap = fa, kn.iteratee = Hu, kn.keyBy = la, kn.keys = bu, kn.keysIn = wu, kn.map = ha, kn.mapKeys = function (t, e) {
            var n = {};
            return e = Zi(e, 3), cr(t, function (t, r, i) {
              Hn(n, e(t, r, i), t);
            }), n;
          }, kn.mapValues = function (t, e) {
            var n = {};
            return e = Zi(e, 3), cr(t, function (t, r, i) {
              Hn(n, r, e(t, r, i));
            }), n;
          }, kn.matches = function (t) {
            return kr(Zn(t, 1));
          }, kn.matchesProperty = function (t, e) {
            return Cr(t, Zn(e, 1));
          }, kn.memoize = Ea, kn.merge = xu, kn.mergeWith = Eu, kn.method = $u, kn.methodOf = Xu, kn.mixin = Zu, kn.negate = Aa, kn.nthArg = function (t) {
            return t = ru(t), zr(function (e) {
              return Mr(e, t);
            });
          }, kn.omit = Au, kn.omitBy = function (t, e) {
            return Su(t, Aa(Zi(e)));
          }, kn.once = function (t) {
            return ya(2, t);
          }, kn.orderBy = function (t, e, n, r) {
            return null == t ? [] : (Ia(e) || (e = null == e ? [] : [e]), Ia(n = r ? void 0 : n) || (n = null == n ? [] : [n]), Tr(t, e, n));
          }, kn.over = Ku, kn.overArgs = Ra, kn.overEvery = Ju, kn.overSome = tc, kn.partial = Sa, kn.partialRight = Oa, kn.partition = da, kn.pick = Ru, kn.pickBy = Su, kn.property = ec, kn.propertyOf = function (t) {
            return function (e) {
              return null == t ? void 0 : lr(t, e);
            };
          }, kn.pull = No, kn.pullAll = Wo, kn.pullAllBy = function (t, e, n) {
            return t && t.length && e && e.length ? Dr(t, e, Zi(n, 2)) : t;
          }, kn.pullAllWith = function (t, e, n) {
            return t && t.length && e && e.length ? Dr(t, e, void 0, n) : t;
          }, kn.pullAt = Fo, kn.range = nc, kn.rangeRight = rc, kn.rearg = ka, kn.reject = function (t, e) {
            return (Ia(t) ? fe : ir)(t, Aa(Zi(e, 3)));
          }, kn.remove = function (t, e) {
            var n = [];
            if (!t || !t.length) return n;
            var r = -1,
                i = [],
                o = t.length;

            for (e = Zi(e, 3); ++r < o;) {
              var a = t[r];
              e(a, r, t) && (n.push(a), i.push(r));
            }

            return Pr(t, i), n;
          }, kn.rest = function (t, e) {
            if ("function" != typeof t) throw new _t(o);
            return zr(t, e = void 0 === e ? e : ru(e));
          }, kn.reverse = qo, kn.sampleSize = function (t, e, n) {
            return e = (n ? uo(t, e, n) : void 0 === e) ? 1 : ru(e), (Ia(t) ? Nn : Nr)(t, e);
          }, kn.set = function (t, e, n) {
            return null == t ? t : Wr(t, e, n);
          }, kn.setWith = function (t, e, n, r) {
            return r = "function" == typeof r ? r : void 0, null == t ? t : Wr(t, e, n, r);
          }, kn.shuffle = function (t) {
            return (Ia(t) ? Wn : Vr)(t);
          }, kn.slice = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n && "number" != typeof n && uo(t, e, n) ? (e = 0, n = r) : (e = null == e ? 0 : ru(e), n = void 0 === n ? r : ru(n)), Yr(t, e, n)) : [];
          }, kn.sortBy = pa, kn.sortedUniq = function (t) {
            return t && t.length ? Xr(t) : [];
          }, kn.sortedUniqBy = function (t, e) {
            return t && t.length ? Xr(t, Zi(e, 2)) : [];
          }, kn.split = function (t, e, n) {
            return n && "number" != typeof n && uo(t, e, n) && (e = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (t = uu(t)) && ("string" == typeof e || null != e && !$a(e)) && !(e = Qr(e)) && Be(t) ? si(Ge(t), 0, n) : t.split(e, n) : [];
          }, kn.spread = function (t, e) {
            if ("function" != typeof t) throw new _t(o);
            return e = null == e ? 0 : an(ru(e), 0), zr(function (n) {
              var r = n[e],
                  i = si(n, 0, e);
              return r && pe(i, r), oe(t, this, i);
            });
          }, kn.tail = function (t) {
            var e = null == t ? 0 : t.length;
            return e ? Yr(t, 1, e) : [];
          }, kn.take = function (t, e, n) {
            return t && t.length ? Yr(t, 0, (e = n || void 0 === e ? 1 : ru(e)) < 0 ? 0 : e) : [];
          }, kn.takeRight = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? Yr(t, (e = r - (e = n || void 0 === e ? 1 : ru(e))) < 0 ? 0 : e, r) : [];
          }, kn.takeRightWhile = function (t, e) {
            return t && t.length ? ei(t, Zi(e, 3), !1, !0) : [];
          }, kn.takeWhile = function (t, e) {
            return t && t.length ? ei(t, Zi(e, 3)) : [];
          }, kn.tap = function (t, e) {
            return e(t), t;
          }, kn.throttle = function (t, e, n) {
            var r = !0,
                i = !0;
            if ("function" != typeof t) throw new _t(o);
            return qa(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), ba(t, e, {
              leading: r,
              maxWait: e,
              trailing: i
            });
          }, kn.thru = na, kn.toArray = eu, kn.toPairs = Ou, kn.toPairsIn = ku, kn.toPath = function (t) {
            return Ia(t) ? de(t, So) : Qa(t) ? [t] : yi(Ro(uu(t)));
          }, kn.toPlainObject = au, kn.transform = function (t, e, n) {
            var r = Ia(t),
                i = r || Ua(t) || Ka(t);

            if (e = Zi(e, 4), null == n) {
              var o = t && t.constructor;
              n = i ? r ? new o() : [] : qa(t) && Na(o) ? Cn(Yt(t)) : {};
            }

            return (i ? ue : cr)(t, function (t, r, i) {
              return e(n, t, r, i);
            }), n;
          }, kn.unary = function (t) {
            return ga(t, 1);
          }, kn.union = Vo, kn.unionBy = Yo, kn.unionWith = Go, kn.uniq = function (t) {
            return t && t.length ? Kr(t) : [];
          }, kn.uniqBy = function (t, e) {
            return t && t.length ? Kr(t, Zi(e, 2)) : [];
          }, kn.uniqWith = function (t, e) {
            return e = "function" == typeof e ? e : void 0, t && t.length ? Kr(t, void 0, e) : [];
          }, kn.unset = function (t, e) {
            return null == t || Jr(t, e);
          }, kn.unzip = Ho, kn.unzipWith = $o, kn.update = function (t, e, n) {
            return null == t ? t : ti(t, e, ai(n));
          }, kn.updateWith = function (t, e, n, r) {
            return r = "function" == typeof r ? r : void 0, null == t ? t : ti(t, e, ai(n), r);
          }, kn.values = Cu, kn.valuesIn = function (t) {
            return null == t ? [] : Me(t, wu(t));
          }, kn.without = Xo, kn.words = Nu, kn.wrap = function (t, e) {
            return Sa(ai(e), t);
          }, kn.xor = Zo, kn.xorBy = Qo, kn.xorWith = Ko, kn.zip = Jo, kn.zipObject = function (t, e) {
            return ii(t || [], e || [], qn);
          }, kn.zipObjectDeep = function (t, e) {
            return ii(t || [], e || [], Wr);
          }, kn.zipWith = ta, kn.entries = Ou, kn.entriesIn = ku, kn.extend = su, kn.extendWith = fu, Zu(kn, kn), kn.add = ac, kn.attempt = Wu, kn.camelCase = ju, kn.capitalize = Mu, kn.ceil = uc, kn.clamp = function (t, e, n) {
            return void 0 === n && (n = e, e = void 0), void 0 !== n && (n = (n = ou(n)) == n ? n : 0), void 0 !== e && (e = (e = ou(e)) == e ? e : 0), Xn(ou(t), e, n);
          }, kn.clone = function (t) {
            return Zn(t, 4);
          }, kn.cloneDeep = function (t) {
            return Zn(t, 5);
          }, kn.cloneDeepWith = function (t, e) {
            return Zn(t, 5, e = "function" == typeof e ? e : void 0);
          }, kn.cloneWith = function (t, e) {
            return Zn(t, 4, e = "function" == typeof e ? e : void 0);
          }, kn.conformsTo = function (t, e) {
            return null == e || Qn(t, e, bu(e));
          }, kn.deburr = Tu, kn.defaultTo = function (t, e) {
            return null == t || t != t ? e : t;
          }, kn.divide = cc, kn.endsWith = function (t, e, n) {
            t = uu(t), e = Qr(e);
            var r = t.length,
                i = n = void 0 === n ? r : Xn(ru(n), 0, r);
            return (n -= e.length) >= 0 && t.slice(n, i) == e;
          }, kn.eq = Ca, kn.escape = function (t) {
            return (t = uu(t)) && B.test(t) ? t.replace(U, Ue) : t;
          }, kn.escapeRegExp = function (t) {
            return (t = uu(t)) && H.test(t) ? t.replace(G, "\\$&") : t;
          }, kn.every = function (t, e, n) {
            var r = Ia(t) ? se : nr;
            return n && uo(t, e, n) && (e = void 0), r(t, Zi(e, 3));
          }, kn.find = oa, kn.findIndex = To, kn.findKey = function (t, e) {
            return me(t, Zi(e, 3), cr);
          }, kn.findLast = aa, kn.findLastIndex = Io, kn.findLastKey = function (t, e) {
            return me(t, Zi(e, 3), sr);
          }, kn.floor = sc, kn.forEach = ua, kn.forEachRight = ca, kn.forIn = function (t, e) {
            return null == t ? t : ar(t, Zi(e, 3), wu);
          }, kn.forInRight = function (t, e) {
            return null == t ? t : ur(t, Zi(e, 3), wu);
          }, kn.forOwn = function (t, e) {
            return t && cr(t, Zi(e, 3));
          }, kn.forOwnRight = function (t, e) {
            return t && sr(t, Zi(e, 3));
          }, kn.get = vu, kn.gt = ja, kn.gte = Ma, kn.has = function (t, e) {
            return null != t && ro(t, e, vr);
          }, kn.hasIn = gu, kn.head = Po, kn.identity = Gu, kn.includes = function (t, e, n, r) {
            t = Pa(t) ? t : Cu(t), n = n && !r ? ru(n) : 0;
            var i = t.length;
            return n < 0 && (n = an(i + n, 0)), Za(t) ? n <= i && t.indexOf(e, n) > -1 : !!i && we(t, e, n) > -1;
          }, kn.indexOf = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = null == n ? 0 : ru(n);
            return i < 0 && (i = an(r + i, 0)), we(t, e, i);
          }, kn.inRange = function (t, e, n) {
            return e = nu(e), void 0 === n ? (n = e, e = 0) : n = nu(n), function (t, e, n) {
              return t >= un(e, n) && t < an(e, n);
            }(t = ou(t), e, n);
          }, kn.invoke = mu, kn.isArguments = Ta, kn.isArray = Ia, kn.isArrayBuffer = Da, kn.isArrayLike = Pa, kn.isArrayLikeObject = La, kn.isBoolean = function (t) {
            return !0 === t || !1 === t || Va(t) && dr(t) == f;
          }, kn.isBuffer = Ua, kn.isDate = za, kn.isElement = function (t) {
            return Va(t) && 1 === t.nodeType && !Ha(t);
          }, kn.isEmpty = function (t) {
            if (null == t) return !0;
            if (Pa(t) && (Ia(t) || "string" == typeof t || "function" == typeof t.splice || Ua(t) || Ka(t) || Ta(t))) return !t.length;
            var e = no(t);
            if (e == v || e == m) return !t.size;
            if (lo(t)) return !Ar(t).length;

            for (var n in t) {
              if (At.call(t, n)) return !1;
            }

            return !0;
          }, kn.isEqual = function (t, e) {
            return br(t, e);
          }, kn.isEqualWith = function (t, e, n) {
            var r = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
            return void 0 === r ? br(t, e, void 0, n) : !!r;
          }, kn.isError = Ba, kn.isFinite = function (t) {
            return "number" == typeof t && nn(t);
          }, kn.isFunction = Na, kn.isInteger = Wa, kn.isLength = Fa, kn.isMap = Ya, kn.isMatch = function (t, e) {
            return t === e || wr(t, e, Ki(e));
          }, kn.isMatchWith = function (t, e, n) {
            return n = "function" == typeof n ? n : void 0, wr(t, e, Ki(e), n);
          }, kn.isNaN = function (t) {
            return Ga(t) && t != +t;
          }, kn.isNative = function (t) {
            if (fo(t)) throw new ht("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return xr(t);
          }, kn.isNil = function (t) {
            return null == t;
          }, kn.isNull = function (t) {
            return null === t;
          }, kn.isNumber = Ga, kn.isObject = qa, kn.isObjectLike = Va, kn.isPlainObject = Ha, kn.isRegExp = $a, kn.isSafeInteger = function (t) {
            return Wa(t) && t >= -9007199254740991 && t <= 9007199254740991;
          }, kn.isSet = Xa, kn.isString = Za, kn.isSymbol = Qa, kn.isTypedArray = Ka, kn.isUndefined = function (t) {
            return void 0 === t;
          }, kn.isWeakMap = function (t) {
            return Va(t) && no(t) == x;
          }, kn.isWeakSet = function (t) {
            return Va(t) && "[object WeakSet]" == dr(t);
          }, kn.join = function (t, e) {
            return null == t ? "" : rn.call(t, e);
          }, kn.kebabCase = Iu, kn.last = Bo, kn.lastIndexOf = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = r;
            return void 0 !== n && (i = (i = ru(n)) < 0 ? an(r + i, 0) : un(i, r - 1)), e == e ? function (t, e, n) {
              for (var r = n + 1; r--;) {
                if (t[r] === e) return r;
              }

              return r;
            }(t, e, i) : be(t, Ee, i, !0);
          }, kn.lowerCase = Du, kn.lowerFirst = Pu, kn.lt = Ja, kn.lte = tu, kn.max = function (t) {
            return t && t.length ? rr(t, Gu, pr) : void 0;
          }, kn.maxBy = function (t, e) {
            return t && t.length ? rr(t, Zi(e, 2), pr) : void 0;
          }, kn.mean = function (t) {
            return Ae(t, Gu);
          }, kn.meanBy = function (t, e) {
            return Ae(t, Zi(e, 2));
          }, kn.min = function (t) {
            return t && t.length ? rr(t, Gu, Sr) : void 0;
          }, kn.minBy = function (t, e) {
            return t && t.length ? rr(t, Zi(e, 2), Sr) : void 0;
          }, kn.stubArray = ic, kn.stubFalse = oc, kn.stubObject = function () {
            return {};
          }, kn.stubString = function () {
            return "";
          }, kn.stubTrue = function () {
            return !0;
          }, kn.multiply = lc, kn.nth = function (t, e) {
            return t && t.length ? Mr(t, ru(e)) : void 0;
          }, kn.noConflict = function () {
            return Ht._ === this && (Ht._ = Ct), this;
          }, kn.noop = Qu, kn.now = va, kn.pad = function (t, e, n) {
            t = uu(t);
            var r = (e = ru(e)) ? Ye(t) : 0;
            if (!e || r >= e) return t;
            var i = (e - r) / 2;
            return Ti(Je(i), n) + t + Ti(Ke(i), n);
          }, kn.padEnd = function (t, e, n) {
            t = uu(t);
            var r = (e = ru(e)) ? Ye(t) : 0;
            return e && r < e ? t + Ti(e - r, n) : t;
          }, kn.padStart = function (t, e, n) {
            t = uu(t);
            var r = (e = ru(e)) ? Ye(t) : 0;
            return e && r < e ? Ti(e - r, n) + t : t;
          }, kn.parseInt = function (t, e, n) {
            return n || null == e ? e = 0 : e && (e = +e), sn(uu(t).replace(X, ""), e || 0);
          }, kn.random = function (t, e, n) {
            if (n && "boolean" != typeof n && uo(t, e, n) && (e = n = void 0), void 0 === n && ("boolean" == typeof e ? (n = e, e = void 0) : "boolean" == typeof t && (n = t, t = void 0)), void 0 === t && void 0 === e ? (t = 0, e = 1) : (t = nu(t), void 0 === e ? (e = t, t = 0) : e = nu(e)), t > e) {
              var r = t;
              t = e, e = r;
            }

            if (n || t % 1 || e % 1) {
              var i = fn();
              return un(t + i * (e - t + qt("1e-" + ((i + "").length - 1))), e);
            }

            return Lr(t, e);
          }, kn.reduce = function (t, e, n) {
            var r = Ia(t) ? ve : Oe,
                i = arguments.length < 3;
            return r(t, Zi(e, 4), n, i, tr);
          }, kn.reduceRight = function (t, e, n) {
            var r = Ia(t) ? ge : Oe,
                i = arguments.length < 3;
            return r(t, Zi(e, 4), n, i, er);
          }, kn.repeat = function (t, e, n) {
            return e = (n ? uo(t, e, n) : void 0 === e) ? 1 : ru(e), Ur(uu(t), e);
          }, kn.replace = function () {
            var t = arguments,
                e = uu(t[0]);
            return t.length < 3 ? e : e.replace(t[1], t[2]);
          }, kn.result = function (t, e, n) {
            var r = -1,
                i = (e = ui(e, t)).length;

            for (i || (i = 1, t = void 0); ++r < i;) {
              var o = null == t ? void 0 : t[So(e[r])];
              void 0 === o && (r = i, o = n), t = Na(o) ? o.call(t) : o;
            }

            return t;
          }, kn.round = hc, kn.runInContext = t, kn.sample = function (t) {
            return (Ia(t) ? Bn : Br)(t);
          }, kn.size = function (t) {
            if (null == t) return 0;
            if (Pa(t)) return Za(t) ? Ye(t) : t.length;
            var e = no(t);
            return e == v || e == m ? t.size : Ar(t).length;
          }, kn.snakeCase = Lu, kn.some = function (t, e, n) {
            var r = Ia(t) ? ye : Gr;
            return n && uo(t, e, n) && (e = void 0), r(t, Zi(e, 3));
          }, kn.sortedIndex = function (t, e) {
            return Hr(t, e);
          }, kn.sortedIndexBy = function (t, e, n) {
            return $r(t, e, Zi(n, 2));
          }, kn.sortedIndexOf = function (t, e) {
            var n = null == t ? 0 : t.length;

            if (n) {
              var r = Hr(t, e);
              if (r < n && Ca(t[r], e)) return r;
            }

            return -1;
          }, kn.sortedLastIndex = function (t, e) {
            return Hr(t, e, !0);
          }, kn.sortedLastIndexBy = function (t, e, n) {
            return $r(t, e, Zi(n, 2), !0);
          }, kn.sortedLastIndexOf = function (t, e) {
            if (null == t ? 0 : t.length) {
              var n = Hr(t, e, !0) - 1;
              if (Ca(t[n], e)) return n;
            }

            return -1;
          }, kn.startCase = Uu, kn.startsWith = function (t, e, n) {
            return t = uu(t), n = null == n ? 0 : Xn(ru(n), 0, t.length), e = Qr(e), t.slice(n, n + e.length) == e;
          }, kn.subtract = dc, kn.sum = function (t) {
            return t && t.length ? ke(t, Gu) : 0;
          }, kn.sumBy = function (t, e) {
            return t && t.length ? ke(t, Zi(e, 2)) : 0;
          }, kn.template = function (t, e, n) {
            var r = kn.templateSettings;
            n && uo(t, e, n) && (e = void 0), t = uu(t), e = fu({}, e, r, Ni);
            var i,
                o,
                a = fu({}, e.imports, r.imports, Ni),
                u = bu(a),
                c = Me(a, u),
                s = 0,
                f = e.interpolate || ft,
                l = "__p += '",
                h = gt((e.escape || ft).source + "|" + f.source + "|" + (f === F ? nt : ft).source + "|" + (e.evaluate || ft).source + "|$", "g"),
                d = "//# sourceURL=" + (At.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Bt + "]") + "\n";
            t.replace(h, function (e, n, r, a, u, c) {
              return r || (r = a), l += t.slice(s, c).replace(lt, ze), n && (i = !0, l += "' +\n__e(" + n + ") +\n'"), u && (o = !0, l += "';\n" + u + ";\n__p += '"), r && (l += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), s = c + e.length, e;
            }), l += "';\n";
            var p = At.call(e, "variable") && e.variable;
            p || (l = "with (obj) {\n" + l + "\n}\n"), l = (o ? l.replace(I, "") : l).replace(D, "$1").replace(P, "$1;"), l = "function(" + (p || "obj") + ") {\n" + (p ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + l + "return __p\n}";
            var v = Wu(function () {
              return dt(u, d + "return " + l).apply(void 0, c);
            });
            if (v.source = l, Ba(v)) throw v;
            return v;
          }, kn.times = function (t, e) {
            if ((t = ru(t)) < 1 || t > 9007199254740991) return [];
            var n = 4294967295,
                r = un(t, 4294967295);
            t -= 4294967295;

            for (var i = Ce(r, e = Zi(e)); ++n < t;) {
              e(n);
            }

            return i;
          }, kn.toFinite = nu, kn.toInteger = ru, kn.toLength = iu, kn.toLower = function (t) {
            return uu(t).toLowerCase();
          }, kn.toNumber = ou, kn.toSafeInteger = function (t) {
            return t ? Xn(ru(t), -9007199254740991, 9007199254740991) : 0 === t ? t : 0;
          }, kn.toString = uu, kn.toUpper = function (t) {
            return uu(t).toUpperCase();
          }, kn.trim = function (t, e, n) {
            if ((t = uu(t)) && (n || void 0 === e)) return t.replace($, "");
            if (!t || !(e = Qr(e))) return t;
            var r = Ge(t),
                i = Ge(e);
            return si(r, Ie(r, i), De(r, i) + 1).join("");
          }, kn.trimEnd = function (t, e, n) {
            if ((t = uu(t)) && (n || void 0 === e)) return t.replace(Z, "");
            if (!t || !(e = Qr(e))) return t;
            var r = Ge(t);
            return si(r, 0, De(r, Ge(e)) + 1).join("");
          }, kn.trimStart = function (t, e, n) {
            if ((t = uu(t)) && (n || void 0 === e)) return t.replace(X, "");
            if (!t || !(e = Qr(e))) return t;
            var r = Ge(t);
            return si(r, Ie(r, Ge(e))).join("");
          }, kn.truncate = function (t, e) {
            var n = 30,
                r = "...";

            if (qa(e)) {
              var i = "separator" in e ? e.separator : i;
              n = "length" in e ? ru(e.length) : n, r = "omission" in e ? Qr(e.omission) : r;
            }

            var o = (t = uu(t)).length;

            if (Be(t)) {
              var a = Ge(t);
              o = a.length;
            }

            if (n >= o) return t;
            var u = n - Ye(r);
            if (u < 1) return r;
            var c = a ? si(a, 0, u).join("") : t.slice(0, u);
            if (void 0 === i) return c + r;

            if (a && (u += c.length - u), $a(i)) {
              if (t.slice(u).search(i)) {
                var s,
                    f = c;

                for (i.global || (i = gt(i.source, uu(rt.exec(i)) + "g")), i.lastIndex = 0; s = i.exec(f);) {
                  var l = s.index;
                }

                c = c.slice(0, void 0 === l ? u : l);
              }
            } else if (t.indexOf(Qr(i), u) != u) {
              var h = c.lastIndexOf(i);
              h > -1 && (c = c.slice(0, h));
            }

            return c + r;
          }, kn.unescape = function (t) {
            return (t = uu(t)) && z.test(t) ? t.replace(L, He) : t;
          }, kn.uniqueId = function (t) {
            var e = ++Rt;
            return uu(t) + e;
          }, kn.upperCase = zu, kn.upperFirst = Bu, kn.each = ua, kn.eachRight = ca, kn.first = Po, Zu(kn, (fc = {}, cr(kn, function (t, e) {
            At.call(kn.prototype, e) || (fc[e] = t);
          }), fc), {
            chain: !1
          }), kn.VERSION = "4.17.19", ue(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (t) {
            kn[t].placeholder = kn;
          }), ue(["drop", "take"], function (t, e) {
            Tn.prototype[t] = function (n) {
              n = void 0 === n ? 1 : an(ru(n), 0);
              var r = this.__filtered__ && !e ? new Tn(this) : this.clone();
              return r.__filtered__ ? r.__takeCount__ = un(n, r.__takeCount__) : r.__views__.push({
                size: un(n, 4294967295),
                type: t + (r.__dir__ < 0 ? "Right" : "")
              }), r;
            }, Tn.prototype[t + "Right"] = function (e) {
              return this.reverse()[t](e).reverse();
            };
          }), ue(["filter", "map", "takeWhile"], function (t, e) {
            var n = e + 1,
                r = 1 == n || 3 == n;

            Tn.prototype[t] = function (t) {
              var e = this.clone();
              return e.__iteratees__.push({
                iteratee: Zi(t, 3),
                type: n
              }), e.__filtered__ = e.__filtered__ || r, e;
            };
          }), ue(["head", "last"], function (t, e) {
            var n = "take" + (e ? "Right" : "");

            Tn.prototype[t] = function () {
              return this[n](1).value()[0];
            };
          }), ue(["initial", "tail"], function (t, e) {
            var n = "drop" + (e ? "" : "Right");

            Tn.prototype[t] = function () {
              return this.__filtered__ ? new Tn(this) : this[n](1);
            };
          }), Tn.prototype.compact = function () {
            return this.filter(Gu);
          }, Tn.prototype.find = function (t) {
            return this.filter(t).head();
          }, Tn.prototype.findLast = function (t) {
            return this.reverse().find(t);
          }, Tn.prototype.invokeMap = zr(function (t, e) {
            return "function" == typeof t ? new Tn(this) : this.map(function (n) {
              return _r(n, t, e);
            });
          }), Tn.prototype.reject = function (t) {
            return this.filter(Aa(Zi(t)));
          }, Tn.prototype.slice = function (t, e) {
            t = ru(t);
            var n = this;
            return n.__filtered__ && (t > 0 || e < 0) ? new Tn(n) : (t < 0 ? n = n.takeRight(-t) : t && (n = n.drop(t)), void 0 !== e && (n = (e = ru(e)) < 0 ? n.dropRight(-e) : n.take(e - t)), n);
          }, Tn.prototype.takeRightWhile = function (t) {
            return this.reverse().takeWhile(t).reverse();
          }, Tn.prototype.toArray = function () {
            return this.take(4294967295);
          }, cr(Tn.prototype, function (t, e) {
            var n = /^(?:filter|find|map|reject)|While$/.test(e),
                r = /^(?:head|last)$/.test(e),
                i = kn[r ? "take" + ("last" == e ? "Right" : "") : e],
                o = r || /^find/.test(e);
            i && (kn.prototype[e] = function () {
              var e = this.__wrapped__,
                  a = r ? [1] : arguments,
                  u = e instanceof Tn,
                  c = a[0],
                  s = u || Ia(e),
                  f = function f(t) {
                var e = i.apply(kn, pe([t], a));
                return r && l ? e[0] : e;
              };

              s && n && "function" == typeof c && 1 != c.length && (u = s = !1);
              var l = this.__chain__,
                  h = !!this.__actions__.length,
                  d = o && !l,
                  p = u && !h;

              if (!o && s) {
                e = p ? e : new Tn(this);
                var v = t.apply(e, a);
                return v.__actions__.push({
                  func: na,
                  args: [f],
                  thisArg: void 0
                }), new Mn(v, l);
              }

              return d && p ? t.apply(this, a) : (v = this.thru(f), d ? r ? v.value()[0] : v.value() : v);
            });
          }), ue(["pop", "push", "shift", "sort", "splice", "unshift"], function (t) {
            var e = mt[t],
                n = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
                r = /^(?:pop|shift)$/.test(t);

            kn.prototype[t] = function () {
              var t = arguments;

              if (r && !this.__chain__) {
                var i = this.value();
                return e.apply(Ia(i) ? i : [], t);
              }

              return this[n](function (n) {
                return e.apply(Ia(n) ? n : [], t);
              });
            };
          }), cr(Tn.prototype, function (t, e) {
            var n = kn[e];

            if (n) {
              var r = n.name + "";
              At.call(mn, r) || (mn[r] = []), mn[r].push({
                name: e,
                func: n
              });
            }
          }), mn[ki(void 0, 2).name] = [{
            name: "wrapper",
            func: void 0
          }], Tn.prototype.clone = function () {
            var t = new Tn(this.__wrapped__);
            return t.__actions__ = yi(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = yi(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = yi(this.__views__), t;
          }, Tn.prototype.reverse = function () {
            if (this.__filtered__) {
              var t = new Tn(this);
              t.__dir__ = -1, t.__filtered__ = !0;
            } else (t = this.clone()).__dir__ *= -1;

            return t;
          }, Tn.prototype.value = function () {
            var t = this.__wrapped__.value(),
                e = this.__dir__,
                n = Ia(t),
                r = e < 0,
                i = n ? t.length : 0,
                o = function (t, e, n) {
              var r = -1,
                  i = n.length;

              for (; ++r < i;) {
                var o = n[r],
                    a = o.size;

                switch (o.type) {
                  case "drop":
                    t += a;
                    break;

                  case "dropRight":
                    e -= a;
                    break;

                  case "take":
                    e = un(e, t + a);
                    break;

                  case "takeRight":
                    t = an(t, e - a);
                }
              }

              return {
                start: t,
                end: e
              };
            }(0, i, this.__views__),
                a = o.start,
                u = o.end,
                c = u - a,
                s = r ? u : a - 1,
                f = this.__iteratees__,
                l = f.length,
                h = 0,
                d = un(c, this.__takeCount__);

            if (!n || !r && i == c && d == c) return ni(t, this.__actions__);
            var p = [];

            t: for (; c-- && h < d;) {
              for (var v = -1, g = t[s += e]; ++v < l;) {
                var y = f[v],
                    _ = y.iteratee,
                    m = y.type,
                    b = _(g);

                if (2 == m) g = b;else if (!b) {
                  if (1 == m) continue t;
                  break t;
                }
              }

              p[h++] = g;
            }

            return p;
          }, kn.prototype.at = ra, kn.prototype.chain = function () {
            return ea(this);
          }, kn.prototype.commit = function () {
            return new Mn(this.value(), this.__chain__);
          }, kn.prototype.next = function () {
            void 0 === this.__values__ && (this.__values__ = eu(this.value()));
            var t = this.__index__ >= this.__values__.length;
            return {
              done: t,
              value: t ? void 0 : this.__values__[this.__index__++]
            };
          }, kn.prototype.plant = function (t) {
            for (var e, n = this; n instanceof jn;) {
              var r = ko(n);
              r.__index__ = 0, r.__values__ = void 0, e ? i.__wrapped__ = r : e = r;
              var i = r;
              n = n.__wrapped__;
            }

            return i.__wrapped__ = t, e;
          }, kn.prototype.reverse = function () {
            var t = this.__wrapped__;

            if (t instanceof Tn) {
              var e = t;
              return this.__actions__.length && (e = new Tn(this)), (e = e.reverse()).__actions__.push({
                func: na,
                args: [qo],
                thisArg: void 0
              }), new Mn(e, this.__chain__);
            }

            return this.thru(qo);
          }, kn.prototype.toJSON = kn.prototype.valueOf = kn.prototype.value = function () {
            return ni(this.__wrapped__, this.__actions__);
          }, kn.prototype.first = kn.prototype.head, Kt && (kn.prototype[Kt] = function () {
            return this;
          }), kn;
        }();

        Ht._ = $e, void 0 === (i = function () {
          return $e;
        }.call(e, n, e, r)) || (r.exports = i);
      }).call(this);
    }).call(this, n(12), n(141)(t));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e) {
    var n,
        r,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    }();
    var c,
        s = [],
        f = !1,
        l = -1;

    function h() {
      f && c && (f = !1, c.length ? s = c.concat(s) : l = -1, s.length && d());
    }

    function d() {
      if (!f) {
        var t = u(h);
        f = !0;

        for (var e = s.length; e;) {
          for (c = s, s = []; ++l < e;) {
            c && c[l].run();
          }

          l = -1, e = s.length;
        }

        c = null, f = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }

    function p(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      s.push(new p(t, e)), 1 !== s.length || f || u(d);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = v, i.addListener = v, i.once = v, i.off = v, i.removeListener = v, i.removeAllListeners = v, i.emit = v, i.prependListener = v, i.prependOnceListener = v, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(24),
        i = Object.keys || function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e;
    };

    t.exports = l;
    var o = Object.create(n(22));
    o.inherits = n(18);
    var a = n(57),
        u = n(33);
    o.inherits(l, a);

    for (var c = i(u.prototype), s = 0; s < c.length; s++) {
      var f = c[s];
      l.prototype[f] || (l.prototype[f] = u.prototype[f]);
    }

    function l(t) {
      if (!(this instanceof l)) return new l(t);
      a.call(this, t), u.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
    }

    function h() {
      this.allowHalfOpen || this._writableState.ended || r.nextTick(d, this);
    }

    function d(t) {
      t.end();
    }

    Object.defineProperty(l.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(l.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), l.prototype._destroy = function (t, e) {
      this.push(null), this.end(), r.nextTick(e, t);
    };
  }, function (t, e, n) {
    "use strict";

    e.a = {
      drawRect: function drawRect(t, e, n, r) {
        n.strokeStyle = r.color, n.fillStyle = r.color, n.lineWidth = r.lineWidth || 1, n.beginPath(), n.strokeRect(t.x, t.y, e.x, e.y);
      },
      drawPath: function drawPath(t, e, n, r) {
        n.strokeStyle = r.color, n.fillStyle = r.color, n.lineWidth = r.lineWidth, n.beginPath(), n.moveTo(t[0][e.x], t[0][e.y]);

        for (var i = 1; i < t.length; i++) {
          n.lineTo(t[i][e.x], t[i][e.y]);
        }

        n.closePath(), n.stroke();
      },
      drawImage: function drawImage(t, e, n) {
        var r = n.getImageData(0, 0, e.x, e.y),
            i = r.data,
            o = i.length,
            a = t.length;
        if (o / a != 4) return !1;

        for (; a--;) {
          var u = t[a];
          i[--o] = 255, i[--o] = u, i[--o] = u, i[--o] = u;
        }

        return n.putImageData(r, 0, 0), !0;
      }
    };
  }, function (t, e, n) {
    var r = n(145);

    function i(e, n, o) {
      return "undefined" != typeof Reflect && Reflect.get ? t.exports = i = Reflect.get : t.exports = i = function i(t, e, n) {
        var i = r(t, e);

        if (i) {
          var o = Object.getOwnPropertyDescriptor(i, e);
          return o.get ? o.get.call(n) : o.value;
        }
      }, i(e, n, o || e);
    }

    t.exports = i;
  }, function (t, e, n) {
    t.exports = n(146);
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }));
    } : t.exports = function (t, e) {
      if (e) {
        t.super_ = e;

        var n = function n() {};

        n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
      }
    };
  }, function (t, e) {
    function n(e) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = n = function n(t) {
        return typeof t;
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, n(e);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    e.a = {
      searchDirections: [[0, 1], [1, 1], [1, 0], [1, -1], [0, -1], [-1, -1], [-1, 0], [-1, 1]],
      create: function create(t, e) {
        var n,
            r = t.data,
            i = e.data,
            o = this.searchDirections,
            a = t.size.x;

        function u(t, e, u, c) {
          var s, f, l;

          for (s = 0; s < 7; s++) {
            if (f = t.cy + o[t.dir][0], l = t.cx + o[t.dir][1], r[n = f * a + l] === e && (0 === i[n] || i[n] === u)) return i[n] = u, t.cy = f, t.cx = l, !0;
            0 === i[n] && (i[n] = c), t.dir = (t.dir + 1) % 8;
          }

          return !1;
        }

        function c(t, e, n) {
          return {
            dir: n,
            x: t,
            y: e,
            next: null,
            prev: null
          };
        }

        return {
          trace: function trace(t, e, n, r) {
            return u(t, e, n, r);
          },
          contourTracing: function contourTracing(t, e, n, r, i) {
            return function (t, e, n, r, i) {
              var o,
                  a,
                  s,
                  f = null,
                  l = {
                cx: e,
                cy: t,
                dir: 0
              };

              if (u(l, r, n, i)) {
                o = f = c(e, t, l.dir), s = l.dir, (a = c(l.cx, l.cy, 0)).prev = o, o.next = a, a.next = null, o = a;

                do {
                  l.dir = (l.dir + 6) % 8, u(l, r, n, i), s !== l.dir ? (o.dir = l.dir, (a = c(l.cx, l.cy, 0)).prev = o, o.next = a, a.next = null, o = a) : (o.dir = s, o.x = l.cx, o.y = l.cy), s = l.dir;
                } while (l.cx !== e || l.cy !== t);

                f.prev = o.prev, o.prev.next = f;
              }

              return f;
            }(t, e, n, r, i);
          }
        };
      }
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var r = n(159),
          i = n(160),
          o = n(161);

      function a() {
        return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function u(t, e) {
        if (a() < e) throw new RangeError("Invalid typed array length");
        return c.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = c.prototype : (null === t && (t = new c(e)), t.length = e), t;
      }

      function c(t, e, n) {
        if (!(c.TYPED_ARRAY_SUPPORT || this instanceof c)) return new c(t, e, n);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return l(this, t);
        }

        return s(this, t, e, n);
      }

      function s(t, e, n, r) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, n, r) {
          if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r);
          c.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = c.prototype : t = h(t, e);
          return t;
        }(t, e, n, r) : "string" == typeof e ? function (t, e, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!c.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | p(e, n),
              i = (t = u(t, r)).write(e, n);
          i !== r && (t = t.slice(0, i));
          return t;
        }(t, e, n) : function (t, e) {
          if (c.isBuffer(e)) {
            var n = 0 | d(e.length);
            return 0 === (t = u(t, n)).length || e.copy(t, 0, 0, n), t;
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (r = e.length) != r ? u(t, 0) : h(t, e);
            if ("Buffer" === e.type && o(e.data)) return h(t, e.data);
          }

          var r;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function f(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function l(t, e) {
        if (f(e), t = u(t, e < 0 ? 0 : 0 | d(e)), !c.TYPED_ARRAY_SUPPORT) for (var n = 0; n < e; ++n) {
          t[n] = 0;
        }
        return t;
      }

      function h(t, e) {
        var n = e.length < 0 ? 0 : 0 | d(e.length);
        t = u(t, n);

        for (var r = 0; r < n; r += 1) {
          t[r] = 255 & e[r];
        }

        return t;
      }

      function d(t) {
        if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | t;
      }

      function p(t, e) {
        if (c.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var n = t.length;
        if (0 === n) return 0;

        for (var r = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;

            case "utf8":
            case "utf-8":
            case void 0:
              return N(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;

            case "hex":
              return n >>> 1;

            case "base64":
              return W(t).length;

            default:
              if (r) return N(t).length;
              e = ("" + e).toLowerCase(), r = !0;
          }
        }
      }

      function v(t, e, n) {
        var r = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return C(this, e, n);

            case "utf8":
            case "utf-8":
              return S(this, e, n);

            case "ascii":
              return O(this, e, n);

            case "latin1":
            case "binary":
              return k(this, e, n);

            case "base64":
              return R(this, e, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return j(this, e, n);

            default:
              if (r) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), r = !0;
          }
        }
      }

      function g(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r;
      }

      function y(t, e, n, r, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
          if (i) return -1;
          n = t.length - 1;
        } else if (n < 0) {
          if (!i) return -1;
          n = 0;
        }

        if ("string" == typeof e && (e = c.from(e, r)), c.isBuffer(e)) return 0 === e.length ? -1 : _(t, e, n, r, i);
        if ("number" == typeof e) return e &= 255, c.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : _(t, [e], n, r, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function _(t, e, n, r, i) {
        var o,
            a = 1,
            u = t.length,
            c = e.length;

        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, u /= 2, c /= 2, n /= 2;
        }

        function s(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a);
        }

        if (i) {
          var f = -1;

          for (o = n; o < u; o++) {
            if (s(t, o) === s(e, -1 === f ? 0 : o - f)) {
              if (-1 === f && (f = o), o - f + 1 === c) return f * a;
            } else -1 !== f && (o -= o - f), f = -1;
          }
        } else for (n + c > u && (n = u - c), o = n; o >= 0; o--) {
          for (var l = !0, h = 0; h < c; h++) {
            if (s(t, o + h) !== s(e, h)) {
              l = !1;
              break;
            }
          }

          if (l) return o;
        }

        return -1;
      }

      function m(t, e, n, r) {
        n = Number(n) || 0;
        var i = t.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        r > o / 2 && (r = o / 2);

        for (var a = 0; a < r; ++a) {
          var u = parseInt(e.substr(2 * a, 2), 16);
          if (isNaN(u)) return a;
          t[n + a] = u;
        }

        return a;
      }

      function b(t, e, n, r) {
        return F(N(e, t.length - n), t, n, r);
      }

      function w(t, e, n, r) {
        return F(function (t) {
          for (var e = [], n = 0; n < t.length; ++n) {
            e.push(255 & t.charCodeAt(n));
          }

          return e;
        }(e), t, n, r);
      }

      function x(t, e, n, r) {
        return w(t, e, n, r);
      }

      function E(t, e, n, r) {
        return F(W(e), t, n, r);
      }

      function A(t, e, n, r) {
        return F(function (t, e) {
          for (var n, r, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
            n = t.charCodeAt(a), r = n >> 8, i = n % 256, o.push(i), o.push(r);
          }

          return o;
        }(e, t.length - n), t, n, r);
      }

      function R(t, e, n) {
        return 0 === e && n === t.length ? r.fromByteArray(t) : r.fromByteArray(t.slice(e, n));
      }

      function S(t, e, n) {
        n = Math.min(t.length, n);

        for (var r = [], i = e; i < n;) {
          var o,
              a,
              u,
              c,
              s = t[i],
              f = null,
              l = s > 239 ? 4 : s > 223 ? 3 : s > 191 ? 2 : 1;
          if (i + l <= n) switch (l) {
            case 1:
              s < 128 && (f = s);
              break;

            case 2:
              128 == (192 & (o = t[i + 1])) && (c = (31 & s) << 6 | 63 & o) > 127 && (f = c);
              break;

            case 3:
              o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (c = (15 & s) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (c < 55296 || c > 57343) && (f = c);
              break;

            case 4:
              o = t[i + 1], a = t[i + 2], u = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & u) && (c = (15 & s) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & u) > 65535 && c < 1114112 && (f = c);
          }
          null === f ? (f = 65533, l = 1) : f > 65535 && (f -= 65536, r.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), r.push(f), i += l;
        }

        return function (t) {
          var e = t.length;
          if (e <= 4096) return String.fromCharCode.apply(String, t);
          var n = "",
              r = 0;

          for (; r < e;) {
            n += String.fromCharCode.apply(String, t.slice(r, r += 4096));
          }

          return n;
        }(r);
      }

      e.Buffer = c, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return c.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = a(), c.poolSize = 8192, c._augment = function (t) {
        return t.__proto__ = c.prototype, t;
      }, c.from = function (t, e, n) {
        return s(null, t, e, n);
      }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
        value: null,
        configurable: !0
      })), c.alloc = function (t, e, n) {
        return function (t, e, n, r) {
          return f(e), e <= 0 ? u(t, e) : void 0 !== n ? "string" == typeof r ? u(t, e).fill(n, r) : u(t, e).fill(n) : u(t, e);
        }(null, t, e, n);
      }, c.allocUnsafe = function (t) {
        return l(null, t);
      }, c.allocUnsafeSlow = function (t) {
        return l(null, t);
      }, c.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, c.compare = function (t, e) {
        if (!c.isBuffer(t) || !c.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var n = t.length, r = e.length, i = 0, o = Math.min(n, r); i < o; ++i) {
          if (t[i] !== e[i]) {
            n = t[i], r = e[i];
            break;
          }
        }

        return n < r ? -1 : r < n ? 1 : 0;
      }, c.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, c.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return c.alloc(0);
        var n;
        if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) {
          e += t[n].length;
        }
        var r = c.allocUnsafe(e),
            i = 0;

        for (n = 0; n < t.length; ++n) {
          var a = t[n];
          if (!c.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, i), i += a.length;
        }

        return r;
      }, c.byteLength = p, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          g(this, e, e + 1);
        }

        return this;
      }, c.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          g(this, e, e + 3), g(this, e + 1, e + 2);
        }

        return this;
      }, c.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
        }

        return this;
      }, c.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? S(this, 0, t) : v.apply(this, arguments);
      }, c.prototype.equals = function (t) {
        if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === c.compare(this, t);
      }, c.prototype.inspect = function () {
        var t = "",
            n = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">";
      }, c.prototype.compare = function (t, e, n, r, i) {
        if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), e < 0 || n > t.length || r < 0 || i > this.length) throw new RangeError("out of range index");
        if (r >= i && e >= n) return 0;
        if (r >= i) return -1;
        if (e >= n) return 1;
        if (this === t) return 0;

        for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (e >>>= 0), u = Math.min(o, a), s = this.slice(r, i), f = t.slice(e, n), l = 0; l < u; ++l) {
          if (s[l] !== f[l]) {
            o = s[l], a = f[l];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, c.prototype.includes = function (t, e, n) {
        return -1 !== this.indexOf(t, e, n);
      }, c.prototype.indexOf = function (t, e, n) {
        return y(this, t, e, n, !0);
      }, c.prototype.lastIndexOf = function (t, e, n) {
        return y(this, t, e, n, !1);
      }, c.prototype.write = function (t, e, n, r) {
        if (void 0 === e) r = "utf8", n = this.length, e = 0;else if (void 0 === n && "string" == typeof e) r = e, n = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }
        var i = this.length - e;
        if ((void 0 === n || n > i) && (n = i), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");

        for (var o = !1;;) {
          switch (r) {
            case "hex":
              return m(this, t, e, n);

            case "utf8":
            case "utf-8":
              return b(this, t, e, n);

            case "ascii":
              return w(this, t, e, n);

            case "latin1":
            case "binary":
              return x(this, t, e, n);

            case "base64":
              return E(this, t, e, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return A(this, t, e, n);

            default:
              if (o) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), o = !0;
          }
        }
      }, c.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function O(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);

        for (var i = e; i < n; ++i) {
          r += String.fromCharCode(127 & t[i]);
        }

        return r;
      }

      function k(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);

        for (var i = e; i < n; ++i) {
          r += String.fromCharCode(t[i]);
        }

        return r;
      }

      function C(t, e, n) {
        var r = t.length;
        (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);

        for (var i = "", o = e; o < n; ++o) {
          i += B(t[o]);
        }

        return i;
      }

      function j(t, e, n) {
        for (var r = t.slice(e, n), i = "", o = 0; o < r.length; o += 2) {
          i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        }

        return i;
      }

      function M(t, e, n) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > n) throw new RangeError("Trying to access beyond buffer length");
      }

      function T(t, e, n, r, i, o) {
        if (!c.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (n + r > t.length) throw new RangeError("Index out of range");
      }

      function I(t, e, n, r) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - n, 2); i < o; ++i) {
          t[n + i] = (e & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
      }

      function D(t, e, n, r) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - n, 4); i < o; ++i) {
          t[n + i] = e >>> 8 * (r ? i : 3 - i) & 255;
        }
      }

      function P(t, e, n, r, i, o) {
        if (n + r > t.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }

      function L(t, e, n, r, o) {
        return o || P(t, 0, n, 4), i.write(t, e, n, r, 23, 4), n + 4;
      }

      function U(t, e, n, r, o) {
        return o || P(t, 0, n, 8), i.write(t, e, n, r, 52, 8), n + 8;
      }

      c.prototype.slice = function (t, e) {
        var n,
            r = this.length;
        if ((t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t), c.TYPED_ARRAY_SUPPORT) (n = this.subarray(t, e)).__proto__ = c.prototype;else {
          var i = e - t;
          n = new c(i, void 0);

          for (var o = 0; o < i; ++o) {
            n[o] = this[o + t];
          }
        }
        return n;
      }, c.prototype.readUIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || M(t, e, this.length);

        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          r += this[t + o] * i;
        }

        return r;
      }, c.prototype.readUIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || M(t, e, this.length);

        for (var r = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          r += this[t + --e] * i;
        }

        return r;
      }, c.prototype.readUInt8 = function (t, e) {
        return e || M(t, 1, this.length), this[t];
      }, c.prototype.readUInt16LE = function (t, e) {
        return e || M(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, c.prototype.readUInt16BE = function (t, e) {
        return e || M(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, c.prototype.readUInt32LE = function (t, e) {
        return e || M(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, c.prototype.readUInt32BE = function (t, e) {
        return e || M(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, c.prototype.readIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || M(t, e, this.length);

        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          r += this[t + o] * i;
        }

        return r >= (i *= 128) && (r -= Math.pow(2, 8 * e)), r;
      }, c.prototype.readIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || M(t, e, this.length);

        for (var r = e, i = 1, o = this[t + --r]; r > 0 && (i *= 256);) {
          o += this[t + --r] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, c.prototype.readInt8 = function (t, e) {
        return e || M(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, c.prototype.readInt16LE = function (t, e) {
        e || M(t, 2, this.length);
        var n = this[t] | this[t + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, c.prototype.readInt16BE = function (t, e) {
        e || M(t, 2, this.length);
        var n = this[t + 1] | this[t] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, c.prototype.readInt32LE = function (t, e) {
        return e || M(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, c.prototype.readInt32BE = function (t, e) {
        return e || M(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, c.prototype.readFloatLE = function (t, e) {
        return e || M(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, c.prototype.readFloatBE = function (t, e) {
        return e || M(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, c.prototype.readDoubleLE = function (t, e) {
        return e || M(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, c.prototype.readDoubleBE = function (t, e) {
        return e || M(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, c.prototype.writeUIntLE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || T(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < n && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + n;
      }, c.prototype.writeUIntBE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || T(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var i = n - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + n;
      }, c.prototype.writeUInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, c.prototype.writeUInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : I(this, t, e, !0), e + 2;
      }, c.prototype.writeUInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : I(this, t, e, !1), e + 2;
      }, c.prototype.writeUInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : D(this, t, e, !0), e + 4;
      }, c.prototype.writeUInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : D(this, t, e, !1), e + 4;
      }, c.prototype.writeIntLE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          T(this, t, e, n, i - 1, -i);
        }

        var o = 0,
            a = 1,
            u = 0;

        for (this[e] = 255 & t; ++o < n && (a *= 256);) {
          t < 0 && 0 === u && 0 !== this[e + o - 1] && (u = 1), this[e + o] = (t / a >> 0) - u & 255;
        }

        return e + n;
      }, c.prototype.writeIntBE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          T(this, t, e, n, i - 1, -i);
        }

        var o = n - 1,
            a = 1,
            u = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
          t < 0 && 0 === u && 0 !== this[e + o + 1] && (u = 1), this[e + o] = (t / a >> 0) - u & 255;
        }

        return e + n;
      }, c.prototype.writeInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, c.prototype.writeInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : I(this, t, e, !0), e + 2;
      }, c.prototype.writeInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : I(this, t, e, !1), e + 2;
      }, c.prototype.writeInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : D(this, t, e, !0), e + 4;
      }, c.prototype.writeInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || T(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : D(this, t, e, !1), e + 4;
      }, c.prototype.writeFloatLE = function (t, e, n) {
        return L(this, t, e, !0, n);
      }, c.prototype.writeFloatBE = function (t, e, n) {
        return L(this, t, e, !1, n);
      }, c.prototype.writeDoubleLE = function (t, e, n) {
        return U(this, t, e, !0, n);
      }, c.prototype.writeDoubleBE = function (t, e, n) {
        return U(this, t, e, !1, n);
      }, c.prototype.copy = function (t, e, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
        var i,
            o = r - n;
        if (this === t && n < e && e < r) for (i = o - 1; i >= 0; --i) {
          t[i + e] = this[i + n];
        } else if (o < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          t[i + e] = this[i + n];
        } else Uint8Array.prototype.set.call(t, this.subarray(n, n + o), e);
        return o;
      }, c.prototype.fill = function (t, e, n, r) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (r = e, e = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !c.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < n) throw new RangeError("Out of range index");
        if (n <= e) return this;
        var o;
        if (e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < n; ++o) {
          this[o] = t;
        } else {
          var a = c.isBuffer(t) ? t : N(new c(t, r).toString()),
              u = a.length;

          for (o = 0; o < n - e; ++o) {
            this[o + e] = a[o % u];
          }
        }
        return this;
      };
      var z = /[^+\/0-9A-Za-z-_]/g;

      function B(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function N(t, e) {
        var n;
        e = e || 1 / 0;

        for (var r = t.length, i = null, o = [], a = 0; a < r; ++a) {
          if ((n = t.charCodeAt(a)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === r) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = n;
              continue;
            }

            if (n < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = n;
              continue;
            }

            n = 65536 + (i - 55296 << 10 | n - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, n < 128) {
            if ((e -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((e -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((e -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }

        return o;
      }

      function W(t) {
        return r.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(z, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function F(t, e, n, r) {
        for (var i = 0; i < r && !(i + n >= e.length || i >= t.length); ++i) {
          e[i + n] = t[i];
        }

        return i;
      }
    }).call(this, n(12));
  }, function (t, e, n) {
    (function (t) {
      function n(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === n(t);
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, e.isNull = function (t) {
        return null === t;
      }, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = function (t) {
        return "number" == typeof t;
      }, e.isString = function (t) {
        return "string" == typeof t;
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = function (t) {
        return void 0 === t;
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === n(t);
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t;
      }, e.isDate = function (t) {
        return "[object Date]" === n(t);
      }, e.isError = function (t) {
        return "[object Error]" === n(t) || t instanceof Error;
      }, e.isFunction = function (t) {
        return "function" == typeof t;
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = t.isBuffer;
    }).call(this, n(21).Buffer);
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r,
          i,
          o,
          a,
          u,
          c,
          s,
          f,
          l,
          h,
          d,
          p,
          v = n(7),
          g = n(28),
          y = n(10),
          _ = n(8),
          m = n(9),
          b = (n(15), n(64)),
          w = n(20),
          x = n(65),
          E = {
        ctx: {
          binary: null
        },
        dom: {
          binary: null
        }
      },
          A = {
        x: 0,
        y: 0
      };

      function R(t) {
        var e,
            n,
            i,
            o,
            a,
            u,
            c,
            s = l.size.x,
            f = l.size.y,
            h = -l.size.x,
            d = -l.size.y;

        for (e = 0, n = 0; n < t.length; n++) {
          e += (o = t[n]).rad;
        }

        for ((e = (180 * (e /= t.length) / Math.PI + 90) % 180 - 90) < 0 && (e += 180), e = (180 - e) * Math.PI / 180, a = g.copy(g.create(), [Math.cos(e), Math.sin(e), -Math.sin(e), Math.cos(e)]), n = 0; n < t.length; n++) {
          for (o = t[n], i = 0; i < 4; i++) {
            v.transformMat2(o.box[i], o.box[i], a);
          }

          0;
        }

        for (n = 0; n < t.length; n++) {
          for (o = t[n], i = 0; i < 4; i++) {
            o.box[i][0] < s && (s = o.box[i][0]), o.box[i][0] > h && (h = o.box[i][0]), o.box[i][1] < f && (f = o.box[i][1]), o.box[i][1] > d && (d = o.box[i][1]);
          }
        }

        for (u = [[s, f], [h, f], [h, d], [s, d]], c = r.halfSample ? 2 : 1, a = g.invert(a, a), i = 0; i < 4; i++) {
          v.transformMat2(u[i], u[i], a);
        }

        for (i = 0; i < 4; i++) {
          v.scale(u[i], u[i], c);
        }

        return u;
      }

      function S(t, e) {
        l.subImageAsCopy(a, Object(_.imageRef)(t, e)), p.skeletonize();
      }

      function O(t, e, n, r) {
        var i,
            o,
            u,
            c,
            s = [],
            f = [],
            l = Math.ceil(h.x / 3);

        if (t.length >= 2) {
          for (i = 0; i < t.length; i++) {
            t[i].m00 > l && s.push(t[i]);
          }

          if (s.length >= 2) {
            for (u = function (t) {
              var e = Object(_.cluster)(t, .9),
                  n = Object(_.topGeneric)(e, 1, function (t) {
                return t.getPoints().length;
              }),
                  r = [],
                  i = [];

              if (1 === n.length) {
                r = n[0].item.getPoints();

                for (var o = 0; o < r.length; o++) {
                  i.push(r[o].point);
                }
              }

              return i;
            }(s), o = 0, i = 0; i < u.length; i++) {
              o += u[i].rad;
            }

            u.length > 1 && u.length >= s.length / 4 * 3 && u.length > t.length / 4 && (o /= u.length, c = {
              index: e[1] * A.x + e[0],
              pos: {
                x: n,
                y: r
              },
              box: [v.clone([n, r]), v.clone([n + a.size.x, r]), v.clone([n + a.size.x, r + a.size.y]), v.clone([n, r + a.size.y])],
              moments: u,
              rad: o,
              vec: v.clone([Math.cos(o), Math.sin(o)])
            }, f.push(c));
          }
        }

        return f;
      }

      e.a = {
        init: function init(e, n) {
          r = n, d = e, function () {
            i = r.halfSample ? new y.a({
              x: d.size.x / 2 | 0,
              y: d.size.y / 2 | 0
            }) : d, h = Object(_.calculatePatchSize)(r.patchSize, i.size), A.x = i.size.x / h.x | 0, A.y = i.size.y / h.y | 0, l = new y.a(i.size, void 0, Uint8Array, !1), u = new y.a(h, void 0, Array, !0);
            var e = new ArrayBuffer(65536);
            a = new y.a(h, new Uint8Array(e, 0, h.x * h.y)), o = new y.a(h, new Uint8Array(e, h.x * h.y * 3, h.x * h.y), void 0, !0), p = Object(x.a)("undefined" != typeof window ? window : "undefined" != typeof self ? self : t, {
              size: h.x
            }, e), f = new y.a({
              x: i.size.x / a.size.x | 0,
              y: i.size.y / a.size.y | 0
            }, void 0, Array, !0), c = new y.a(f.size, void 0, void 0, !0), s = new y.a(f.size, void 0, Int32Array, !0);
          }(), r.useWorker || "undefined" == typeof document || (E.dom.binary = document.createElement("canvas"), E.dom.binary.className = "binaryBuffer", E.ctx.binary = E.dom.binary.getContext("2d"), E.dom.binary.width = l.size.x, E.dom.binary.height = l.size.y);
        },
        locate: function locate() {
          r.halfSample && Object(_.halfSample)(d, i), Object(_.otsuThreshold)(i, l), l.zeroBorder();

          var t = function () {
            var t,
                e,
                n,
                r,
                i,
                c,
                s = [];

            for (t = 0; t < A.x; t++) {
              for (e = 0; e < A.y; e++) {
                S(n = a.size.x * t, r = a.size.y * e), o.zeroBorder(), m.a.init(u.data, 0), c = b.a.create(o, u).rasterize(0), i = u.moments(c.count), s = s.concat(O(i, [t, e], n, r));
              }
            }

            return s;
          }();

          if (t.length < A.x * A.y * .05) return null;

          var e = function (t) {
            var e,
                n,
                r = 0,
                i = 0;

            function o() {
              var t;

              for (t = 0; t < s.data.length; t++) {
                if (0 === s.data[t] && 1 === c.data[t]) return t;
              }

              return s.length;
            }

            function a(t) {
              var e,
                  n,
                  i,
                  o,
                  u,
                  l = t % s.size.x,
                  h = t / s.size.x | 0;
              if (t < s.data.length) for (i = f.data[t], s.data[t] = r, u = 0; u < w.a.searchDirections.length; u++) {
                n = h + w.a.searchDirections[u][0], e = l + w.a.searchDirections[u][1], o = n * s.size.x + e, 0 !== c.data[o] ? 0 === s.data[o] && Math.abs(v.dot(f.data[o].vec, i.vec)) > .95 && a(o) : s.data[o] = Number.MAX_VALUE;
              }
            }

            for (m.a.init(c.data, 0), m.a.init(s.data, 0), m.a.init(f.data, null), e = 0; e < t.length; e++) {
              n = t[e], f.data[n.index] = n, c.data[n.index] = 1;
            }

            for (c.zeroBorder(); (i = o()) < s.data.length;) {
              r++, a(i);
            }

            return r;
          }(t);

          if (e < 1) return null;

          var n = function (t) {
            var e,
                n,
                r = [];

            for (e = 0; e < t; e++) {
              r.push(0);
            }

            for (n = s.data.length; n--;) {
              s.data[n] > 0 && r[s.data[n] - 1]++;
            }

            return (r = r.map(function (t, e) {
              return {
                val: t,
                label: e + 1
              };
            })).sort(function (t, e) {
              return e.val - t.val;
            }), r.filter(function (t) {
              return t.val >= 5;
            });
          }(e);

          return 0 === n.length ? null : function (t, e) {
            var n,
                r,
                i,
                o,
                a = [],
                u = [];

            for (n = 0; n < t.length; n++) {
              for (r = s.data.length, a.length = 0; r--;) {
                s.data[r] === t[n].label && (i = f.data[r], a.push(i));
              }

              (o = R(a)) && u.push(o);
            }

            return u;
          }(n);
        },
        checkImageConstraints: function checkImageConstraints(t, e) {
          var n,
              r,
              i = t.getWidth(),
              o = t.getHeight(),
              a = e.halfSample ? .5 : 1;
          t.getConfig().area && (r = Object(_.computeImageArea)(i, o, t.getConfig().area), t.setTopRight({
            x: r.sx,
            y: r.sy
          }), t.setCanvasSize({
            x: i,
            y: o
          }), i = r.sw, o = r.sh);
          var u = {
            x: Math.floor(i * a),
            y: Math.floor(o * a)
          };
          if (n = Object(_.calculatePatchSize)(e.patchSize, u), t.setWidth(Math.floor(Math.floor(u.x / n.x) * (1 / a) * n.x)), t.setHeight(Math.floor(Math.floor(u.y / n.y) * (1 / a) * n.y)), t.getWidth() % n.x == 0 && t.getHeight() % n.y == 0) return !0;
          throw new Error("Image dimensions do not comply with the current settings: Width (".concat(i, " )and height (").concat(o, ") must a multiple of ").concat(n.x));
        }
      };
    }).call(this, n(12));
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function nextTick(t, n, r, i) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var o,
              a,
              u = arguments.length;

          switch (u) {
            case 0:
            case 1:
              return e.nextTick(t);

            case 2:
              return e.nextTick(function () {
                t.call(null, n);
              });

            case 3:
              return e.nextTick(function () {
                t.call(null, n, r);
              });

            case 4:
              return e.nextTick(function () {
                t.call(null, n, r, i);
              });

            default:
              for (o = new Array(u - 1), a = 0; a < o.length;) {
                o[a++] = arguments[a];
              }

              return e.nextTick(function () {
                t.apply(null, o);
              });
          }
        }
      } : t.exports = e;
    }).call(this, n(13));
  }, function (t, e, n) {
    var r = n(69),
        i = n(70),
        o = n(34),
        a = n(71);

    t.exports = function (t, e) {
      return r(t) || i(t, e) || o(t, e) || a();
    };
  }, function (t, e, n) {
    var r = n(142),
        i = n(143),
        o = n(34),
        a = n(144);

    t.exports = function (t) {
      return r(t) || i(t) || o(t) || a();
    };
  }, function (t, e) {
    function n(t, e, n, r, i, o, a) {
      try {
        var u = t[o](a),
            c = u.value;
      } catch (t) {
        return void n(t);
      }

      u.done ? e(c) : Promise.resolve(c).then(r, i);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (i, o) {
          var a = t.apply(e, r);

          function u(t) {
            n(a, i, o, u, c, "next", t);
          }

          function c(t) {
            n(a, i, o, u, c, "throw", t);
          }

          u(void 0);
        });
      };
    };
  }, function (t, e, n) {
    t.exports = {
      determinant: n(147),
      transpose: n(148),
      multiply: n(149),
      identity: n(150),
      adjoint: n(151),
      rotate: n(152),
      invert: n(153),
      create: n(154),
      scale: n(155),
      copy: n(156),
      frob: n(157),
      ldu: n(158)
    };
  }, function (t, e, n) {
    var r = n(163),
        i = n(164),
        o = "undefined" != typeof Float64Array;

    function a(t, e) {
      return t[0] - e[0];
    }

    function u() {
      var t,
          e = this.stride,
          n = new Array(e.length);

      for (t = 0; t < n.length; ++t) {
        n[t] = [Math.abs(e[t]), t];
      }

      n.sort(a);
      var r = new Array(n.length);

      for (t = 0; t < r.length; ++t) {
        r[t] = n[t][1];
      }

      return r;
    }

    function c(t, e) {
      var n = ["View", e, "d", t].join("");
      e < 0 && (n = "View_Nil" + t);
      var i = "generic" === t;

      if (-1 === e) {
        var o = "function " + n + "(a){this.data=a;};var proto=" + n + ".prototype;proto.dtype='" + t + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + n + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + n + "(a){return new " + n + "(a);}";
        return new Function(o)();
      }

      if (0 === e) {
        o = "function " + n + "(a,d) {this.data = a;this.offset = d};var proto=" + n + ".prototype;proto.dtype='" + t + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + n + "_copy() {return new " + n + "(this.data,this.offset)};proto.pick=function " + n + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + n + "_get(){return " + (i ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + n + "_set(v){return " + (i ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + n + "(a,b,c,d){return new " + n + "(a,d)}";
        return new Function("TrivialArray", o)(s[t][0]);
      }

      o = ["'use strict'"];
      var a = r(e),
          c = a.map(function (t) {
        return "i" + t;
      }),
          f = "this.offset+" + a.map(function (t) {
        return "this.stride[" + t + "]*i" + t;
      }).join("+"),
          l = a.map(function (t) {
        return "b" + t;
      }).join(","),
          h = a.map(function (t) {
        return "c" + t;
      }).join(",");
      o.push("function " + n + "(a," + l + "," + h + ",d){this.data=a", "this.shape=[" + l + "]", "this.stride=[" + h + "]", "this.offset=d|0}", "var proto=" + n + ".prototype", "proto.dtype='" + t + "'", "proto.dimension=" + e), o.push("Object.defineProperty(proto,'size',{get:function " + n + "_size(){return " + a.map(function (t) {
        return "this.shape[" + t + "]";
      }).join("*"), "}})"), 1 === e ? o.push("proto.order=[0]") : (o.push("Object.defineProperty(proto,'order',{get:"), e < 4 ? (o.push("function " + n + "_order(){"), 2 === e ? o.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})") : 3 === e && o.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})")) : o.push("ORDER})")), o.push("proto.set=function " + n + "_set(" + c.join(",") + ",v){"), i ? o.push("return this.data.set(" + f + ",v)}") : o.push("return this.data[" + f + "]=v}"), o.push("proto.get=function " + n + "_get(" + c.join(",") + "){"), i ? o.push("return this.data.get(" + f + ")}") : o.push("return this.data[" + f + "]}"), o.push("proto.index=function " + n + "_index(", c.join(), "){return " + f + "}"), o.push("proto.hi=function " + n + "_hi(" + c.join(",") + "){return new " + n + "(this.data," + a.map(function (t) {
        return ["(typeof i", t, "!=='number'||i", t, "<0)?this.shape[", t, "]:i", t, "|0"].join("");
      }).join(",") + "," + a.map(function (t) {
        return "this.stride[" + t + "]";
      }).join(",") + ",this.offset)}");
      var d = a.map(function (t) {
        return "a" + t + "=this.shape[" + t + "]";
      }),
          p = a.map(function (t) {
        return "c" + t + "=this.stride[" + t + "]";
      });
      o.push("proto.lo=function " + n + "_lo(" + c.join(",") + "){var b=this.offset,d=0," + d.join(",") + "," + p.join(","));

      for (var v = 0; v < e; ++v) {
        o.push("if(typeof i" + v + "==='number'&&i" + v + ">=0){d=i" + v + "|0;b+=c" + v + "*d;a" + v + "-=d}");
      }

      o.push("return new " + n + "(this.data," + a.map(function (t) {
        return "a" + t;
      }).join(",") + "," + a.map(function (t) {
        return "c" + t;
      }).join(",") + ",b)}"), o.push("proto.step=function " + n + "_step(" + c.join(",") + "){var " + a.map(function (t) {
        return "a" + t + "=this.shape[" + t + "]";
      }).join(",") + "," + a.map(function (t) {
        return "b" + t + "=this.stride[" + t + "]";
      }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");

      for (v = 0; v < e; ++v) {
        o.push("if(typeof i" + v + "==='number'){d=i" + v + "|0;if(d<0){c+=b" + v + "*(a" + v + "-1);a" + v + "=ceil(-a" + v + "/d)}else{a" + v + "=ceil(a" + v + "/d)}b" + v + "*=d}");
      }

      o.push("return new " + n + "(this.data," + a.map(function (t) {
        return "a" + t;
      }).join(",") + "," + a.map(function (t) {
        return "b" + t;
      }).join(",") + ",c)}");
      var g = new Array(e),
          y = new Array(e);

      for (v = 0; v < e; ++v) {
        g[v] = "a[i" + v + "]", y[v] = "b[i" + v + "]";
      }

      o.push("proto.transpose=function " + n + "_transpose(" + c + "){" + c.map(function (t, e) {
        return t + "=(" + t + "===undefined?" + e + ":" + t + "|0)";
      }).join(";"), "var a=this.shape,b=this.stride;return new " + n + "(this.data," + g.join(",") + "," + y.join(",") + ",this.offset)}"), o.push("proto.pick=function " + n + "_pick(" + c + "){var a=[],b=[],c=this.offset");

      for (v = 0; v < e; ++v) {
        o.push("if(typeof i" + v + "==='number'&&i" + v + ">=0){c=(c+this.stride[" + v + "]*i" + v + ")|0}else{a.push(this.shape[" + v + "]);b.push(this.stride[" + v + "])}");
      }

      return o.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}"), o.push("return function construct_" + n + "(data,shape,stride,offset){return new " + n + "(data," + a.map(function (t) {
        return "shape[" + t + "]";
      }).join(",") + "," + a.map(function (t) {
        return "stride[" + t + "]";
      }).join(",") + ",offset)}"), new Function("CTOR_LIST", "ORDER", o.join("\n"))(s[t], u);
    }

    var s = {
      float32: [],
      float64: [],
      int8: [],
      int16: [],
      int32: [],
      uint8: [],
      uint16: [],
      uint32: [],
      array: [],
      uint8_clamped: [],
      bigint64: [],
      biguint64: [],
      buffer: [],
      generic: []
    };

    t.exports = function (t, e, n, r) {
      if (void 0 === t) return (0, s.array[0])([]);
      "number" == typeof t && (t = [t]), void 0 === e && (e = [t.length]);
      var a = e.length;

      if (void 0 === n) {
        n = new Array(a);

        for (var u = a - 1, f = 1; u >= 0; --u) {
          n[u] = f, f *= e[u];
        }
      }

      if (void 0 === r) {
        r = 0;

        for (u = 0; u < a; ++u) {
          n[u] < 0 && (r -= (e[u] - 1) * n[u]);
        }
      }

      for (var l = function (t) {
        if (i(t)) return "buffer";
        if (o) switch (Object.prototype.toString.call(t)) {
          case "[object Float64Array]":
            return "float64";

          case "[object Float32Array]":
            return "float32";

          case "[object Int8Array]":
            return "int8";

          case "[object Int16Array]":
            return "int16";

          case "[object Int32Array]":
            return "int32";

          case "[object Uint8Array]":
            return "uint8";

          case "[object Uint16Array]":
            return "uint16";

          case "[object Uint32Array]":
            return "uint32";

          case "[object Uint8ClampedArray]":
            return "uint8_clamped";

          case "[object BigInt64Array]":
            return "bigint64";

          case "[object BigUint64Array]":
            return "biguint64";
        }
        return Array.isArray(t) ? "array" : "generic";
      }(t), h = s[l]; h.length <= a + 1;) {
        h.push(c(l, h.length - 1));
      }

      return (0, h[a + 1])(t, e, n, r);
    };
  }, function (t, e, n) {
    "use strict";

    var r,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, n) {
      return Function.prototype.apply.call(t, e, n);
    };
    r = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var a = Number.isNaN || function (t) {
      return t != t;
    };

    function u() {
      u.init.call(this);
    }

    t.exports = u, u.EventEmitter = u, u.prototype._events = void 0, u.prototype._eventsCount = 0, u.prototype._maxListeners = void 0;
    var c = 10;

    function s(t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    }

    function f(t) {
      return void 0 === t._maxListeners ? u.defaultMaxListeners : t._maxListeners;
    }

    function l(t, e, n, r) {
      var i, o, a, u;
      if (s(n), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, n.listener ? n.listener : n), o = t._events), a = o[e]), void 0 === a) a = o[e] = n, ++t._eventsCount;else if ("function" == typeof a ? a = o[e] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (i = f(t)) > 0 && a.length > i && !a.warned) {
        a.warned = !0;
        var c = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        c.name = "MaxListenersExceededWarning", c.emitter = t, c.type = e, c.count = a.length, u = c, console && console.warn && console.warn(u);
      }
      return t;
    }

    function h() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }

    function d(t, e, n) {
      var r = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: n
      },
          i = h.bind(r);
      return i.listener = n, r.wrapFn = i, i;
    }

    function p(t, e, n) {
      var r = t._events;
      if (void 0 === r) return [];
      var i = r[e];
      return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (t) {
        for (var e = new Array(t.length), n = 0; n < e.length; ++n) {
          e[n] = t[n].listener || t[n];
        }

        return e;
      }(i) : g(i, i.length);
    }

    function v(t) {
      var e = this._events;

      if (void 0 !== e) {
        var n = e[t];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length;
      }

      return 0;
    }

    function g(t, e) {
      for (var n = new Array(e), r = 0; r < e; ++r) {
        n[r] = t[r];
      }

      return n;
    }

    Object.defineProperty(u, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return c;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        c = t;
      }
    }), u.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, u.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, u.prototype.getMaxListeners = function () {
      return f(this);
    }, u.prototype.emit = function (t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e.push(arguments[n]);
      }

      var r = "error" === t,
          i = this._events;
      if (void 0 !== i) r = r && void 0 === i.error;else if (!r) return !1;

      if (r) {
        var a;
        if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
        var u = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw u.context = a, u;
      }

      var c = i[t];
      if (void 0 === c) return !1;
      if ("function" == typeof c) o(c, this, e);else {
        var s = c.length,
            f = g(c, s);

        for (n = 0; n < s; ++n) {
          o(f[n], this, e);
        }
      }
      return !0;
    }, u.prototype.addListener = function (t, e) {
      return l(this, t, e, !1);
    }, u.prototype.on = u.prototype.addListener, u.prototype.prependListener = function (t, e) {
      return l(this, t, e, !0);
    }, u.prototype.once = function (t, e) {
      return s(e), this.on(t, d(this, t, e)), this;
    }, u.prototype.prependOnceListener = function (t, e) {
      return s(e), this.prependListener(t, d(this, t, e)), this;
    }, u.prototype.removeListener = function (t, e) {
      var n, r, i, o, a;
      if (s(e), void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[t])) return this;
      if (n === e || n.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[t], r.removeListener && this.emit("removeListener", t, n.listener || e));else if ("function" != typeof n) {
        for (i = -1, o = n.length - 1; o >= 0; o--) {
          if (n[o] === e || n[o].listener === e) {
            a = n[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? n.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(n, i), 1 === n.length && (r[t] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", t, a || e);
      }
      return this;
    }, u.prototype.off = u.prototype.removeListener, u.prototype.removeAllListeners = function (t) {
      var e, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(n);

        for (r = 0; r < o.length; ++r) {
          "removeListener" !== (i = o[r]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = n[t])) this.removeListener(t, e);else if (void 0 !== e) for (r = e.length - 1; r >= 0; r--) {
        this.removeListener(t, e[r]);
      }
      return this;
    }, u.prototype.listeners = function (t) {
      return p(this, t, !0);
    }, u.prototype.rawListeners = function (t) {
      return p(this, t, !1);
    }, u.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : v.call(t, e);
    }, u.prototype.listenerCount = v, u.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : [];
    };
  }, function (t, e, n) {
    (e = t.exports = n(57)).Stream = e, e.Readable = e, e.Writable = n(33), e.Duplex = n(14), e.Transform = n(61), e.PassThrough = n(182);
  }, function (t, e, n) {
    var r = n(21),
        i = r.Buffer;

    function o(t, e) {
      for (var n in t) {
        e[n] = t[n];
      }
    }

    function a(t, e, n) {
      return i(t, e, n);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (o(r, e), e.Buffer = a), o(i, a), a.from = function (t, e, n) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, n);
    }, a.alloc = function (t, e, n) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var r = i(t);
      return void 0 !== e ? "string" == typeof n ? r.fill(e, n) : r.fill(e) : r.fill(0), r;
    }, a.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, a.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return r.SlowBuffer(t);
    };
  }, function (t, e, n) {
    "use strict";

    (function (e, r, i) {
      var o = n(24);

      function a(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (t, e, n) {
            var r = t.entry;
            t.entry = null;

            for (; r;) {
              var i = r.callback;
              e.pendingcb--, i(n), r = r.next;
            }

            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
          }(e, t);
        };
      }

      t.exports = _;
      var u,
          c = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? r : o.nextTick;
      _.WritableState = y;
      var s = Object.create(n(22));
      s.inherits = n(18);

      var f = {
        deprecate: n(180)
      },
          l = n(58),
          h = n(32).Buffer,
          d = i.Uint8Array || function () {};

      var p,
          v = n(59);

      function g() {}

      function y(t, e) {
        u = u || n(14), t = t || {};
        var r = e instanceof u;
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            s = t.writableHighWaterMark,
            f = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : r && (s || 0 === s) ? s : f, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var l = !1 === t.decodeStrings;
        this.decodeStrings = !l, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          !function (t, e) {
            var n = t._writableState,
                r = n.sync,
                i = n.writecb;
            if (function (t) {
              t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(n), e) !function (t, e, n, r, i) {
              --e.pendingcb, n ? (o.nextTick(i, r), o.nextTick(A, t, e), t._writableState.errorEmitted = !0, t.emit("error", r)) : (i(r), t._writableState.errorEmitted = !0, t.emit("error", r), A(t, e));
            }(t, n, r, e, i);else {
              var a = x(n);
              a || n.corked || n.bufferProcessing || !n.bufferedRequest || w(t, n), r ? c(b, t, n, a, i) : b(t, n, a, i);
            }
          }(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
      }

      function _(t) {
        if (u = u || n(14), !(p.call(_, this) || this instanceof u)) return new _(t);
        this._writableState = new y(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), l.call(this);
      }

      function m(t, e, n, r, i, o, a) {
        e.writelen = r, e.writecb = a, e.writing = !0, e.sync = !0, n ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function b(t, e, n, r) {
        n || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
        }(t, e), e.pendingcb--, r(), A(t, e);
      }

      function w(t, e) {
        e.bufferProcessing = !0;
        var n = e.bufferedRequest;

        if (t._writev && n && n.next) {
          var r = e.bufferedRequestCount,
              i = new Array(r),
              o = e.corkedRequestsFree;
          o.entry = n;

          for (var u = 0, c = !0; n;) {
            i[u] = n, n.isBuf || (c = !1), n = n.next, u += 1;
          }

          i.allBuffers = c, m(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0;
        } else {
          for (; n;) {
            var s = n.chunk,
                f = n.encoding,
                l = n.callback;
            if (m(t, e, !1, e.objectMode ? 1 : s.length, s, f, l), n = n.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === n && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = n, e.bufferProcessing = !1;
      }

      function x(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function E(t, e) {
        t._final(function (n) {
          e.pendingcb--, n && t.emit("error", n), e.prefinished = !0, t.emit("prefinish"), A(t, e);
        });
      }

      function A(t, e) {
        var n = x(e);
        return n && (!function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(E, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), n;
      }

      s.inherits(_, l), y.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(y.prototype, "buffer", {
            get: f.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(_, Symbol.hasInstance, {
        value: function value(t) {
          return !!p.call(this, t) || this === _ && t && t._writableState instanceof y;
        }
      })) : p = function p(t) {
        return t instanceof this;
      }, _.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, _.prototype.write = function (t, e, n) {
        var r,
            i = this._writableState,
            a = !1,
            u = !i.objectMode && (r = t, h.isBuffer(r) || r instanceof d);
        return u && !h.isBuffer(t) && (t = function (t) {
          return h.from(t);
        }(t)), "function" == typeof e && (n = e, e = null), u ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof n && (n = g), i.ended ? function (t, e) {
          var n = new Error("write after end");
          t.emit("error", n), o.nextTick(e, n);
        }(this, n) : (u || function (t, e, n, r) {
          var i = !0,
              a = !1;
          return null === n ? a = new TypeError("May not write null values to stream") : "string" == typeof n || void 0 === n || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(r, a), i = !1), i;
        }(this, i, t, n)) && (i.pendingcb++, a = function (t, e, n, r, i, o) {
          if (!n) {
            var a = function (t, e, n) {
              t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = h.from(e, n));
              return e;
            }(e, r, i);

            r !== a && (n = !0, i = "buffer", r = a);
          }

          var u = e.objectMode ? 1 : r.length;
          e.length += u;
          var c = e.length < e.highWaterMark;
          c || (e.needDrain = !0);

          if (e.writing || e.corked) {
            var s = e.lastBufferedRequest;
            e.lastBufferedRequest = {
              chunk: r,
              encoding: i,
              isBuf: n,
              callback: o,
              next: null
            }, s ? s.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
          } else m(t, e, !1, u, r, i, o);

          return c;
        }(this, i, u, t, e, n)), a;
      }, _.prototype.cork = function () {
        this._writableState.corked++;
      }, _.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || w(this, t));
      }, _.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, Object.defineProperty(_.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), _.prototype._write = function (t, e, n) {
        n(new Error("_write() is not implemented"));
      }, _.prototype._writev = null, _.prototype.end = function (t, e, n) {
        var r = this._writableState;
        "function" == typeof t ? (n = t, t = null, e = null) : "function" == typeof e && (n = e, e = null), null != t && this.write(t, e), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (t, e, n) {
          e.ending = !0, A(t, e), n && (e.finished ? o.nextTick(n) : t.once("finish", n));
          e.ended = !0, t.writable = !1;
        }(this, r, n);
      }, Object.defineProperty(_.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), _.prototype.destroy = v.destroy, _.prototype._undestroy = v.undestroy, _.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(this, n(13), n(178).setImmediate, n(12));
  }, function (t, e, n) {
    var r = n(35);

    t.exports = function (t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
      }
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var n = 0, r = new Array(e); n < e; n++) {
        r[n] = t[n];
      }

      return r;
    };
  }, function (t, e) {
    t.exports = 1e-6;
  }, function (t, e) {
    t.exports = function () {
      var t = new Float32Array(2);
      return t[0] = 0, t[1] = 0, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] - n[0], t[1] = e[1] - n[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] * n[0], t[1] = e[1] * n[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] / n[0], t[1] = e[1] / n[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0] - t[0],
          r = e[1] - t[1];
      return Math.sqrt(n * n + r * r);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0] - t[0],
          r = e[1] - t[1];
      return n * n + r * r;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = t[0],
          n = t[1];
      return Math.sqrt(e * e + n * n);
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = t[0],
          n = t[1];
      return e * e + n * n;
    };
  }, function (t, e) {
    t.exports = 1e-6;
  }, function (t, e) {
    t.exports = function () {
      var t = new Float32Array(3);
      return t[0] = 0, t[1] = 0, t[2] = 0, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = new Float32Array(3);
      return r[0] = t, r[1] = e, r[2] = n, r;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0],
          r = e[1],
          i = e[2],
          o = n * n + r * r + i * i;
      o > 0 && (o = 1 / Math.sqrt(o), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o);
      return t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] - n[0], t[1] = e[1] - n[1], t[2] = e[2] - n[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] * n[0], t[1] = e[1] * n[1], t[2] = e[2] * n[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] / n[0], t[1] = e[1] / n[1], t[2] = e[2] / n[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0] - t[0],
          r = e[1] - t[1],
          i = e[2] - t[2];
      return Math.sqrt(n * n + r * r + i * i);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0] - t[0],
          r = e[1] - t[1],
          i = e[2] - t[2];
      return n * n + r * r + i * i;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = t[0],
          n = t[1],
          r = t[2];
      return Math.sqrt(e * e + n * n + r * r);
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = t[0],
          n = t[1],
          r = t[2];
      return e * e + n * n + r * r;
    };
  }, function (t, e, n) {
    "use strict";

    (function (e, r) {
      var i = n(24);
      t.exports = m;
      var o,
          a = n(174);
      m.ReadableState = _;
      n(30).EventEmitter;

      var u = function u(t, e) {
        return t.listeners(e).length;
      },
          c = n(58),
          s = n(32).Buffer,
          f = e.Uint8Array || function () {};

      var l = Object.create(n(22));
      l.inherits = n(18);
      var h = n(175),
          d = void 0;
      d = h && h.debuglog ? h.debuglog("stream") : function () {};
      var p,
          v = n(176),
          g = n(59);
      l.inherits(m, c);
      var y = ["error", "close", "destroy", "pause", "resume"];

      function _(t, e) {
        t = t || {};
        var r = e instanceof (o = o || n(14));
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            a = t.readableHighWaterMark,
            u = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : r && (a || 0 === a) ? a : u, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new v(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = n(60).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
      }

      function m(t) {
        if (o = o || n(14), !(this instanceof m)) return new m(t);
        this._readableState = new _(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), c.call(this);
      }

      function b(t, e, n, r, i) {
        var o,
            a = t._readableState;
        null === e ? (a.reading = !1, function (t, e) {
          if (e.ended) return;

          if (e.decoder) {
            var n = e.decoder.end();
            n && n.length && (e.buffer.push(n), e.length += e.objectMode ? 1 : n.length);
          }

          e.ended = !0, E(t);
        }(t, a)) : (i || (o = function (t, e) {
          var n;
          r = e, s.isBuffer(r) || r instanceof f || "string" == typeof e || void 0 === e || t.objectMode || (n = new TypeError("Invalid non-string/buffer chunk"));
          var r;
          return n;
        }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === s.prototype || (e = function (t) {
          return s.from(t);
        }(e)), r ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !n ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? w(t, a, e, !1) : R(t, a)) : w(t, a, e, !1))) : r || (a.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
        }(a);
      }

      function w(t, e, n, r) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", n), t.read(0)) : (e.length += e.objectMode ? 1 : n.length, r ? e.buffer.unshift(n) : e.buffer.push(n), e.needReadable && E(t)), R(t, e);
      }

      Object.defineProperty(m.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), m.prototype.destroy = g.destroy, m.prototype._undestroy = g.undestroy, m.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, m.prototype.push = function (t, e) {
        var n,
            r = this._readableState;
        return r.objectMode ? n = !0 : "string" == typeof t && ((e = e || r.defaultEncoding) !== r.encoding && (t = s.from(t, e), e = ""), n = !0), b(this, t, e, !1, n);
      }, m.prototype.unshift = function (t) {
        return b(this, t, null, !0, !1);
      }, m.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, m.prototype.setEncoding = function (t) {
        return p || (p = n(60).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
      };

      function x(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= 8388608 ? t = 8388608 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function E(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(A, t) : A(t));
      }

      function A(t) {
        d("emit readable"), t.emit("readable"), C(t);
      }

      function R(t, e) {
        e.readingMore || (e.readingMore = !0, i.nextTick(S, t, e));
      }

      function S(t, e) {
        for (var n = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), n !== e.length);) {
          n = e.length;
        }

        e.readingMore = !1;
      }

      function O(t) {
        d("readable nexttick read 0"), t.read(0);
      }

      function k(t, e) {
        e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), C(t), e.flowing && !e.reading && t.read(0);
      }

      function C(t) {
        var e = t._readableState;

        for (d("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function j(t, e) {
        return 0 === e.length ? null : (e.objectMode ? n = e.buffer.shift() : !t || t >= e.length ? (n = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : n = function (t, e, n) {
          var r;
          t < e.head.data.length ? (r = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : r = t === e.head.data.length ? e.shift() : n ? function (t, e) {
            var n = e.head,
                r = 1,
                i = n.data;
            t -= i.length;

            for (; n = n.next;) {
              var o = n.data,
                  a = t > o.length ? o.length : t;

              if (a === o.length ? i += o : i += o.slice(0, t), 0 === (t -= a)) {
                a === o.length ? (++r, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a));
                break;
              }

              ++r;
            }

            return e.length -= r, i;
          }(t, e) : function (t, e) {
            var n = s.allocUnsafe(t),
                r = e.head,
                i = 1;
            r.data.copy(n), t -= r.data.length;

            for (; r = r.next;) {
              var o = r.data,
                  a = t > o.length ? o.length : t;

              if (o.copy(n, n.length - t, 0, a), 0 === (t -= a)) {
                a === o.length ? (++i, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a));
                break;
              }

              ++i;
            }

            return e.length -= i, n;
          }(t, e);
          return r;
        }(t, e.buffer, e.decoder), n);
        var n;
      }

      function M(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, i.nextTick(T, e, t));
      }

      function T(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function I(t, e) {
        for (var n = 0, r = t.length; n < r; n++) {
          if (t[n] === e) return n;
        }

        return -1;
      }

      m.prototype.read = function (t) {
        d("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            n = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? M(this) : E(this), null;
        if (0 === (t = x(t, e)) && e.ended) return 0 === e.length && M(this), null;
        var r,
            i = e.needReadable;
        return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = x(n, e))), null === (r = t > 0 ? j(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), n !== t && e.ended && M(this)), null !== r && this.emit("data", r), r;
      }, m.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, m.prototype.pipe = function (t, e) {
        var n = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = t;
            break;

          case 1:
            o.pipes = [o.pipes, t];
            break;

          default:
            o.pipes.push(t);
        }

        o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
        var c = (!e || !1 !== e.end) && t !== r.stdout && t !== r.stderr ? f : m;

        function s(e, r) {
          d("onunpipe"), e === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), t.removeListener("close", y), t.removeListener("finish", _), t.removeListener("drain", l), t.removeListener("error", g), t.removeListener("unpipe", s), n.removeListener("end", f), n.removeListener("end", m), n.removeListener("data", v), h = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || l());
        }

        function f() {
          d("onend"), t.end();
        }

        o.endEmitted ? i.nextTick(c) : n.once("end", c), t.on("unpipe", s);

        var l = function (t) {
          return function () {
            var e = t._readableState;
            d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && u(t, "data") && (e.flowing = !0, C(t));
          };
        }(n);

        t.on("drain", l);
        var h = !1;
        var p = !1;

        function v(e) {
          d("ondata"), p = !1, !1 !== t.write(e) || p || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== I(o.pipes, t)) && !h && (d("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, p = !0), n.pause());
        }

        function g(e) {
          d("onerror", e), m(), t.removeListener("error", g), 0 === u(t, "error") && t.emit("error", e);
        }

        function y() {
          t.removeListener("finish", _), m();
        }

        function _() {
          d("onfinish"), t.removeListener("close", y), m();
        }

        function m() {
          d("unpipe"), n.unpipe(t);
        }

        return n.on("data", v), function (t, e, n) {
          if ("function" == typeof t.prependListener) return t.prependListener(e, n);
          t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(n) : t._events[e] = [n, t._events[e]] : t.on(e, n);
        }(t, "error", g), t.once("close", y), t.once("finish", _), t.emit("pipe", n), o.flowing || (d("pipe resume"), n.resume()), t;
      }, m.prototype.unpipe = function (t) {
        var e = this._readableState,
            n = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes || (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, n)), this;

        if (!t) {
          var r = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            r[o].emit("unpipe", this, n);
          }

          return this;
        }

        var a = I(e.pipes, t);
        return -1 === a || (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, n)), this;
      }, m.prototype.on = function (t, e) {
        var n = c.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var r = this._readableState;
          r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && E(this) : i.nextTick(O, this));
        }
        return n;
      }, m.prototype.addListener = m.prototype.on, m.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (d("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(k, t, e));
        }(this, t)), this;
      }, m.prototype.pause = function () {
        return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, m.prototype.wrap = function (t) {
        var e = this,
            n = this._readableState,
            r = !1;

        for (var i in t.on("end", function () {
          if (d("wrapped end"), n.decoder && !n.ended) {
            var t = n.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          (d("wrapped data"), n.decoder && (i = n.decoder.write(i)), n.objectMode && null == i) || (n.objectMode || i && i.length) && (e.push(i) || (r = !0, t.pause()));
        }), t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < y.length; o++) {
          t.on(y[o], this.emit.bind(this, y[o]));
        }

        return this._read = function (e) {
          d("wrapped _read", e), r && (r = !1, t.resume());
        }, this;
      }, Object.defineProperty(m.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), m._fromList = j;
    }).call(this, n(12), n(13));
  }, function (t, e, n) {
    t.exports = n(30).EventEmitter;
  }, function (t, e, n) {
    "use strict";

    var r = n(24);

    function i(t, e) {
      t.emit("error", e);
    }

    t.exports = {
      destroy: function destroy(t, e) {
        var n = this,
            o = this._readableState && this._readableState.destroyed,
            a = this._writableState && this._writableState.destroyed;
        return o || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || r.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
          !e && t ? (r.nextTick(i, n, t), n._writableState && (n._writableState.errorEmitted = !0)) : e && e(t);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(181).Buffer,
        i = r.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(t) {
      var e;

      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";

          for (var e;;) {
            switch (t) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return t;

              default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
            }
          }
        }(t);

        if ("string" != typeof e && (r.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
      }(t), this.encoding) {
        case "utf16le":
          this.text = c, this.end = s, e = 4;
          break;

        case "utf8":
          this.fillLast = u, e = 4;
          break;

        case "base64":
          this.text = f, this.end = l, e = 3;
          break;

        default:
          return this.write = h, void (this.end = d);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(e);
    }

    function a(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
    }

    function u(t) {
      var e = this.lastTotal - this.lastNeed,
          n = function (t, e, n) {
        if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

        if (t.lastNeed > 1 && e.length > 1) {
          if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
          if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
        }
      }(this, t);

      return void 0 !== n ? n : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function c(t, e) {
      if ((t.length - e) % 2 == 0) {
        var n = t.toString("utf16le", e);

        if (n) {
          var r = n.charCodeAt(n.length - 1);
          if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], n.slice(0, -1);
        }

        return n;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function s(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var n = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, n);
      }

      return e;
    }

    function f(t, e) {
      var n = (t.length - e) % 3;
      return 0 === n ? t.toString("base64", e) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - n));
    }

    function l(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function h(t) {
      return t.toString(this.encoding);
    }

    function d(t) {
      return t && t.length ? this.write(t) : "";
    }

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, n;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        n = this.lastNeed, this.lastNeed = 0;
      } else n = 0;

      return n < t.length ? e ? e + this.text(t, n) : this.text(t, n) : e || "";
    }, o.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e;
    }, o.prototype.text = function (t, e) {
      var n = function (t, e, n) {
        var r = e.length - 1;
        if (r < n) return 0;
        var i = a(e[r]);
        if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
        if (--r < n || -2 === i) return 0;
        if ((i = a(e[r])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
        if (--r < n || -2 === i) return 0;
        if ((i = a(e[r])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
        return 0;
      }(this, t, e);

      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = n;
      var r = t.length - (n - this.lastNeed);
      return t.copy(this.lastChar, 0, r), t.toString("utf8", e, r);
    }, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = a;
    var r = n(14),
        i = Object.create(n(22));

    function o(t, e) {
      var n = this._transformState;
      n.transforming = !1;
      var r = n.writecb;
      if (!r) return this.emit("error", new Error("write callback called multiple times"));
      n.writechunk = null, n.writecb = null, null != e && this.push(e), r(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function a(t) {
      if (!(this instanceof a)) return new a(t);
      r.call(this, t), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", u);
    }

    function u() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, n) {
        c(t, e, n);
      }) : c(this, null, null);
    }

    function c(t, e, n) {
      if (e) return t.emit("error", e);
      if (null != n && t.push(n), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    i.inherits = n(18), i.inherits(a, r), a.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, r.prototype.push.call(this, t, e);
    }, a.prototype._transform = function (t, e, n) {
      throw new Error("_transform() is not implemented");
    }, a.prototype._write = function (t, e, n) {
      var r = this._transformState;

      if (r.writecb = n, r.writechunk = t, r.writeencoding = e, !r.transforming) {
        var i = this._readableState;
        (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, a.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, a.prototype._destroy = function (t, e) {
      var n = this;

      r.prototype._destroy.call(this, t, function (t) {
        e(t), n.emit("close");
      });
    };
  }, function (t, e, n) {
    var r = n(8),
        i = n(29),
        o = n(188).d2,
        a = {
      create: function create(t) {
        var e = {},
            n = r.imageRef(t.getRealWidth(), t.getRealHeight()),
            a = t.getCanvasSize(),
            u = r.imageRef(t.getWidth(), t.getHeight()),
            c = t.getTopRight(),
            s = new Uint8Array(u.x * u.y),
            f = new Uint8Array(n.x * n.y),
            l = new Uint8Array(a.x * a.y),
            h = i(f, [n.y, n.x]).transpose(1, 0),
            d = i(l, [a.y, a.x]).transpose(1, 0),
            p = d.hi(c.x + u.x, c.y + u.y).lo(c.x, c.y),
            v = n.x / a.x,
            g = n.y / a.y;
        return e.attachData = function (t) {
          s = t;
        }, e.getData = function () {
          return s;
        }, e.grab = function () {
          var e = t.getFrame();
          return !!e && (this.scaleAndCrop(e), !0);
        }, e.scaleAndCrop = function (t) {
          r.computeGray(t.data, f);

          for (var e = 0; e < a.y; e++) {
            for (var n = 0; n < a.x; n++) {
              d.set(n, e, 0 | o(h, n * v, e * g));
            }
          }

          if (p.shape[0] !== u.x || p.shape[1] !== u.y) throw new Error("Shapes do not match!");

          for (var i = 0; i < u.y; i++) {
            for (var c = 0; c < u.x; c++) {
              s[i * u.x + c] = p.get(c, i);
            }
          }
        }, e.getSize = function () {
          return u;
        }, e;
      }
    };
    t.exports = a;
  }, function (t, e, n) {
    t.exports = {
      EPSILON: n(45),
      create: n(46),
      clone: n(107),
      angle: n(108),
      fromValues: n(47),
      copy: n(109),
      set: n(110),
      equals: n(111),
      exactEquals: n(112),
      add: n(113),
      subtract: n(50),
      sub: n(114),
      multiply: n(51),
      mul: n(115),
      divide: n(52),
      div: n(116),
      min: n(117),
      max: n(118),
      floor: n(119),
      ceil: n(120),
      round: n(121),
      scale: n(122),
      scaleAndAdd: n(123),
      distance: n(53),
      dist: n(124),
      squaredDistance: n(54),
      sqrDist: n(125),
      length: n(55),
      len: n(126),
      squaredLength: n(56),
      sqrLen: n(127),
      negate: n(128),
      inverse: n(129),
      normalize: n(48),
      dot: n(49),
      cross: n(130),
      lerp: n(131),
      random: n(132),
      transformMat4: n(133),
      transformMat3: n(134),
      transformQuat: n(135),
      rotateX: n(136),
      rotateY: n(137),
      rotateZ: n(138),
      forEach: n(139)
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(20),
        i = {
      createContour2D: function createContour2D() {
        return {
          dir: null,
          index: null,
          firstVertex: null,
          insideContours: null,
          nextpeer: null,
          prevpeer: null
        };
      },
      CONTOUR_DIR: {
        CW_DIR: 0,
        CCW_DIR: 1,
        UNKNOWN_DIR: 2
      },
      DIR: {
        OUTSIDE_EDGE: -32767,
        INSIDE_EDGE: -32766
      },
      create: function create(t, e) {
        var n = t.data,
            o = e.data,
            a = t.size.x,
            u = t.size.y,
            c = r.a.create(t, e);
        return {
          rasterize: function rasterize(t) {
            var e,
                r,
                s,
                f,
                l,
                h,
                d,
                p,
                v,
                g,
                y,
                _,
                m = [],
                b = 0;

            for (_ = 0; _ < 400; _++) {
              m[_] = 0;
            }

            for (m[0] = n[0], v = null, h = 1; h < u - 1; h++) {
              for (f = 0, r = m[0], l = 1; l < a - 1; l++) {
                if (0 === o[y = h * a + l]) {
                  if ((e = n[y]) !== r) {
                    if (0 === f) m[s = b + 1] = e, r = e, null !== (d = c.contourTracing(h, l, s, e, i.DIR.OUTSIDE_EDGE)) && (b++, f = s, (p = i.createContour2D()).dir = i.CONTOUR_DIR.CW_DIR, p.index = f, p.firstVertex = d, p.nextpeer = v, p.insideContours = null, null !== v && (v.prevpeer = p), v = p);else if (null !== (d = c.contourTracing(h, l, i.DIR.INSIDE_EDGE, e, f))) {
                      for ((p = i.createContour2D()).firstVertex = d, p.insideContours = null, p.dir = 0 === t ? i.CONTOUR_DIR.CCW_DIR : i.CONTOUR_DIR.CW_DIR, p.index = t, g = v; null !== g && g.index !== f;) {
                        g = g.nextpeer;
                      }

                      null !== g && (p.nextpeer = g.insideContours, null !== g.insideContours && (g.insideContours.prevpeer = p), g.insideContours = p);
                    }
                  } else o[y] = f;
                } else o[y] === i.DIR.OUTSIDE_EDGE || o[y] === i.DIR.INSIDE_EDGE ? (f = 0, r = o[y] === i.DIR.INSIDE_EDGE ? n[y] : m[0]) : r = m[f = o[y]];
              }
            }

            for (g = v; null !== g;) {
              g.index = t, g = g.nextpeer;
            }

            return {
              cc: v,
              count: b
            };
          },
          debug: {
            drawContour: function drawContour(t, e) {
              var n,
                  r,
                  o,
                  a = t.getContext("2d"),
                  u = e;

              for (a.strokeStyle = "red", a.fillStyle = "red", a.lineWidth = 1, n = null !== u ? u.insideContours : null; null !== u;) {
                switch (null !== n ? (r = n, n = n.nextpeer) : (r = u, n = null !== (u = u.nextpeer) ? u.insideContours : null), r.dir) {
                  case i.CONTOUR_DIR.CW_DIR:
                    a.strokeStyle = "red";
                    break;

                  case i.CONTOUR_DIR.CCW_DIR:
                    a.strokeStyle = "blue";
                    break;

                  case i.CONTOUR_DIR.UNKNOWN_DIR:
                    a.strokeStyle = "green";
                }

                o = r.firstVertex, a.beginPath(), a.moveTo(o.x, o.y);

                do {
                  o = o.next, a.lineTo(o.x, o.y);
                } while (o !== r.firstVertex);

                a.stroke();
              }
            }
          }
        };
      }
    };
    e.a = i;
  }, function (t, e, n) {
    "use strict";
    /* @preserve ASM BEGIN */

    /* @preserve ASM END */

    e.a = function (t, e, n) {
      "use asm";

      var r = new t.Uint8Array(n),
          i = e.size | 0,
          o = t.Math.imul;

      function a(t, e) {
        t |= 0;
        e |= 0;
        var n = 0;
        var o = 0;
        var a = 0;
        var u = 0;
        var c = 0;
        var s = 0;
        var f = 0;
        var l = 0;

        for (n = 1; (n | 0) < (i - 1 | 0); n = n + 1 | 0) {
          l = l + i | 0;

          for (o = 1; (o | 0) < (i - 1 | 0); o = o + 1 | 0) {
            u = l - i | 0;
            c = l + i | 0;
            s = o - 1 | 0;
            f = o + 1 | 0;
            a = (r[t + u + s | 0] | 0) + (r[t + u + f | 0] | 0) + (r[t + l + o | 0] | 0) + (r[t + c + s | 0] | 0) + (r[t + c + f | 0] | 0) | 0;

            if ((a | 0) == (5 | 0)) {
              r[e + l + o | 0] = 1;
            } else {
              r[e + l + o | 0] = 0;
            }
          }
        }
      }

      function u(t, e, n) {
        t |= 0;
        e |= 0;
        n |= 0;
        var a = 0;
        a = o(i, i) | 0;

        while ((a | 0) > 0) {
          a = a - 1 | 0;
          r[n + a | 0] = (r[t + a | 0] | 0) - (r[e + a | 0] | 0) | 0;
        }
      }

      function c(t, e, n) {
        t |= 0;
        e |= 0;
        n |= 0;
        var a = 0;
        a = o(i, i) | 0;

        while ((a | 0) > 0) {
          a = a - 1 | 0;
          r[n + a | 0] = r[t + a | 0] | 0 | (r[e + a | 0] | 0) | 0;
        }
      }

      function s(t) {
        t |= 0;
        var e = 0;
        var n = 0;
        n = o(i, i) | 0;

        while ((n | 0) > 0) {
          n = n - 1 | 0;
          e = (e | 0) + (r[t + n | 0] | 0) | 0;
        }

        return e | 0;
      }

      function f(t, e) {
        t |= 0;
        e |= 0;
        var n = 0;
        n = o(i, i) | 0;

        while ((n | 0) > 0) {
          n = n - 1 | 0;
          r[t + n | 0] = e;
        }
      }

      function l(t, e) {
        t |= 0;
        e |= 0;
        var n = 0;
        var o = 0;
        var a = 0;
        var u = 0;
        var c = 0;
        var s = 0;
        var f = 0;
        var l = 0;

        for (n = 1; (n | 0) < (i - 1 | 0); n = n + 1 | 0) {
          l = l + i | 0;

          for (o = 1; (o | 0) < (i - 1 | 0); o = o + 1 | 0) {
            u = l - i | 0;
            c = l + i | 0;
            s = o - 1 | 0;
            f = o + 1 | 0;
            a = (r[t + u + s | 0] | 0) + (r[t + u + f | 0] | 0) + (r[t + l + o | 0] | 0) + (r[t + c + s | 0] | 0) + (r[t + c + f | 0] | 0) | 0;

            if ((a | 0) > (0 | 0)) {
              r[e + l + o | 0] = 1;
            } else {
              r[e + l + o | 0] = 0;
            }
          }
        }
      }

      function h(t, e) {
        t |= 0;
        e |= 0;
        var n = 0;
        n = o(i, i) | 0;

        while ((n | 0) > 0) {
          n = n - 1 | 0;
          r[e + n | 0] = r[t + n | 0] | 0;
        }
      }

      function d(t) {
        t |= 0;
        var e = 0;
        var n = 0;

        for (e = 0; (e | 0) < (i - 1 | 0); e = e + 1 | 0) {
          r[t + e | 0] = 0;
          r[t + n | 0] = 0;
          n = n + i - 1 | 0;
          r[t + n | 0] = 0;
          n = n + 1 | 0;
        }

        for (e = 0; (e | 0) < (i | 0); e = e + 1 | 0) {
          r[t + n | 0] = 0;
          n = n + 1 | 0;
        }
      }

      function p() {
        var t = 0;
        var e = 0;
        var n = 0;
        var r = 0;
        var p = 0;
        var v = 0;
        e = o(i, i) | 0;
        n = e + e | 0;
        r = n + e | 0;
        f(r, 0);
        d(t);

        do {
          a(t, e);
          l(e, n);
          u(t, n, n);
          c(r, n, r);
          h(e, t);
          p = s(t) | 0;
          v = (p | 0) == 0 | 0;
        } while (!v);
      }

      return {
        skeletonize: p
      };
    };
  }, function (t, e, n) {
    "use strict";

    (function (e, r) {
      var i = n(162),
          o = n(29),
          a = n(165).GifReader,
          u = (n(166), n(172), n(187));

      function c(t, e) {
        var n;

        try {
          n = new a(t);
        } catch (t) {
          return void e(t);
        }

        if (n.numFrames() > 0) {
          var r = [n.numFrames(), n.height, n.width, 4],
              i = new Uint8Array(r[0] * r[1] * r[2] * r[3]),
              u = o(i, r);

          try {
            for (var c = 0; c < n.numFrames(); ++c) {
              n.decodeAndBlitFrameRGBA(c, i.subarray(u.index(c, 0, 0, 0), u.index(c + 1, 0, 0, 0)));
            }
          } catch (t) {
            return void e(t);
          }

          e(null, u.transpose(0, 2, 1));
        } else {
          r = [n.height, n.width, 4], i = new Uint8Array(r[0] * r[1] * r[2]), u = o(i, r);

          try {
            n.decodeAndBlitFrameRGBA(0, i);
          } catch (t) {
            return void e(t);
          }

          e(null, u.transpose(1, 0));
        }
      }

      function s(t, n) {
        e.nextTick(function () {
          try {
            var e = u(t);
            e ? c(function (t) {
              if (void 0 === t[0]) {
                for (var e = t.length, n = new Uint8Array(e), r = 0; r < e; ++r) {
                  n[r] = t.get(r);
                }

                return n;
              }

              return new Uint8Array(t);
            }(e), n) : n(new Error("Error parsing data URI"));
          } catch (t) {
            n(t);
          }
        });
      }

      t.exports = function (t, e, n) {
        n || (n = e, e = "");
        var a = i.extname(t);

        switch (e || a.toUpperCase()) {
          case ".GIF":
            !function (t, e) {
              var n = new XMLHttpRequest();
              n.open("GET", t, !0), n.responseType = "arraybuffer", n.overrideMimeType && n.overrideMimeType("application/binary"), n.onerror = function (t) {
                e(t);
              }, n.onload = function () {
                4 === n.readyState && c(new Uint8Array(n.response), e);
              }, n.send();
            }(t, n);
            break;

          default:
            r.isBuffer(t) && (t = "data:" + e + ";base64," + t.toString("base64")), 0 === t.indexOf("data:image/gif;") ? s(t, n) : function (t, e) {
              var n = new Image();
              n.crossOrigin = "Anonymous", n.onload = function () {
                var t = document.createElement("canvas");
                t.width = n.width, t.height = n.height;
                var r = t.getContext("2d");
                r.drawImage(n, 0, 0);
                var i = r.getImageData(0, 0, n.width, n.height);
                e(null, o(new Uint8Array(i.data), [n.width, n.height, 4], [4, 4 * n.width, 1], 0));
              }, n.onerror = function (t) {
                e(t);
              }, n.src = t;
            }(t, n);
        }
      };
    }).call(this, n(13), n(21).Buffer);
  }, function (t, e, n) {
    t.exports = n(189);
  }, function (t, e) {
    "undefined" != typeof window && (window.requestAnimationFrame || (window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (t) {
      window.setTimeout(t, 1e3 / 60);
    })), "function" != typeof Math.imul && (Math.imul = function (t, e) {
      var n = 65535 & t,
          r = 65535 & e;
      return n * r + ((t >>> 16 & 65535) * r + n * (e >>> 16 & 65535) << 16 >>> 0) | 0;
    }), "function" != typeof Object.assign && (Object.assign = function (t) {
      "use strict";

      if (null === t) throw new TypeError("Cannot convert undefined or null to object");

      for (var e = Object(t), n = 1; n < arguments.length; n++) {
        var r = arguments[n];
        if (null !== r) for (var i in r) {
          Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
        }
      }

      return e;
    });
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) return t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
        var n = [],
            r = !0,
            i = !1,
            o = void 0;

        try {
          for (var a, u = t[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          i = !0, o = t;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (i) throw o;
          }
        }

        return n;
      }
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = new Float32Array(2);
      return e[0] = t[0], e[1] = t[1], e;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = new Float32Array(2);
      return n[0] = t, n[1] = e, n;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e, t[1] = n, t;
    };
  }, function (t, e, n) {
    t.exports = function (t, e) {
      var n = t[0],
          i = t[1],
          o = e[0],
          a = e[1];
      return Math.abs(n - o) <= r * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - a) <= r * Math.max(1, Math.abs(i), Math.abs(a));
    };

    var r = n(36);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] === e[0] && t[1] === e[1];
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t;
    };
  }, function (t, e, n) {
    t.exports = n(38);
  }, function (t, e, n) {
    t.exports = n(39);
  }, function (t, e, n) {
    t.exports = n(40);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = 1 / e[0], t[1] = 1 / e[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = Math.min(e[0], n[0]), t[1] = Math.min(e[1], n[1]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = Math.max(e[0], n[0]), t[1] = Math.max(e[1], n[1]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = Math.cos(n),
          i = Math.sin(n),
          o = e[0],
          a = e[1];
      return t[0] = o * r - a * i, t[1] = o * i + a * r, t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] * n, t[1] = e[1] * n, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      return t[0] = e[0] + n[0] * r, t[1] = e[1] + n[1] * r, t;
    };
  }, function (t, e, n) {
    t.exports = n(41);
  }, function (t, e, n) {
    t.exports = n(42);
  }, function (t, e, n) {
    t.exports = n(43);
  }, function (t, e, n) {
    t.exports = n(44);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0],
          r = e[1],
          i = n * n + r * r;
      i > 0 && (i = 1 / Math.sqrt(i), t[0] = e[0] * i, t[1] = e[1] * i);
      return t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] * e[0] + t[1] * e[1];
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0] * n[1] - e[1] * n[0];
      return t[0] = t[1] = 0, t[2] = r, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      var i = e[0],
          o = e[1];
      return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      e = e || 1;
      var n = 2 * Math.random() * Math.PI;
      return t[0] = Math.cos(n) * e, t[1] = Math.sin(n) * e, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1];
      return t[0] = n[0] * r + n[2] * i, t[1] = n[1] * r + n[3] * i, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1];
      return t[0] = n[0] * r + n[2] * i + n[4], t[1] = n[1] * r + n[3] * i + n[5], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1];
      return t[0] = n[0] * r + n[3] * i + n[6], t[1] = n[1] * r + n[4] * i + n[7], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1];
      return t[0] = n[0] * r + n[4] * i + n[12], t[1] = n[1] * r + n[5] * i + n[13], t;
    };
  }, function (t, e, n) {
    t.exports = function (t, e, n, i, o, a) {
      var u, c;
      e || (e = 2);
      n || (n = 0);
      c = i ? Math.min(i * e + n, t.length) : t.length;

      for (u = n; u < c; u += e) {
        r[0] = t[u], r[1] = t[u + 1], o(r, r, a), t[u] = r[0], t[u + 1] = r[1];
      }

      return t;
    };

    var r = n(37)();
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0] * e[0] + e[1] * e[1];

      if (r > n * n) {
        var i = Math.sqrt(r);
        t[0] = e[0] / i * n, t[1] = e[1] / i * n;
      } else t[0] = e[0], t[1] = e[1];

      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = new Float32Array(3);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
    };
  }, function (t, e, n) {
    t.exports = function (t, e) {
      var n = r(t[0], t[1], t[2]),
          a = r(e[0], e[1], e[2]);
      i(n, n), i(a, a);
      var u = o(n, a);
      return u > 1 ? 0 : Math.acos(u);
    };

    var r = n(47),
        i = n(48),
        o = n(49);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      return t[0] = e, t[1] = n, t[2] = r, t;
    };
  }, function (t, e, n) {
    t.exports = function (t, e) {
      var n = t[0],
          i = t[1],
          o = t[2],
          a = e[0],
          u = e[1],
          c = e[2];
      return Math.abs(n - a) <= r * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - u) <= r * Math.max(1, Math.abs(i), Math.abs(u)) && Math.abs(o - c) <= r * Math.max(1, Math.abs(o), Math.abs(c));
    };

    var r = n(45);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2];
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t[2] = e[2] + n[2], t;
    };
  }, function (t, e, n) {
    t.exports = n(50);
  }, function (t, e, n) {
    t.exports = n(51);
  }, function (t, e, n) {
    t.exports = n(52);
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = Math.min(e[0], n[0]), t[1] = Math.min(e[1], n[1]), t[2] = Math.min(e[2], n[2]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = Math.max(e[0], n[0]), t[1] = Math.max(e[1], n[1]), t[2] = Math.max(e[2], n[2]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      return t[0] = e[0] + n[0] * r, t[1] = e[1] + n[1] * r, t[2] = e[2] + n[2] * r, t;
    };
  }, function (t, e, n) {
    t.exports = n(53);
  }, function (t, e, n) {
    t.exports = n(54);
  }, function (t, e, n) {
    t.exports = n(55);
  }, function (t, e, n) {
    t.exports = n(56);
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = n[0],
          u = n[1],
          c = n[2];
      return t[0] = i * c - o * u, t[1] = o * a - r * c, t[2] = r * u - i * a, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      var i = e[0],
          o = e[1],
          a = e[2];
      return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t[2] = a + r * (n[2] - a), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      e = e || 1;
      var n = 2 * Math.random() * Math.PI,
          r = 2 * Math.random() - 1,
          i = Math.sqrt(1 - r * r) * e;
      return t[0] = Math.cos(n) * i, t[1] = Math.sin(n) * i, t[2] = r * e, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = n[3] * r + n[7] * i + n[11] * o + n[15];
      return a = a || 1, t[0] = (n[0] * r + n[4] * i + n[8] * o + n[12]) / a, t[1] = (n[1] * r + n[5] * i + n[9] * o + n[13]) / a, t[2] = (n[2] * r + n[6] * i + n[10] * o + n[14]) / a, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2];
      return t[0] = r * n[0] + i * n[3] + o * n[6], t[1] = r * n[1] + i * n[4] + o * n[7], t[2] = r * n[2] + i * n[5] + o * n[8], t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = n[0],
          u = n[1],
          c = n[2],
          s = n[3],
          f = s * r + u * o - c * i,
          l = s * i + c * r - a * o,
          h = s * o + a * i - u * r,
          d = -a * r - u * i - c * o;
      return t[0] = f * s + d * -a + l * -c - h * -u, t[1] = l * s + d * -u + h * -a - f * -c, t[2] = h * s + d * -c + f * -u - l * -a, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      var i = n[1],
          o = n[2],
          a = e[1] - i,
          u = e[2] - o,
          c = Math.sin(r),
          s = Math.cos(r);
      return t[0] = e[0], t[1] = i + a * s - u * c, t[2] = o + a * c + u * s, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      var i = n[0],
          o = n[2],
          a = e[0] - i,
          u = e[2] - o,
          c = Math.sin(r),
          s = Math.cos(r);
      return t[0] = i + u * c + a * s, t[1] = e[1], t[2] = o + u * s - a * c, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      var i = n[0],
          o = n[1],
          a = e[0] - i,
          u = e[1] - o,
          c = Math.sin(r),
          s = Math.cos(r);
      return t[0] = i + a * s - u * c, t[1] = o + a * c + u * s, t[2] = e[2], t;
    };
  }, function (t, e, n) {
    t.exports = function (t, e, n, i, o, a) {
      var u, c;
      e || (e = 3);
      n || (n = 0);
      c = i ? Math.min(i * e + n, t.length) : t.length;

      for (u = n; u < c; u += e) {
        r[0] = t[u], r[1] = t[u + 1], r[2] = t[u + 2], o(r, r, a), t[u] = r[0], t[u + 1] = r[1], t[u + 2] = r[2];
      }

      return t;
    };

    var r = n(46)();
  }, function (t, e) {
    function n(e, r) {
      return t.exports = n = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, n(e, r);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, n) {
    var r = n(35);

    t.exports = function (t) {
      if (Array.isArray(t)) return r(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (t, e, n) {
    var r = n(2);

    t.exports = function (t, e) {
      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = r(t));) {
        ;
      }

      return t;
    };
  }, function (t, e, n) {
    var r = function (t) {
      "use strict";

      var e = Object.prototype,
          n = e.hasOwnProperty,
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          o = r.asyncIterator || "@@asyncIterator",
          a = r.toStringTag || "@@toStringTag";

      function u(t, e, n, r) {
        var i = e && e.prototype instanceof f ? e : f,
            o = Object.create(i.prototype),
            a = new x(r || []);
        return o._invoke = function (t, e, n) {
          var r = "suspendedStart";
          return function (i, o) {
            if ("executing" === r) throw new Error("Generator is already running");

            if ("completed" === r) {
              if ("throw" === i) throw o;
              return A();
            }

            for (n.method = i, n.arg = o;;) {
              var a = n.delegate;

              if (a) {
                var u = m(a, n);

                if (u) {
                  if (u === s) continue;
                  return u;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw r = "completed", n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var f = c(t, e, n);

              if ("normal" === f.type) {
                if (r = n.done ? "completed" : "suspendedYield", f.arg === s) continue;
                return {
                  value: f.arg,
                  done: n.done
                };
              }

              "throw" === f.type && (r = "completed", n.method = "throw", n.arg = f.arg);
            }
          };
        }(t, n, a), o;
      }

      function c(t, e, n) {
        try {
          return {
            type: "normal",
            arg: t.call(e, n)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var s = {};

      function f() {}

      function l() {}

      function h() {}

      var d = {};

      d[i] = function () {
        return this;
      };

      var p = Object.getPrototypeOf,
          v = p && p(p(E([])));
      v && v !== e && n.call(v, i) && (d = v);
      var g = h.prototype = f.prototype = Object.create(d);

      function y(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function _(t, e) {
        var r;

        this._invoke = function (i, o) {
          function a() {
            return new e(function (r, a) {
              !function r(i, o, a, u) {
                var s = c(t[i], t, o);

                if ("throw" !== s.type) {
                  var f = s.arg,
                      l = f.value;
                  return l && "object" == typeof l && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
                    r("next", t, a, u);
                  }, function (t) {
                    r("throw", t, a, u);
                  }) : e.resolve(l).then(function (t) {
                    f.value = t, a(f);
                  }, function (t) {
                    return r("throw", t, a, u);
                  });
                }

                u(s.arg);
              }(i, o, r, a);
            });
          }

          return r = r ? r.then(a, a) : a();
        };
      }

      function m(t, e) {
        var n = t.iterator[e.method];

        if (void 0 === n) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = void 0, m(t, e), "throw" === e.method)) return s;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return s;
        }

        var r = c(n, t.iterator, e.arg);
        if ("throw" === r.type) return e.method = "throw", e.arg = r.arg, e.delegate = null, s;
        var i = r.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, s) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, s);
      }

      function b(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function w(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function x(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(b, this), this.reset(!0);
      }

      function E(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var r = -1,
                o = function e() {
              for (; ++r < t.length;) {
                if (n.call(t, r)) return e.value = t[r], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return o.next = o;
          }
        }

        return {
          next: A
        };
      }

      function A() {
        return {
          value: void 0,
          done: !0
        };
      }

      return l.prototype = g.constructor = h, h.constructor = l, h[a] = l.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === l || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(g), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, y(_.prototype), _.prototype[o] = function () {
        return this;
      }, t.AsyncIterator = _, t.async = function (e, n, r, i, o) {
        void 0 === o && (o = Promise);
        var a = new _(u(e, n, r, i), o);
        return t.isGeneratorFunction(n) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, y(g), g[a] = "Generator", g[i] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var n in t) {
          e.push(n);
        }

        return e.reverse(), function n() {
          for (; e.length;) {
            var r = e.pop();
            if (r in t) return n.value = r, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, t.values = E, x.prototype = {
        constructor: x,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !t) for (var e in this) {
            "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function r(n, r) {
            return a.type = "throw", a.arg = t, e.next = n, r && (e.method = "next", e.arg = void 0), !!r;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i],
                a = o.completion;
            if ("root" === o.tryLoc) return r("end");

            if (o.tryLoc <= this.prev) {
              var u = n.call(o, "catchLoc"),
                  c = n.call(o, "finallyLoc");

              if (u && c) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              } else if (u) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];

            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, s) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), s;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), w(n), s;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];

            if (n.tryLoc === t) {
              var r = n.completion;

              if ("throw" === r.type) {
                var i = r.arg;
                w(n);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, n) {
          return this.delegate = {
            iterator: E(t),
            resultName: e,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), s;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = r;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (t, e) {
    t.exports = function (t) {
      return t[0] * t[3] - t[2] * t[1];
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (t === e) {
        var n = e[1];
        t[1] = e[2], t[2] = n;
      } else t[0] = e[0], t[1] = e[2], t[2] = e[1], t[3] = e[3];

      return t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = e[3],
          u = n[0],
          c = n[1],
          s = n[2],
          f = n[3];
      return t[0] = r * u + o * c, t[1] = i * u + a * c, t[2] = r * s + o * f, t[3] = i * s + a * f, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0];
      return t[0] = e[3], t[1] = -e[1], t[2] = -e[2], t[3] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = e[3],
          u = Math.sin(n),
          c = Math.cos(n);
      return t[0] = r * c + o * u, t[1] = i * c + a * u, t[2] = r * -u + o * c, t[3] = i * -u + a * c, t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = e[0],
          r = e[1],
          i = e[2],
          o = e[3],
          a = n * o - i * r;
      return a ? (a = 1 / a, t[0] = o * a, t[1] = -r * a, t[2] = -i * a, t[3] = n * a, t) : null;
    };
  }, function (t, e) {
    t.exports = function () {
      var t = new Float32Array(4);
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = e[0],
          i = e[1],
          o = e[2],
          a = e[3],
          u = n[0],
          c = n[1];
      return t[0] = r * u, t[1] = i * u, t[2] = o * c, t[3] = a * c, t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2));
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      return t[2] = r[2] / r[0], n[0] = r[0], n[1] = r[1], n[3] = r[3] - t[2] * n[1], [t, e, n];
    };
  }, function (t, e, n) {
    "use strict";

    e.byteLength = function (t) {
      var e = s(t),
          n = e[0],
          r = e[1];
      return 3 * (n + r) / 4 - r;
    }, e.toByteArray = function (t) {
      var e,
          n,
          r = s(t),
          a = r[0],
          u = r[1],
          c = new o(function (t, e, n) {
        return 3 * (e + n) / 4 - n;
      }(0, a, u)),
          f = 0,
          l = u > 0 ? a - 4 : a;

      for (n = 0; n < l; n += 4) {
        e = i[t.charCodeAt(n)] << 18 | i[t.charCodeAt(n + 1)] << 12 | i[t.charCodeAt(n + 2)] << 6 | i[t.charCodeAt(n + 3)], c[f++] = e >> 16 & 255, c[f++] = e >> 8 & 255, c[f++] = 255 & e;
      }

      2 === u && (e = i[t.charCodeAt(n)] << 2 | i[t.charCodeAt(n + 1)] >> 4, c[f++] = 255 & e);
      1 === u && (e = i[t.charCodeAt(n)] << 10 | i[t.charCodeAt(n + 1)] << 4 | i[t.charCodeAt(n + 2)] >> 2, c[f++] = e >> 8 & 255, c[f++] = 255 & e);
      return c;
    }, e.fromByteArray = function (t) {
      for (var e, n = t.length, i = n % 3, o = [], a = 0, u = n - i; a < u; a += 16383) {
        o.push(f(t, a, a + 16383 > u ? u : a + 16383));
      }

      1 === i ? (e = t[n - 1], o.push(r[e >> 2] + r[e << 4 & 63] + "==")) : 2 === i && (e = (t[n - 2] << 8) + t[n - 1], o.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + "="));
      return o.join("");
    };

    for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u = 0, c = a.length; u < c; ++u) {
      r[u] = a[u], i[a.charCodeAt(u)] = u;
    }

    function s(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = t.indexOf("=");
      return -1 === n && (n = e), [n, n === e ? 0 : 4 - n % 4];
    }

    function f(t, e, n) {
      for (var i, o, a = [], u = e; u < n; u += 3) {
        i = (t[u] << 16 & 16711680) + (t[u + 1] << 8 & 65280) + (255 & t[u + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
      }

      return a.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, n, r, i) {
      var o,
          a,
          u = 8 * i - r - 1,
          c = (1 << u) - 1,
          s = c >> 1,
          f = -7,
          l = n ? i - 1 : 0,
          h = n ? -1 : 1,
          d = t[e + l];

      for (l += h, o = d & (1 << -f) - 1, d >>= -f, f += u; f > 0; o = 256 * o + t[e + l], l += h, f -= 8) {
        ;
      }

      for (a = o & (1 << -f) - 1, o >>= -f, f += r; f > 0; a = 256 * a + t[e + l], l += h, f -= 8) {
        ;
      }

      if (0 === o) o = 1 - s;else {
        if (o === c) return a ? NaN : 1 / 0 * (d ? -1 : 1);
        a += Math.pow(2, r), o -= s;
      }
      return (d ? -1 : 1) * a * Math.pow(2, o - r);
    }, e.write = function (t, e, n, r, i, o) {
      var a,
          u,
          c,
          s = 8 * o - i - 1,
          f = (1 << s) - 1,
          l = f >> 1,
          h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          d = r ? 0 : o - 1,
          p = r ? 1 : -1,
          v = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (u = isNaN(e) ? 1 : 0, a = f) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), (e += a + l >= 1 ? h / c : h * Math.pow(2, 1 - l)) * c >= 2 && (a++, c /= 2), a + l >= f ? (u = 0, a = f) : a + l >= 1 ? (u = (e * c - 1) * Math.pow(2, i), a += l) : (u = e * Math.pow(2, l - 1) * Math.pow(2, i), a = 0)); i >= 8; t[n + d] = 255 & u, d += p, u /= 256, i -= 8) {
        ;
      }

      for (a = a << i | u, s += i; s > 0; t[n + d] = 255 & a, d += p, a /= 256, s -= 8) {
        ;
      }

      t[n + d - p] |= 128 * v;
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == n.call(t);
    };
  }, function (t, e, n) {
    (function (t) {
      function n(t, e) {
        for (var n = 0, r = t.length - 1; r >= 0; r--) {
          var i = t[r];
          "." === i ? t.splice(r, 1) : ".." === i ? (t.splice(r, 1), n++) : n && (t.splice(r, 1), n--);
        }

        if (e) for (; n--; n) {
          t.unshift("..");
        }
        return t;
      }

      function r(t, e) {
        if (t.filter) return t.filter(e);

        for (var n = [], r = 0; r < t.length; r++) {
          e(t[r], r, t) && n.push(t[r]);
        }

        return n;
      }

      e.resolve = function () {
        for (var e = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--) {
          var a = o >= 0 ? arguments[o] : t.cwd();
          if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
          a && (e = a + "/" + e, i = "/" === a.charAt(0));
        }

        return (i ? "/" : "") + (e = n(r(e.split("/"), function (t) {
          return !!t;
        }), !i).join("/")) || ".";
      }, e.normalize = function (t) {
        var o = e.isAbsolute(t),
            a = "/" === i(t, -1);
        return (t = n(r(t.split("/"), function (t) {
          return !!t;
        }), !o).join("/")) || o || (t = "."), t && a && (t += "/"), (o ? "/" : "") + t;
      }, e.isAbsolute = function (t) {
        return "/" === t.charAt(0);
      }, e.join = function () {
        var t = Array.prototype.slice.call(arguments, 0);
        return e.normalize(r(t, function (t, e) {
          if ("string" != typeof t) throw new TypeError("Arguments to path.join must be strings");
          return t;
        }).join("/"));
      }, e.relative = function (t, n) {
        function r(t) {
          for (var e = 0; e < t.length && "" === t[e]; e++) {
            ;
          }

          for (var n = t.length - 1; n >= 0 && "" === t[n]; n--) {
            ;
          }

          return e > n ? [] : t.slice(e, n - e + 1);
        }

        t = e.resolve(t).substr(1), n = e.resolve(n).substr(1);

        for (var i = r(t.split("/")), o = r(n.split("/")), a = Math.min(i.length, o.length), u = a, c = 0; c < a; c++) {
          if (i[c] !== o[c]) {
            u = c;
            break;
          }
        }

        var s = [];

        for (c = u; c < i.length; c++) {
          s.push("..");
        }

        return (s = s.concat(o.slice(u))).join("/");
      }, e.sep = "/", e.delimiter = ":", e.dirname = function (t) {
        if ("string" != typeof t && (t += ""), 0 === t.length) return ".";

        for (var e = t.charCodeAt(0), n = 47 === e, r = -1, i = !0, o = t.length - 1; o >= 1; --o) {
          if (47 === (e = t.charCodeAt(o))) {
            if (!i) {
              r = o;
              break;
            }
          } else i = !1;
        }

        return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : t.slice(0, r);
      }, e.basename = function (t, e) {
        var n = function (t) {
          "string" != typeof t && (t += "");
          var e,
              n = 0,
              r = -1,
              i = !0;

          for (e = t.length - 1; e >= 0; --e) {
            if (47 === t.charCodeAt(e)) {
              if (!i) {
                n = e + 1;
                break;
              }
            } else -1 === r && (i = !1, r = e + 1);
          }

          return -1 === r ? "" : t.slice(n, r);
        }(t);

        return e && n.substr(-1 * e.length) === e && (n = n.substr(0, n.length - e.length)), n;
      }, e.extname = function (t) {
        "string" != typeof t && (t += "");

        for (var e = -1, n = 0, r = -1, i = !0, o = 0, a = t.length - 1; a >= 0; --a) {
          var u = t.charCodeAt(a);
          if (47 !== u) -1 === r && (i = !1, r = a + 1), 46 === u ? -1 === e ? e = a : 1 !== o && (o = 1) : -1 !== e && (o = -1);else if (!i) {
            n = a + 1;
            break;
          }
        }

        return -1 === e || -1 === r || 0 === o || 1 === o && e === r - 1 && e === n + 1 ? "" : t.slice(e, r);
      };
      var i = "b" === "ab".substr(-1) ? function (t, e, n) {
        return t.substr(e, n);
      } : function (t, e, n) {
        return e < 0 && (e = t.length + e), t.substr(e, n);
      };
    }).call(this, n(13));
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      for (var e = new Array(t), n = 0; n < t; ++n) {
        e[n] = n;
      }

      return e;
    };
  }, function (t, e) {
    function n(t) {
      return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
    }
    /*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */


    t.exports = function (t) {
      return null != t && (n(t) || function (t) {
        return "function" == typeof t.readFloatLE && "function" == typeof t.slice && n(t.slice(0, 0));
      }(t) || !!t._isBuffer);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      for (var i = t[e++], o = 1 << i, a = o + 1, u = a + 1, c = i + 1, s = (1 << c) - 1, f = 0, l = 0, h = 0, d = t[e++], p = new Int32Array(4096), v = null;;) {
        for (; f < 16 && 0 !== d;) {
          l |= t[e++] << f, f += 8, 1 === d ? d = t[e++] : --d;
        }

        if (f < c) break;
        var g = l & s;

        if (l >>= c, f -= c, g !== o) {
          if (g === a) break;

          for (var y = g < u ? g : v, _ = 0, m = y; m > o;) {
            m = p[m] >> 8, ++_;
          }

          var b = m;
          if (h + _ + (y !== g ? 1 : 0) > r) return void console.log("Warning, gif stream longer than expected.");
          n[h++] = b;
          var w = h += _;

          for (y !== g && (n[h++] = b), m = y; _--;) {
            m = p[m], n[--w] = 255 & m, m >>= 8;
          }

          null !== v && u < 4096 && (p[u++] = v << 8 | b, u >= s + 1 && c < 12 && (++c, s = s << 1 | 1)), v = g;
        } else u = a + 1, s = (1 << (c = i + 1)) - 1, v = null;
      }

      return h !== r && console.log("Warning, gif stream shorter than expected."), n;
    }

    try {
      e.GifWriter = function (t, e, n, r) {
        var i = 0,
            o = void 0 === (r = void 0 === r ? {} : r).loop ? null : r.loop,
            a = void 0 === r.palette ? null : r.palette;
        if (e <= 0 || n <= 0 || e > 65535 || n > 65535) throw new Error("Width/Height invalid.");

        function u(t) {
          var e = t.length;
          if (e < 2 || e > 256 || e & e - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
          return e;
        }

        t[i++] = 71, t[i++] = 73, t[i++] = 70, t[i++] = 56, t[i++] = 57, t[i++] = 97;
        var c = 0,
            s = 0;

        if (null !== a) {
          for (var f = u(a); f >>= 1;) {
            ++c;
          }

          if (f = 1 << c, --c, void 0 !== r.background) {
            if ((s = r.background) >= f) throw new Error("Background index out of range.");
            if (0 === s) throw new Error("Background index explicitly passed as 0.");
          }
        }

        if (t[i++] = 255 & e, t[i++] = e >> 8 & 255, t[i++] = 255 & n, t[i++] = n >> 8 & 255, t[i++] = (null !== a ? 128 : 0) | c, t[i++] = s, t[i++] = 0, null !== a) for (var l = 0, h = a.length; l < h; ++l) {
          var d = a[l];
          t[i++] = d >> 16 & 255, t[i++] = d >> 8 & 255, t[i++] = 255 & d;
        }

        if (null !== o) {
          if (o < 0 || o > 65535) throw new Error("Loop count invalid.");
          t[i++] = 33, t[i++] = 255, t[i++] = 11, t[i++] = 78, t[i++] = 69, t[i++] = 84, t[i++] = 83, t[i++] = 67, t[i++] = 65, t[i++] = 80, t[i++] = 69, t[i++] = 50, t[i++] = 46, t[i++] = 48, t[i++] = 3, t[i++] = 1, t[i++] = 255 & o, t[i++] = o >> 8 & 255, t[i++] = 0;
        }

        var p = !1;
        this.addFrame = function (e, n, r, o, c, s) {
          if (!0 === p && (--i, p = !1), s = void 0 === s ? {} : s, e < 0 || n < 0 || e > 65535 || n > 65535) throw new Error("x/y invalid.");
          if (r <= 0 || o <= 0 || r > 65535 || o > 65535) throw new Error("Width/Height invalid.");
          if (c.length < r * o) throw new Error("Not enough pixels for the frame size.");
          var f = !0,
              l = s.palette;
          if (null == l && (f = !1, l = a), null == l) throw new Error("Must supply either a local or global palette.");

          for (var h = u(l), d = 0; h >>= 1;) {
            ++d;
          }

          h = 1 << d;
          var v = void 0 === s.delay ? 0 : s.delay,
              g = void 0 === s.disposal ? 0 : s.disposal;
          if (g < 0 || g > 3) throw new Error("Disposal out of range.");
          var y = !1,
              _ = 0;
          if (void 0 !== s.transparent && null !== s.transparent && (y = !0, (_ = s.transparent) < 0 || _ >= h)) throw new Error("Transparent color index.");
          if ((0 !== g || y || 0 !== v) && (t[i++] = 33, t[i++] = 249, t[i++] = 4, t[i++] = g << 2 | (!0 === y ? 1 : 0), t[i++] = 255 & v, t[i++] = v >> 8 & 255, t[i++] = _, t[i++] = 0), t[i++] = 44, t[i++] = 255 & e, t[i++] = e >> 8 & 255, t[i++] = 255 & n, t[i++] = n >> 8 & 255, t[i++] = 255 & r, t[i++] = r >> 8 & 255, t[i++] = 255 & o, t[i++] = o >> 8 & 255, t[i++] = !0 === f ? 128 | d - 1 : 0, !0 === f) for (var m = 0, b = l.length; m < b; ++m) {
            var w = l[m];
            t[i++] = w >> 16 & 255, t[i++] = w >> 8 & 255, t[i++] = 255 & w;
          }
          return i = function (t, e, n, r) {
            t[e++] = n;
            var i = e++,
                o = 1 << n,
                a = o - 1,
                u = o + 1,
                c = u + 1,
                s = n + 1,
                f = 0,
                l = 0;

            function h(n) {
              for (; f >= n;) {
                t[e++] = 255 & l, l >>= 8, f -= 8, e === i + 256 && (t[i] = 255, i = e++);
              }
            }

            function d(t) {
              l |= t << f, f += s, h(8);
            }

            var p = r[0] & a,
                v = {};
            d(o);

            for (var g = 1, y = r.length; g < y; ++g) {
              var _ = r[g] & a,
                  m = p << 8 | _,
                  b = v[m];

              if (void 0 === b) {
                for (l |= p << f, f += s; f >= 8;) {
                  t[e++] = 255 & l, l >>= 8, f -= 8, e === i + 256 && (t[i] = 255, i = e++);
                }

                4096 === c ? (d(o), c = u + 1, s = n + 1, v = {}) : (c >= 1 << s && ++s, v[m] = c++), p = _;
              } else p = b;
            }

            d(p), d(u), h(1), i + 1 === e ? t[i] = 0 : (t[i] = e - i - 1, t[e++] = 0);
            return e;
          }(t, i, d < 2 ? 2 : d, c);
        }, this.end = function () {
          return !1 === p && (t[i++] = 59, p = !0), i;
        }, this.getOutputBuffer = function () {
          return t;
        }, this.setOutputBuffer = function (e) {
          t = e;
        }, this.getOutputBufferPosition = function () {
          return i;
        }, this.setOutputBufferPosition = function (t) {
          i = t;
        };
      }, e.GifReader = function (t) {
        var e = 0;
        if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
        var n = t[e++] | t[e++] << 8,
            i = t[e++] | t[e++] << 8,
            o = t[e++],
            a = o >> 7,
            u = 1 << (7 & o) + 1;
        t[e++], t[e++];
        var c = null,
            s = null;
        a && (c = e, s = u, e += 3 * u);
        var f = !0,
            l = [],
            h = 0,
            d = null,
            p = 0,
            v = null;

        for (this.width = n, this.height = i; f && e < t.length;) {
          switch (t[e++]) {
            case 33:
              switch (t[e++]) {
                case 255:
                  if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, v = t[e++] | t[e++] << 8, e++;else for (e += 12;;) {
                    if (!((k = t[e++]) >= 0)) throw Error("Invalid block size");
                    if (0 === k) break;
                    e += k;
                  }
                  break;

                case 249:
                  if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                  var g = t[e++];
                  h = t[e++] | t[e++] << 8, d = t[e++], 0 == (1 & g) && (d = null), p = g >> 2 & 7, e++;
                  break;

                case 254:
                  for (;;) {
                    if (!((k = t[e++]) >= 0)) throw Error("Invalid block size");
                    if (0 === k) break;
                    e += k;
                  }

                  break;

                default:
                  throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
              }

              break;

            case 44:
              var y = t[e++] | t[e++] << 8,
                  _ = t[e++] | t[e++] << 8,
                  m = t[e++] | t[e++] << 8,
                  b = t[e++] | t[e++] << 8,
                  w = t[e++],
                  x = w >> 6 & 1,
                  E = 1 << (7 & w) + 1,
                  A = c,
                  R = s,
                  S = !1;

              if (w >> 7) {
                S = !0;
                A = e, R = E, e += 3 * E;
              }

              var O = e;

              for (e++;;) {
                var k;
                if (!((k = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === k) break;
                e += k;
              }

              l.push({
                x: y,
                y: _,
                width: m,
                height: b,
                has_local_palette: S,
                palette_offset: A,
                palette_size: R,
                data_offset: O,
                data_length: e - O,
                transparent_index: d,
                interlaced: !!x,
                delay: h,
                disposal: p
              });
              break;

            case 59:
              f = !1;
              break;

            default:
              throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
          }
        }

        this.numFrames = function () {
          return l.length;
        }, this.loopCount = function () {
          return v;
        }, this.frameInfo = function (t) {
          if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
          return l[t];
        }, this.decodeAndBlitFrameBGRA = function (e, i) {
          var o = this.frameInfo(e),
              a = o.width * o.height,
              u = new Uint8Array(a);
          r(t, o.data_offset, u, a);
          var c = o.palette_offset,
              s = o.transparent_index;
          null === s && (s = 256);
          var f = o.width,
              l = n - f,
              h = f,
              d = 4 * (o.y * n + o.x),
              p = 4 * ((o.y + o.height) * n + o.x),
              v = d,
              g = 4 * l;
          !0 === o.interlaced && (g += 4 * n * 7);

          for (var y = 8, _ = 0, m = u.length; _ < m; ++_) {
            var b = u[_];
            if (0 === h && (h = f, (v += g) >= p && (g = 4 * l + 4 * n * (y - 1), v = d + (f + l) * (y << 1), y >>= 1)), b === s) v += 4;else {
              var w = t[c + 3 * b],
                  x = t[c + 3 * b + 1],
                  E = t[c + 3 * b + 2];
              i[v++] = E, i[v++] = x, i[v++] = w, i[v++] = 255;
            }
            --h;
          }
        }, this.decodeAndBlitFrameRGBA = function (e, i) {
          var o = this.frameInfo(e),
              a = o.width * o.height,
              u = new Uint8Array(a);
          r(t, o.data_offset, u, a);
          var c = o.palette_offset,
              s = o.transparent_index;
          null === s && (s = 256);
          var f = o.width,
              l = n - f,
              h = f,
              d = 4 * (o.y * n + o.x),
              p = 4 * ((o.y + o.height) * n + o.x),
              v = d,
              g = 4 * l;
          !0 === o.interlaced && (g += 4 * n * 7);

          for (var y = 8, _ = 0, m = u.length; _ < m; ++_) {
            var b = u[_];
            if (0 === h && (h = f, (v += g) >= p && (g = 4 * l + 4 * n * (y - 1), v = d + (f + l) * (y << 1), y >>= 1)), b === s) v += 4;else {
              var w = t[c + 3 * b],
                  x = t[c + 3 * b + 1],
                  E = t[c + 3 * b + 2];
              i[v++] = w, i[v++] = x, i[v++] = E, i[v++] = 255;
            }
            --h;
          }
        };
      };
    } catch (t) {}
  }, function (t, e, n) {
    "use strict";

    var r = n(29),
        i = n(167);

    t.exports = function (t, e) {
      for (var n = [], o = t, a = 1; Array.isArray(o);) {
        n.push(o.length), a *= o.length, o = o[0];
      }

      return 0 === n.length ? r() : (e || (e = r(new Float64Array(a), n)), i(e, t), e);
    };
  }, function (t, e, n) {
    t.exports = n(168)({
      args: ["array", "scalar", "index"],
      pre: {
        body: "{}",
        args: [],
        thisVars: [],
        localVars: []
      },
      body: {
        body: "{\nvar _inline_1_v=_inline_1_arg1_,_inline_1_i\nfor(_inline_1_i=0;_inline_1_i<_inline_1_arg2_.length-1;++_inline_1_i) {\n_inline_1_v=_inline_1_v[_inline_1_arg2_[_inline_1_i]]\n}\n_inline_1_arg0_=_inline_1_v[_inline_1_arg2_[_inline_1_arg2_.length-1]]\n}",
        args: [{
          name: "_inline_1_arg0_",
          lvalue: !0,
          rvalue: !1,
          count: 1
        }, {
          name: "_inline_1_arg1_",
          lvalue: !1,
          rvalue: !0,
          count: 1
        }, {
          name: "_inline_1_arg2_",
          lvalue: !1,
          rvalue: !0,
          count: 4
        }],
        thisVars: [],
        localVars: ["_inline_1_i", "_inline_1_v"]
      },
      post: {
        body: "{}",
        args: [],
        thisVars: [],
        localVars: []
      },
      funcName: "convert",
      blockSize: 64
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(169);

    function i() {
      this.argTypes = [], this.shimArgs = [], this.arrayArgs = [], this.arrayBlockIndices = [], this.scalarArgs = [], this.offsetArgs = [], this.offsetArgIndex = [], this.indexArgs = [], this.shapeArgs = [], this.funcName = "", this.pre = null, this.body = null, this.post = null, this.debug = !1;
    }

    t.exports = function (t) {
      var e = new i();
      e.pre = t.pre, e.body = t.body, e.post = t.post;
      var n = t.args.slice(0);
      e.argTypes = n;

      for (var o = 0; o < n.length; ++o) {
        var a = n[o];

        if ("array" === a || "object" == typeof a && a.blockIndices) {
          if (e.argTypes[o] = "array", e.arrayArgs.push(o), e.arrayBlockIndices.push(a.blockIndices ? a.blockIndices : 0), e.shimArgs.push("array" + o), o < e.pre.args.length && e.pre.args[o].count > 0) throw new Error("cwise: pre() block may not reference array args");
          if (o < e.post.args.length && e.post.args[o].count > 0) throw new Error("cwise: post() block may not reference array args");
        } else if ("scalar" === a) e.scalarArgs.push(o), e.shimArgs.push("scalar" + o);else if ("index" === a) {
          if (e.indexArgs.push(o), o < e.pre.args.length && e.pre.args[o].count > 0) throw new Error("cwise: pre() block may not reference array index");
          if (o < e.body.args.length && e.body.args[o].lvalue) throw new Error("cwise: body() block may not write to array index");
          if (o < e.post.args.length && e.post.args[o].count > 0) throw new Error("cwise: post() block may not reference array index");
        } else if ("shape" === a) {
          if (e.shapeArgs.push(o), o < e.pre.args.length && e.pre.args[o].lvalue) throw new Error("cwise: pre() block may not write to array shape");
          if (o < e.body.args.length && e.body.args[o].lvalue) throw new Error("cwise: body() block may not write to array shape");
          if (o < e.post.args.length && e.post.args[o].lvalue) throw new Error("cwise: post() block may not write to array shape");
        } else {
          if ("object" != typeof a || !a.offset) throw new Error("cwise: Unknown argument type " + n[o]);
          e.argTypes[o] = "offset", e.offsetArgs.push({
            array: a.array,
            offset: a.offset
          }), e.offsetArgIndex.push(o);
        }
      }

      if (e.arrayArgs.length <= 0) throw new Error("cwise: No array arguments specified");
      if (e.pre.args.length > n.length) throw new Error("cwise: Too many arguments in pre() block");
      if (e.body.args.length > n.length) throw new Error("cwise: Too many arguments in body() block");
      if (e.post.args.length > n.length) throw new Error("cwise: Too many arguments in post() block");
      return e.debug = !!t.printCode || !!t.debug, e.funcName = t.funcName || "cwise", e.blockSize = t.blockSize || 64, r(e);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(170);

    t.exports = function (t) {
      var e = ["'use strict'", "var CACHED={}"],
          n = [],
          i = t.funcName + "_cwise_thunk";
      e.push(["return function ", i, "(", t.shimArgs.join(","), "){"].join(""));

      for (var o = [], a = [], u = [["array", t.arrayArgs[0], ".shape.slice(", Math.max(0, t.arrayBlockIndices[0]), t.arrayBlockIndices[0] < 0 ? "," + t.arrayBlockIndices[0] + ")" : ")"].join("")], c = [], s = [], f = 0; f < t.arrayArgs.length; ++f) {
        var l = t.arrayArgs[f];
        n.push(["t", l, "=array", l, ".dtype,", "r", l, "=array", l, ".order"].join("")), o.push("t" + l), o.push("r" + l), a.push("t" + l), a.push("r" + l + ".join()"), u.push("array" + l + ".data"), u.push("array" + l + ".stride"), u.push("array" + l + ".offset|0"), f > 0 && (c.push("array" + t.arrayArgs[0] + ".shape.length===array" + l + ".shape.length+" + (Math.abs(t.arrayBlockIndices[0]) - Math.abs(t.arrayBlockIndices[f]))), s.push("array" + t.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, t.arrayBlockIndices[0]) + "]===array" + l + ".shape[shapeIndex+" + Math.max(0, t.arrayBlockIndices[f]) + "]"));
      }

      for (t.arrayArgs.length > 1 && (e.push("if (!(" + c.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')"), e.push("for(var shapeIndex=array" + t.arrayArgs[0] + ".shape.length-" + Math.abs(t.arrayBlockIndices[0]) + "; shapeIndex--\x3e0;) {"), e.push("if (!(" + s.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')"), e.push("}")), f = 0; f < t.scalarArgs.length; ++f) {
        u.push("scalar" + t.scalarArgs[f]);
      }

      return n.push(["type=[", a.join(","), "].join()"].join("")), n.push("proc=CACHED[type]"), e.push("var " + n.join(",")), e.push(["if(!proc){", "CACHED[type]=proc=compile([", o.join(","), "])}", "return proc(", u.join(","), ")}"].join("")), t.debug && console.log("-----Generated thunk:\n" + e.join("\n") + "\n----------"), new Function("compile", e.join("\n"))(r.bind(void 0, t));
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(171);

    function i(t, e, n) {
      var r,
          i,
          o = t.length,
          a = e.arrayArgs.length,
          u = e.indexArgs.length > 0,
          c = [],
          s = [],
          f = 0,
          l = 0;

      for (r = 0; r < o; ++r) {
        s.push(["i", r, "=0"].join(""));
      }

      for (i = 0; i < a; ++i) {
        for (r = 0; r < o; ++r) {
          l = f, f = t[r], 0 === r ? s.push(["d", i, "s", r, "=t", i, "p", f].join("")) : s.push(["d", i, "s", r, "=(t", i, "p", f, "-s", l, "*t", i, "p", l, ")"].join(""));
        }
      }

      for (s.length > 0 && c.push("var " + s.join(",")), r = o - 1; r >= 0; --r) {
        f = t[r], c.push(["for(i", r, "=0;i", r, "<s", f, ";++i", r, "){"].join(""));
      }

      for (c.push(n), r = 0; r < o; ++r) {
        for (l = f, f = t[r], i = 0; i < a; ++i) {
          c.push(["p", i, "+=d", i, "s", r].join(""));
        }

        u && (r > 0 && c.push(["index[", l, "]-=s", l].join("")), c.push(["++index[", f, "]"].join(""))), c.push("}");
      }

      return c.join("\n");
    }

    function o(t, e, n) {
      for (var r = t.body, i = [], o = [], a = 0; a < t.args.length; ++a) {
        var u = t.args[a];

        if (!(u.count <= 0)) {
          var c = new RegExp(u.name, "g"),
              s = "",
              f = e.arrayArgs.indexOf(a);

          switch (e.argTypes[a]) {
            case "offset":
              var l = e.offsetArgIndex.indexOf(a);
              f = e.offsetArgs[l].array, s = "+q" + l;

            case "array":
              s = "p" + f + s;
              var h = "l" + a,
                  d = "a" + f;
              if (0 === e.arrayBlockIndices[f]) 1 === u.count ? "generic" === n[f] ? u.lvalue ? (i.push(["var ", h, "=", d, ".get(", s, ")"].join("")), r = r.replace(c, h), o.push([d, ".set(", s, ",", h, ")"].join(""))) : r = r.replace(c, [d, ".get(", s, ")"].join("")) : r = r.replace(c, [d, "[", s, "]"].join("")) : "generic" === n[f] ? (i.push(["var ", h, "=", d, ".get(", s, ")"].join("")), r = r.replace(c, h), u.lvalue && o.push([d, ".set(", s, ",", h, ")"].join(""))) : (i.push(["var ", h, "=", d, "[", s, "]"].join("")), r = r.replace(c, h), u.lvalue && o.push([d, "[", s, "]=", h].join("")));else {
                for (var p = [u.name], v = [s], g = 0; g < Math.abs(e.arrayBlockIndices[f]); g++) {
                  p.push("\\s*\\[([^\\]]+)\\]"), v.push("$" + (g + 1) + "*t" + f + "b" + g);
                }

                if (c = new RegExp(p.join(""), "g"), s = v.join("+"), "generic" === n[f]) throw new Error("cwise: Generic arrays not supported in combination with blocks!");
                r = r.replace(c, [d, "[", s, "]"].join(""));
              }
              break;

            case "scalar":
              r = r.replace(c, "Y" + e.scalarArgs.indexOf(a));
              break;

            case "index":
              r = r.replace(c, "index");
              break;

            case "shape":
              r = r.replace(c, "shape");
          }
        }
      }

      return [i.join("\n"), r, o.join("\n")].join("\n").trim();
    }

    function a(t) {
      for (var e = new Array(t.length), n = !0, r = 0; r < t.length; ++r) {
        var i = t[r],
            o = i.match(/\d+/);
        o = o ? o[0] : "", 0 === i.charAt(0) ? e[r] = "u" + i.charAt(1) + o : e[r] = i.charAt(0) + o, r > 0 && (n = n && e[r] === e[r - 1]);
      }

      return n ? e[0] : e.join("");
    }

    t.exports = function (t, e) {
      for (var n = e[1].length - Math.abs(t.arrayBlockIndices[0]) | 0, u = new Array(t.arrayArgs.length), c = new Array(t.arrayArgs.length), s = 0; s < t.arrayArgs.length; ++s) {
        c[s] = e[2 * s], u[s] = e[2 * s + 1];
      }

      var f = [],
          l = [],
          h = [],
          d = [],
          p = [];

      for (s = 0; s < t.arrayArgs.length; ++s) {
        t.arrayBlockIndices[s] < 0 ? (h.push(0), d.push(n), f.push(n), l.push(n + t.arrayBlockIndices[s])) : (h.push(t.arrayBlockIndices[s]), d.push(t.arrayBlockIndices[s] + n), f.push(0), l.push(t.arrayBlockIndices[s]));

        for (var v = [], g = 0; g < u[s].length; g++) {
          h[s] <= u[s][g] && u[s][g] < d[s] && v.push(u[s][g] - h[s]);
        }

        p.push(v);
      }

      var y = ["SS"],
          _ = ["'use strict'"],
          m = [];

      for (g = 0; g < n; ++g) {
        m.push(["s", g, "=SS[", g, "]"].join(""));
      }

      for (s = 0; s < t.arrayArgs.length; ++s) {
        y.push("a" + s), y.push("t" + s), y.push("p" + s);

        for (g = 0; g < n; ++g) {
          m.push(["t", s, "p", g, "=t", s, "[", h[s] + g, "]"].join(""));
        }

        for (g = 0; g < Math.abs(t.arrayBlockIndices[s]); ++g) {
          m.push(["t", s, "b", g, "=t", s, "[", f[s] + g, "]"].join(""));
        }
      }

      for (s = 0; s < t.scalarArgs.length; ++s) {
        y.push("Y" + s);
      }

      if (t.shapeArgs.length > 0 && m.push("shape=SS.slice(0)"), t.indexArgs.length > 0) {
        var b = new Array(n);

        for (s = 0; s < n; ++s) {
          b[s] = "0";
        }

        m.push(["index=[", b.join(","), "]"].join(""));
      }

      for (s = 0; s < t.offsetArgs.length; ++s) {
        var w = t.offsetArgs[s],
            x = [];

        for (g = 0; g < w.offset.length; ++g) {
          0 !== w.offset[g] && (1 === w.offset[g] ? x.push(["t", w.array, "p", g].join("")) : x.push([w.offset[g], "*t", w.array, "p", g].join("")));
        }

        0 === x.length ? m.push("q" + s + "=0") : m.push(["q", s, "=", x.join("+")].join(""));
      }

      var E = r([].concat(t.pre.thisVars).concat(t.body.thisVars).concat(t.post.thisVars));

      for ((m = m.concat(E)).length > 0 && _.push("var " + m.join(",")), s = 0; s < t.arrayArgs.length; ++s) {
        _.push("p" + s + "|=0");
      }

      t.pre.body.length > 3 && _.push(o(t.pre, t, c));

      var A = o(t.body, t, c),
          R = function (t) {
        for (var e = 0, n = t[0].length; e < n;) {
          for (var r = 1; r < t.length; ++r) {
            if (t[r][e] !== t[0][e]) return e;
          }

          ++e;
        }

        return e;
      }(p);

      R < n ? _.push(function (t, e, n, r) {
        for (var o = e.length, a = n.arrayArgs.length, u = n.blockSize, c = n.indexArgs.length > 0, s = [], f = 0; f < a; ++f) {
          s.push(["var offset", f, "=p", f].join(""));
        }

        for (f = t; f < o; ++f) {
          s.push(["for(var j" + f + "=SS[", e[f], "]|0;j", f, ">0;){"].join("")), s.push(["if(j", f, "<", u, "){"].join("")), s.push(["s", e[f], "=j", f].join("")), s.push(["j", f, "=0"].join("")), s.push(["}else{s", e[f], "=", u].join("")), s.push(["j", f, "-=", u, "}"].join("")), c && s.push(["index[", e[f], "]=j", f].join(""));
        }

        for (f = 0; f < a; ++f) {
          for (var l = ["offset" + f], h = t; h < o; ++h) {
            l.push(["j", h, "*t", f, "p", e[h]].join(""));
          }

          s.push(["p", f, "=(", l.join("+"), ")"].join(""));
        }

        for (s.push(i(e, n, r)), f = t; f < o; ++f) {
          s.push("}");
        }

        return s.join("\n");
      }(R, p[0], t, A)) : _.push(i(p[0], t, A)), t.post.body.length > 3 && _.push(o(t.post, t, c)), t.debug && console.log("-----Generated cwise routine for ", e, ":\n" + _.join("\n") + "\n----------");
      var S = [t.funcName || "unnamed", "_cwise_loop_", u[0].join("s"), "m", R, a(c)].join("");
      return new Function(["function ", S, "(", y.join(","), "){", _.join("\n"), "} return ", S].join(""))();
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t, e, n) {
      return 0 === t.length ? t : e ? (n || t.sort(e), function (t, e) {
        for (var n = 1, r = t.length, i = t[0], o = t[0], a = 1; a < r; ++a) {
          if (o = i, e(i = t[a], o)) {
            if (a === n) {
              n++;
              continue;
            }

            t[n++] = i;
          }
        }

        return t.length = n, t;
      }(t, e)) : (n || t.sort(), function (t) {
        for (var e = 1, n = t.length, r = t[0], i = t[0], o = 1; o < n; ++o, i = r) {
          if (i = r, (r = t[o]) !== i) {
            if (o === e) {
              e++;
              continue;
            }

            t[e++] = r;
          }
        }

        return t.length = e, t;
      }(t));
    };
  }, function (t, e, n) {
    (function (e) {
      var r = n(173);

      function i(t, n, i) {
        t = t || function (t) {
          this.queue(t);
        }, n = n || function () {
          this.queue(null);
        };
        var o = !1,
            a = !1,
            u = [],
            c = !1,
            s = new r();

        function f() {
          for (; u.length && !s.paused;) {
            var t = u.shift();
            if (null === t) return s.emit("end");
            s.emit("data", t);
          }
        }

        function l() {
          s.writable = !1, n.call(s), !s.readable && s.autoDestroy && s.destroy();
        }

        return s.readable = s.writable = !0, s.paused = !1, s.autoDestroy = !(i && !1 === i.autoDestroy), s.write = function (e) {
          return t.call(this, e), !s.paused;
        }, s.queue = s.push = function (t) {
          return c || (null === t && (c = !0), u.push(t), f()), s;
        }, s.on("end", function () {
          s.readable = !1, !s.writable && s.autoDestroy && e.nextTick(function () {
            s.destroy();
          });
        }), s.end = function (t) {
          if (!o) return o = !0, arguments.length && s.write(t), l(), s;
        }, s.destroy = function () {
          if (!a) return a = !0, o = !0, u.length = 0, s.writable = s.readable = !1, s.emit("close"), s;
        }, s.pause = function () {
          if (!s.paused) return s.paused = !0, s;
        }, s.resume = function () {
          return s.paused && (s.paused = !1, s.emit("resume")), f(), s.paused || s.emit("drain"), s;
        }, s;
      }

      t.exports = i, i.through = i;
    }).call(this, n(13));
  }, function (t, e, n) {
    t.exports = i;
    var r = n(30).EventEmitter;

    function i() {
      r.call(this);
    }

    n(18)(i, r), i.Readable = n(31), i.Writable = n(183), i.Duplex = n(184), i.Transform = n(185), i.PassThrough = n(186), i.Stream = i, i.prototype.pipe = function (t, e) {
      var n = this;

      function i(e) {
        t.writable && !1 === t.write(e) && n.pause && n.pause();
      }

      function o() {
        n.readable && n.resume && n.resume();
      }

      n.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (n.on("end", u), n.on("close", c));
      var a = !1;

      function u() {
        a || (a = !0, t.end());
      }

      function c() {
        a || (a = !0, "function" == typeof t.destroy && t.destroy());
      }

      function s(t) {
        if (f(), 0 === r.listenerCount(this, "error")) throw t;
      }

      function f() {
        n.removeListener("data", i), t.removeListener("drain", o), n.removeListener("end", u), n.removeListener("close", c), n.removeListener("error", s), t.removeListener("error", s), n.removeListener("end", f), n.removeListener("close", f), t.removeListener("close", f);
      }

      return n.on("error", s), t.on("error", s), n.on("end", f), n.on("close", f), t.on("close", f), t.emit("pipe", n), t;
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == n.call(t);
    };
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    var r = n(32).Buffer,
        i = n(177);
    t.exports = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, n = "" + e.data; e = e.next;) {
          n += t + e.data;
        }

        return n;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return r.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e, n, i, o = r.allocUnsafe(t >>> 0), a = this.head, u = 0; a;) {
          e = a.data, n = o, i = u, e.copy(n, i), u += a.data.length, a = a.next;
        }

        return o;
      }, t;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
      var t = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, r, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(179), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, n(12));
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";

        if (!t.setImmediate) {
          var r,
              i,
              o,
              a,
              u,
              c = 1,
              s = {},
              f = !1,
              l = t.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(t);
          h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
            e.nextTick(function () {
              p(t);
            });
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            p(t.data);
          }, r = function r(t) {
            o.port2.postMessage(t);
          }) : l && "onreadystatechange" in l.createElement("script") ? (i = l.documentElement, r = function r(t) {
            var e = l.createElement("script");
            e.onreadystatechange = function () {
              p(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e);
          }) : r = function r(t) {
            setTimeout(p, 0, t);
          } : (a = "setImmediate$" + Math.random() + "$", u = function u(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
          }, t.addEventListener ? t.addEventListener("message", u, !1) : t.attachEvent("onmessage", u), r = function r(e) {
            t.postMessage(a + e, "*");
          }), h.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
              e[n] = arguments[n + 1];
            }

            var i = {
              callback: t,
              args: e
            };
            return s[c] = i, r(c), c++;
          }, h.clearImmediate = d;
        }

        function d(t) {
          delete s[t];
        }

        function p(t) {
          if (f) setTimeout(p, 0, t);else {
            var e = s[t];

            if (e) {
              f = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      n = t.args;

                  switch (n.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(n[0]);
                      break;

                    case 2:
                      e(n[0], n[1]);
                      break;

                    case 3:
                      e(n[0], n[1], n[2]);
                      break;

                    default:
                      e.apply(void 0, n);
                  }
                }(e);
              } finally {
                d(t), f = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, n(12), n(13));
  }, function (t, e, n) {
    (function (e) {
      function n(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var n = e.localStorage[t];
        return null != n && "true" === String(n).toLowerCase();
      }

      t.exports = function (t, e) {
        if (n("noDeprecation")) return t;
        var r = !1;
        return function () {
          if (!r) {
            if (n("throwDeprecation")) throw new Error(e);
            n("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
          }

          return t.apply(this, arguments);
        };
      };
    }).call(this, n(12));
  }, function (t, e, n) {
    var r = n(21),
        i = r.Buffer;

    function o(t, e) {
      for (var n in t) {
        e[n] = t[n];
      }
    }

    function a(t, e, n) {
      return i(t, e, n);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (o(r, e), e.Buffer = a), a.prototype = Object.create(i.prototype), o(i, a), a.from = function (t, e, n) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, n);
    }, a.alloc = function (t, e, n) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var r = i(t);
      return void 0 !== e ? "string" == typeof n ? r.fill(e, n) : r.fill(e) : r.fill(0), r;
    }, a.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, a.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return r.SlowBuffer(t);
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = o;
    var r = n(61),
        i = Object.create(n(22));

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      r.call(this, t);
    }

    i.inherits = n(18), i.inherits(o, r), o.prototype._transform = function (t, e, n) {
      n(null, t);
    };
  }, function (t, e, n) {
    t.exports = n(33);
  }, function (t, e, n) {
    t.exports = n(14);
  }, function (t, e, n) {
    t.exports = n(31).Transform;
  }, function (t, e, n) {
    t.exports = n(31).PassThrough;
  }, function (t, e, n) {
    (function (e) {
      t.exports = function (t) {
        if (!/^data\:/i.test(t)) throw new TypeError('`uri` does not appear to be a Data URI (must begin with "data:")');
        var n = (t = t.replace(/\r?\n/g, "")).indexOf(",");
        if (-1 === n || n <= 4) throw new TypeError("malformed data: URI");

        for (var r = t.substring(5, n).split(";"), i = !1, o = "US-ASCII", a = 0; a < r.length; a++) {
          "base64" == r[a] ? i = !0 : 0 == r[a].indexOf("charset=") && (o = r[a].substring(8));
        }

        var u = unescape(t.substring(n + 1)),
            c = new e(u, i ? "base64" : "ascii");
        return c.type = r[0] || "text/plain", c.charset = o, c;
      };
    }).call(this, n(21).Buffer);
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      var n = Math.floor(e),
          r = e - n,
          i = 0 <= n && n < t.shape[0],
          o = 0 <= n + 1 && n + 1 < t.shape[0];
      return (1 - r) * (i ? +t.get(n) : 0) + r * (o ? +t.get(n + 1) : 0);
    }

    function i(t, e, n) {
      var r = Math.floor(e),
          i = e - r,
          o = 0 <= r && r < t.shape[0],
          a = 0 <= r + 1 && r + 1 < t.shape[0],
          u = Math.floor(n),
          c = n - u,
          s = 0 <= u && u < t.shape[1],
          f = 0 <= u + 1 && u + 1 < t.shape[1],
          l = o && s ? t.get(r, u) : 0,
          h = o && f ? t.get(r, u + 1) : 0;
      return (1 - c) * ((1 - i) * l + i * (a && s ? t.get(r + 1, u) : 0)) + c * ((1 - i) * h + i * (a && f ? t.get(r + 1, u + 1) : 0));
    }

    function o(t, e, n, r) {
      var i = Math.floor(e),
          o = e - i,
          a = 0 <= i && i < t.shape[0],
          u = 0 <= i + 1 && i + 1 < t.shape[0],
          c = Math.floor(n),
          s = n - c,
          f = 0 <= c && c < t.shape[1],
          l = 0 <= c + 1 && c + 1 < t.shape[1],
          h = Math.floor(r),
          d = r - h,
          p = 0 <= h && h < t.shape[2],
          v = 0 <= h + 1 && h + 1 < t.shape[2],
          g = a && f && p ? t.get(i, c, h) : 0,
          y = a && l && p ? t.get(i, c + 1, h) : 0,
          _ = u && f && p ? t.get(i + 1, c, h) : 0,
          m = u && l && p ? t.get(i + 1, c + 1, h) : 0,
          b = a && f && v ? t.get(i, c, h + 1) : 0,
          w = a && l && v ? t.get(i, c + 1, h + 1) : 0;

      return (1 - d) * ((1 - s) * ((1 - o) * g + o * _) + s * ((1 - o) * y + o * m)) + d * ((1 - s) * ((1 - o) * b + o * (u && f && v ? t.get(i + 1, c, h + 1) : 0)) + s * ((1 - o) * w + o * (u && l && v ? t.get(i + 1, c + 1, h + 1) : 0)));
    }

    function a(t) {
      var e,
          n,
          r = 0 | t.shape.length,
          i = new Array(r),
          o = new Array(r),
          a = new Array(r),
          u = new Array(r);

      for (e = 0; e < r; ++e) {
        n = +arguments[e + 1], i[e] = Math.floor(n), o[e] = n - i[e], a[e] = 0 <= i[e] && i[e] < t.shape[e], u[e] = 0 <= i[e] + 1 && i[e] + 1 < t.shape[e];
      }

      var c,
          s,
          f,
          l = 0;

      t: for (e = 0; e < 1 << r; ++e) {
        for (s = 1, f = t.offset, c = 0; c < r; ++c) {
          if (e & 1 << c) {
            if (!u[c]) continue t;
            s *= o[c], f += t.stride[c] * (i[c] + 1);
          } else {
            if (!a[c]) continue t;
            s *= 1 - o[c], f += t.stride[c] * i[c];
          }
        }

        l += s * t.data[f];
      }

      return l;
    }

    t.exports = function (t, e, n, u) {
      switch (t.shape.length) {
        case 0:
          return 0;

        case 1:
          return r(t, e);

        case 2:
          return i(t, e, n);

        case 3:
          return o(t, e, n, u);

        default:
          return a.apply(void 0, arguments);
      }
    }, t.exports.d1 = r, t.exports.d2 = i, t.exports.d3 = o;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "BarcodeDecoder", function () {
      return Mt;
    }), n.d(e, "BarcodeReader", function () {
      return S;
    }), n.d(e, "CameraAccess", function () {
      return Gt;
    }), n.d(e, "ImageDebug", function () {
      return f.a;
    }), n.d(e, "ImageWrapper", function () {
      return o.a;
    }), n.d(e, "ResultCollector", function () {
      return Ht;
    });
    var r = n(19),
        i = n.n(r),
        o = (n(68), n(10)),
        a = {},
        u = {
      UP: 1,
      DOWN: -1
    };
    a.getBarcodeLine = function (t, e, n) {
      var r,
          i,
          o,
          a,
          u,
          c = 0 | e.x,
          s = 0 | e.y,
          f = 0 | n.x,
          l = 0 | n.y,
          h = Math.abs(l - s) > Math.abs(f - c),
          d = [],
          p = t.data,
          v = t.size.x,
          g = 255,
          y = 0;

      function _(t, e) {
        u = p[e * v + t], g = u < g ? u : g, y = u > y ? u : y, d.push(u);
      }

      h && (o = c, c = s, s = o, o = f, f = l, l = o), c > f && (o = c, c = f, f = o, o = s, s = l, l = o);
      var m = f - c,
          b = Math.abs(l - s);
      r = m / 2 | 0, i = s;
      var w = s < l ? 1 : -1;

      for (a = c; a < f; a++) {
        h ? _(i, a) : _(a, i), (r -= b) < 0 && (i += w, r += m);
      }

      return {
        line: d,
        min: g,
        max: y
      };
    }, a.toBinaryLine = function (t) {
      var e,
          n,
          r,
          i,
          o,
          a,
          c = t.min,
          s = t.max,
          f = t.line,
          l = c + (s - c) / 2,
          h = [],
          d = (s - c) / 12,
          p = -d;

      for (r = f[0] > l ? u.UP : u.DOWN, h.push({
        pos: 0,
        val: f[0]
      }), o = 0; o < f.length - 2; o++) {
        r !== (i = (e = f[o + 1] - f[o]) + (n = f[o + 2] - f[o + 1]) < p && f[o + 1] < 1.5 * l ? u.DOWN : e + n > d && f[o + 1] > .5 * l ? u.UP : r) && (h.push({
          pos: o,
          val: f[o]
        }), r = i);
      }

      for (h.push({
        pos: f.length,
        val: f[f.length - 1]
      }), a = h[0].pos; a < h[1].pos; a++) {
        f[a] = f[a] > l ? 0 : 1;
      }

      for (o = 1; o < h.length - 1; o++) {
        for (d = h[o + 1].val > h[o].val ? h[o].val + (h[o + 1].val - h[o].val) / 3 * 2 | 0 : h[o + 1].val + (h[o].val - h[o + 1].val) / 3 | 0, a = h[o].pos; a < h[o + 1].pos; a++) {
          f[a] = f[a] > d ? 0 : 1;
        }
      }

      return {
        line: f,
        threshold: d
      };
    }, a.debug = {
      printFrequency: function printFrequency(t, e) {
        var n,
            r = e.getContext("2d");

        for (e.width = t.length, e.height = 256, r.beginPath(), r.strokeStyle = "blue", n = 0; n < t.length; n++) {
          r.moveTo(n, 255), r.lineTo(n, 255 - t[n]);
        }

        r.stroke(), r.closePath();
      },
      printPattern: function printPattern(t, e) {
        var n,
            r = e.getContext("2d");

        for (e.width = t.length, r.fillColor = "black", n = 0; n < t.length; n++) {
          1 === t[n] && r.fillRect(n, 0, 1, 100);
        }
      }
    };

    var c,
        s = a,
        f = n(15),
        l = n(3),
        h = n.n(l),
        d = n(4),
        p = n.n(d),
        v = n(1),
        g = n.n(v),
        y = n(6),
        _ = n.n(y),
        m = n(5),
        b = n.n(m),
        w = n(2),
        x = n.n(w),
        E = n(0),
        A = n.n(E),
        R = n(9);

    !function (t) {
      t[t.Forward = 1] = "Forward", t[t.Reverse = -1] = "Reverse";
    }(c || (c = {}));

    var S = function () {
      function t(e, n) {
        return h()(this, t), A()(this, "_row", []), A()(this, "config", {}), A()(this, "supplements", []), A()(this, "SINGLE_CODE_ERROR", 0), A()(this, "FORMAT", "unknown"), A()(this, "CONFIG_KEYS", {}), this._row = [], this.config = e || {}, n && (this.supplements = n), this;
      }

      return p()(t, null, [{
        key: "Exception",
        get: function get() {
          return {
            StartNotFoundException: "Start-Info was not found!",
            CodeNotFoundException: "Code could not be found!",
            PatternNotFoundException: "Pattern could not be found!"
          };
        }
      }]), p()(t, [{
        key: "_nextUnset",
        value: function value(t) {
          for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = e; n < t.length; n++) {
            if (!t[n]) return n;
          }

          return t.length;
        }
      }, {
        key: "_matchPattern",
        value: function value(t, e, n) {
          var r,
              i = 0,
              o = 0,
              a = 0,
              u = 0,
              c = 0,
              s = 0;
          n = n || this.SINGLE_CODE_ERROR || 1;

          for (var f = 0; f < t.length; f++) {
            a += t[f], u += e[f];
          }

          if (a < u) return Number.MAX_VALUE;
          n *= r = a / u;

          for (var l = 0; l < t.length; l++) {
            if (c = t[l], s = e[l] * r, (o = Math.abs(c - s) / s) > n) return Number.MAX_VALUE;
            i += o;
          }

          return i / u;
        }
      }, {
        key: "_nextSet",
        value: function value(t) {
          for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = e; n < t.length; n++) {
            if (t[n]) return n;
          }

          return t.length;
        }
      }, {
        key: "_correctBars",
        value: function value(t, e, n) {
          for (var r = n.length, i = 0; r--;) {
            (i = t[n[r]] * (1 - (1 - e) / 2)) > 1 && (t[n[r]] = i);
          }
        }
      }, {
        key: "decodePattern",
        value: function value(t) {
          this._row = t;

          var e = this._decode();

          return null === e ? (this._row.reverse(), (e = this._decode()) && (e.direction = c.Reverse, e.start = this._row.length - e.start, e.end = this._row.length - e.end)) : e.direction = c.Forward, e && (e.format = this.FORMAT), e;
        }
      }, {
        key: "_matchRange",
        value: function value(t, e, n) {
          var r;

          for (r = t = t < 0 ? 0 : t; r < e; r++) {
            if (this._row[r] !== n) return !1;
          }

          return !0;
        }
      }, {
        key: "_fillCounters",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._nextUnset(this._row),
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._row.length,
              n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
              r = [],
              i = 0;
          r[i] = 0;

          for (var o = t; o < e; o++) {
            this._row[o] ^ (n ? 1 : 0) ? r[i]++ : (r[++i] = 1, n = !n);
          }

          return r;
        }
      }, {
        key: "_toCounters",
        value: function value(t, e) {
          var n = e.length,
              r = this._row.length,
              i = !this._row[t],
              o = 0;
          R.a.init(e, 0);

          for (var a = t; a < r; a++) {
            if (this._row[a] ^ (i ? 1 : 0)) e[o]++;else {
              if (++o === n) break;
              e[o] = 1, i = !i;
            }
          }

          return e;
        }
      }]), t;
    }();

    function O(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var k = function (t) {
      _()(n, t);

      var e = O(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "CODE_SHIFT", 98), A()(g()(t), "CODE_C", 99), A()(g()(t), "CODE_B", 100), A()(g()(t), "CODE_A", 101), A()(g()(t), "START_CODE_A", 103), A()(g()(t), "START_CODE_B", 104), A()(g()(t), "START_CODE_C", 105), A()(g()(t), "STOP_CODE", 106), A()(g()(t), "CODE_PATTERN", [[2, 1, 2, 2, 2, 2], [2, 2, 2, 1, 2, 2], [2, 2, 2, 2, 2, 1], [1, 2, 1, 2, 2, 3], [1, 2, 1, 3, 2, 2], [1, 3, 1, 2, 2, 2], [1, 2, 2, 2, 1, 3], [1, 2, 2, 3, 1, 2], [1, 3, 2, 2, 1, 2], [2, 2, 1, 2, 1, 3], [2, 2, 1, 3, 1, 2], [2, 3, 1, 2, 1, 2], [1, 1, 2, 2, 3, 2], [1, 2, 2, 1, 3, 2], [1, 2, 2, 2, 3, 1], [1, 1, 3, 2, 2, 2], [1, 2, 3, 1, 2, 2], [1, 2, 3, 2, 2, 1], [2, 2, 3, 2, 1, 1], [2, 2, 1, 1, 3, 2], [2, 2, 1, 2, 3, 1], [2, 1, 3, 2, 1, 2], [2, 2, 3, 1, 1, 2], [3, 1, 2, 1, 3, 1], [3, 1, 1, 2, 2, 2], [3, 2, 1, 1, 2, 2], [3, 2, 1, 2, 2, 1], [3, 1, 2, 2, 1, 2], [3, 2, 2, 1, 1, 2], [3, 2, 2, 2, 1, 1], [2, 1, 2, 1, 2, 3], [2, 1, 2, 3, 2, 1], [2, 3, 2, 1, 2, 1], [1, 1, 1, 3, 2, 3], [1, 3, 1, 1, 2, 3], [1, 3, 1, 3, 2, 1], [1, 1, 2, 3, 1, 3], [1, 3, 2, 1, 1, 3], [1, 3, 2, 3, 1, 1], [2, 1, 1, 3, 1, 3], [2, 3, 1, 1, 1, 3], [2, 3, 1, 3, 1, 1], [1, 1, 2, 1, 3, 3], [1, 1, 2, 3, 3, 1], [1, 3, 2, 1, 3, 1], [1, 1, 3, 1, 2, 3], [1, 1, 3, 3, 2, 1], [1, 3, 3, 1, 2, 1], [3, 1, 3, 1, 2, 1], [2, 1, 1, 3, 3, 1], [2, 3, 1, 1, 3, 1], [2, 1, 3, 1, 1, 3], [2, 1, 3, 3, 1, 1], [2, 1, 3, 1, 3, 1], [3, 1, 1, 1, 2, 3], [3, 1, 1, 3, 2, 1], [3, 3, 1, 1, 2, 1], [3, 1, 2, 1, 1, 3], [3, 1, 2, 3, 1, 1], [3, 3, 2, 1, 1, 1], [3, 1, 4, 1, 1, 1], [2, 2, 1, 4, 1, 1], [4, 3, 1, 1, 1, 1], [1, 1, 1, 2, 2, 4], [1, 1, 1, 4, 2, 2], [1, 2, 1, 1, 2, 4], [1, 2, 1, 4, 2, 1], [1, 4, 1, 1, 2, 2], [1, 4, 1, 2, 2, 1], [1, 1, 2, 2, 1, 4], [1, 1, 2, 4, 1, 2], [1, 2, 2, 1, 1, 4], [1, 2, 2, 4, 1, 1], [1, 4, 2, 1, 1, 2], [1, 4, 2, 2, 1, 1], [2, 4, 1, 2, 1, 1], [2, 2, 1, 1, 1, 4], [4, 1, 3, 1, 1, 1], [2, 4, 1, 1, 1, 2], [1, 3, 4, 1, 1, 1], [1, 1, 1, 2, 4, 2], [1, 2, 1, 1, 4, 2], [1, 2, 1, 2, 4, 1], [1, 1, 4, 2, 1, 2], [1, 2, 4, 1, 1, 2], [1, 2, 4, 2, 1, 1], [4, 1, 1, 2, 1, 2], [4, 2, 1, 1, 1, 2], [4, 2, 1, 2, 1, 1], [2, 1, 2, 1, 4, 1], [2, 1, 4, 1, 2, 1], [4, 1, 2, 1, 2, 1], [1, 1, 1, 1, 4, 3], [1, 1, 1, 3, 4, 1], [1, 3, 1, 1, 4, 1], [1, 1, 4, 1, 1, 3], [1, 1, 4, 3, 1, 1], [4, 1, 1, 1, 1, 3], [4, 1, 1, 3, 1, 1], [1, 1, 3, 1, 4, 1], [1, 1, 4, 1, 3, 1], [3, 1, 1, 1, 4, 1], [4, 1, 1, 1, 3, 1], [2, 1, 1, 4, 1, 2], [2, 1, 1, 2, 1, 4], [2, 1, 1, 2, 3, 2], [2, 3, 3, 1, 1, 1, 2]]), A()(g()(t), "SINGLE_CODE_ERROR", .64), A()(g()(t), "AVG_CODE_ERROR", .3), A()(g()(t), "FORMAT", "code_128"), A()(g()(t), "MODULE_INDICES", {
          bar: [0, 2, 4],
          space: [1, 3, 5]
        }), t;
      }

      return p()(n, [{
        key: "_decodeCode",
        value: function value(t, e) {
          for (var n = {
            error: Number.MAX_VALUE,
            code: -1,
            start: t,
            end: t,
            correction: {
              bar: 1,
              space: 1
            }
          }, r = [0, 0, 0, 0, 0, 0], i = t, o = !this._row[i], a = 0, u = i; u < this._row.length; u++) {
            if (this._row[u] ^ (o ? 1 : 0)) r[a]++;else {
              if (a === r.length - 1) {
                e && this._correct(r, e);

                for (var c = 0; c < this.CODE_PATTERN.length; c++) {
                  var s = this._matchPattern(r, this.CODE_PATTERN[c]);

                  s < n.error && (n.code = c, n.error = s);
                }

                return n.end = u, -1 === n.code || n.error > this.AVG_CODE_ERROR ? null : (this.CODE_PATTERN[n.code] && (n.correction.bar = this.calculateCorrection(this.CODE_PATTERN[n.code], r, this.MODULE_INDICES.bar), n.correction.space = this.calculateCorrection(this.CODE_PATTERN[n.code], r, this.MODULE_INDICES.space)), n);
              }

              r[++a] = 1, o = !o;
            }
          }

          return null;
        }
      }, {
        key: "_correct",
        value: function value(t, e) {
          this._correctBars(t, e.bar, this.MODULE_INDICES.bar), this._correctBars(t, e.space, this.MODULE_INDICES.space);
        }
      }, {
        key: "_findStart",
        value: function value() {
          for (var t = [0, 0, 0, 0, 0, 0], e = this._nextSet(this._row), n = {
            error: Number.MAX_VALUE,
            code: -1,
            start: 0,
            end: 0,
            correction: {
              bar: 1,
              space: 1
            }
          }, r = !1, i = 0, o = e; o < this._row.length; o++) {
            if (this._row[o] ^ (r ? 1 : 0)) t[i]++;else {
              if (i === t.length - 1) {
                for (var a = t.reduce(function (t, e) {
                  return t + e;
                }, 0), u = this.START_CODE_A; u <= this.START_CODE_C; u++) {
                  var c = this._matchPattern(t, this.CODE_PATTERN[u]);

                  c < n.error && (n.code = u, n.error = c);
                }

                if (n.error < this.AVG_CODE_ERROR) return n.start = o - a, n.end = o, n.correction.bar = this.calculateCorrection(this.CODE_PATTERN[n.code], t, this.MODULE_INDICES.bar), n.correction.space = this.calculateCorrection(this.CODE_PATTERN[n.code], t, this.MODULE_INDICES.space), n;

                for (var s = 0; s < 4; s++) {
                  t[s] = t[s + 2];
                }

                t[4] = 0, t[5] = 0, i--;
              } else i++;

              t[i] = 1, r = !r;
            }
          }

          return null;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var n = this,
              r = this._findStart();

          if (null === r) return null;
          var i = {
            code: r.code,
            start: r.start,
            end: r.end,
            correction: {
              bar: r.correction.bar,
              space: r.correction.space
            }
          },
              o = [];
          o.push(i);

          for (var a = i.code, u = function (t) {
            switch (t) {
              case n.START_CODE_A:
                return n.CODE_A;

              case n.START_CODE_B:
                return n.CODE_B;

              case n.START_CODE_C:
                return n.CODE_C;

              default:
                return null;
            }
          }(i.code), c = !1, s = !1, f = s, l = !0, h = 0, d = [], p = []; !c;) {
            if (f = s, s = !1, null !== (i = this._decodeCode(i.end, i.correction))) switch (i.code !== this.STOP_CODE && (l = !0), i.code !== this.STOP_CODE && (d.push(i.code), a += ++h * i.code), o.push(i), u) {
              case this.CODE_A:
                if (i.code < 64) p.push(String.fromCharCode(32 + i.code));else if (i.code < 96) p.push(String.fromCharCode(i.code - 64));else switch (i.code !== this.STOP_CODE && (l = !1), i.code) {
                  case this.CODE_SHIFT:
                    s = !0, u = this.CODE_B;
                    break;

                  case this.CODE_B:
                    u = this.CODE_B;
                    break;

                  case this.CODE_C:
                    u = this.CODE_C;
                    break;

                  case this.STOP_CODE:
                    c = !0;
                }
                break;

              case this.CODE_B:
                if (i.code < 96) p.push(String.fromCharCode(32 + i.code));else switch (i.code !== this.STOP_CODE && (l = !1), i.code) {
                  case this.CODE_SHIFT:
                    s = !0, u = this.CODE_A;
                    break;

                  case this.CODE_A:
                    u = this.CODE_A;
                    break;

                  case this.CODE_C:
                    u = this.CODE_C;
                    break;

                  case this.STOP_CODE:
                    c = !0;
                }
                break;

              case this.CODE_C:
                if (i.code < 100) p.push(i.code < 10 ? "0" + i.code : i.code);else switch (i.code !== this.STOP_CODE && (l = !1), i.code) {
                  case this.CODE_A:
                    u = this.CODE_A;
                    break;

                  case this.CODE_B:
                    u = this.CODE_B;
                    break;

                  case this.STOP_CODE:
                    c = !0;
                }
            } else c = !0;
            f && (u = u === this.CODE_A ? this.CODE_B : this.CODE_A);
          }

          return null === i ? null : (i.end = this._nextUnset(this._row, i.end), this._verifyTrailingWhitespace(i) ? (a -= h * d[d.length - 1]) % 103 !== d[d.length - 1] ? null : p.length ? (l && p.splice(p.length - 1, 1), {
            code: p.join(""),
            start: r.start,
            end: i.end,
            codeset: u,
            startInfo: r,
            decodedCodes: o,
            endInfo: i,
            format: this.FORMAT
          }) : null : null);
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t) {
          var e;
          return (e = t.end + (t.end - t.start) / 2) < this._row.length && this._matchRange(t.end, e, 0) ? t : null;
        }
      }, {
        key: "calculateCorrection",
        value: function value(t, e, n) {
          for (var r = n.length, i = 0, o = 0; r--;) {
            o += t[n[r]], i += e[n[r]];
          }

          return o / i;
        }
      }]), n;
    }(S),
        C = n(11);

    function j(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function M(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? j(Object(n), !0).forEach(function (e) {
          A()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function T(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var I = [1, 1, 1],
        D = [1, 1, 1, 1, 1],
        P = [1, 1, 2],
        L = [[3, 2, 1, 1], [2, 2, 2, 1], [2, 1, 2, 2], [1, 4, 1, 1], [1, 1, 3, 2], [1, 2, 3, 1], [1, 1, 1, 4], [1, 3, 1, 2], [1, 2, 1, 3], [3, 1, 1, 2], [1, 1, 2, 3], [1, 2, 2, 2], [2, 2, 1, 2], [1, 1, 4, 1], [2, 3, 1, 1], [1, 3, 2, 1], [4, 1, 1, 1], [2, 1, 3, 1], [3, 1, 2, 1], [2, 1, 1, 3]],
        U = [0, 11, 13, 14, 19, 25, 28, 21, 22, 26],
        z = function (t) {
      _()(n, t);

      var e = T(n);

      function n(t, r) {
        var i;
        return h()(this, n), i = e.call(this, Object(C.merge)({
          supplements: []
        }, t), r), A()(g()(i), "FORMAT", "ean_13"), A()(g()(i), "SINGLE_CODE_ERROR", .7), A()(g()(i), "STOP_PATTERN", [1, 1, 1]), i;
      }

      return p()(n, [{
        key: "_findPattern",
        value: function value(t, e, n, r) {
          var i = new Array(t.length).fill(0),
              o = {
            error: Number.MAX_VALUE,
            start: 0,
            end: 0
          },
              a = 0;
          e || (e = this._nextSet(this._row));

          for (var u = !1, c = e; c < this._row.length; c++) {
            if (this._row[c] ^ (n ? 1 : 0)) i[a] += 1;else {
              if (a === i.length - 1) {
                var s = this._matchPattern(i, t);

                if (s < .48 && o.error && s < o.error) return u = !0, o.error = s, o.start = c - i.reduce(function (t, e) {
                  return t + e;
                }, 0), o.end = c, o;

                if (r) {
                  for (var f = 0; f < i.length - 2; f++) {
                    i[f] = i[f + 2];
                  }

                  i[i.length - 2] = 0, i[i.length - 1] = 0, a--;
                }
              } else a++;

              i[a] = 1, n = !n;
            }
          }

          return u ? o : null;
        }
      }, {
        key: "_decodeCode",
        value: function value(t, e) {
          var n = [0, 0, 0, 0],
              r = t,
              i = {
            error: Number.MAX_VALUE,
            code: -1,
            start: t,
            end: t
          },
              o = !this._row[r],
              a = 0;
          e || (e = L.length);

          for (var u = r; u < this._row.length; u++) {
            if (this._row[u] ^ (o ? 1 : 0)) n[a]++;else {
              if (a === n.length - 1) {
                for (var c = 0; c < e; c++) {
                  var s = this._matchPattern(n, L[c]);

                  i.end = u, s < i.error && (i.code = c, i.error = s);
                }

                return i.error > .48 ? null : i;
              }

              n[++a] = 1, o = !o;
            }
          }

          return null;
        }
      }, {
        key: "_findStart",
        value: function value() {
          for (var t = this._nextSet(this._row), e = null; !e;) {
            if (!(e = this._findPattern(I, t, !1, !0))) return null;
            var n = e.start - (e.end - e.start);
            if (n >= 0 && this._matchRange(n, e.start, 0)) return e;
            t = e.end, e = null;
          }

          return null;
        }
      }, {
        key: "_calculateFirstDigit",
        value: function value(t) {
          for (var e = 0; e < U.length; e++) {
            if (t === U[e]) return e;
          }

          return null;
        }
      }, {
        key: "_decodePayload",
        value: function value(t, e, n) {
          for (var r = M({}, t), i = 0, o = 0; o < 6; o++) {
            if (!(r = this._decodeCode(r.end))) return null;
            r.code >= 10 ? (r.code -= 10, i |= 1 << 5 - o) : i |= 0 << 5 - o, e.push(r.code), n.push(r);
          }

          var a = this._calculateFirstDigit(i);

          if (null === a) return null;
          e.unshift(a);

          var u = this._findPattern(D, r.end, !0, !1);

          if (null === u || !u.end) return null;
          n.push(u);

          for (var c = 0; c < 6; c++) {
            if (!(u = this._decodeCode(u.end, 10))) return null;
            n.push(u), e.push(u.code);
          }

          return u;
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t) {
          var e = t.end + (t.end - t.start);
          return e < this._row.length && this._matchRange(t.end, e, 0) ? t : null;
        }
      }, {
        key: "_findEnd",
        value: function value(t, e) {
          var n = this._findPattern(this.STOP_PATTERN, t, e, !1);

          return null !== n ? this._verifyTrailingWhitespace(n) : null;
        }
      }, {
        key: "_checksum",
        value: function value(t) {
          for (var e = 0, n = t.length - 2; n >= 0; n -= 2) {
            e += t[n];
          }

          e *= 3;

          for (var r = t.length - 1; r >= 0; r -= 2) {
            e += t[r];
          }

          return e % 10 == 0;
        }
      }, {
        key: "_decodeExtensions",
        value: function value(t) {
          var e = this._nextSet(this._row, t),
              n = this._findPattern(P, e, !1, !1);

          if (null === n) return null;

          for (var r = 0; r < this.supplements.length; r++) {
            try {
              var i = this.supplements[r]._decode(this._row, n.end);

              if (null !== i) return {
                code: i.code,
                start: e,
                startInfo: n,
                end: i.end,
                decodedCodes: i.decodedCodes,
                format: this.supplements[r].FORMAT
              };
            } catch (t) {
              console.error("* decodeExtensions error in ", this.supplements[r], ": ", t);
            }
          }

          return null;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var n = new Array(),
              r = new Array(),
              i = {},
              o = this._findStart();

          if (!o) return null;
          var a = {
            start: o.start,
            end: o.end
          };
          if (r.push(a), !(a = this._decodePayload(a, n, r))) return null;
          if (!(a = this._findEnd(a.end, !1))) return null;
          if (r.push(a), !this._checksum(n)) return null;

          if (this.supplements.length > 0) {
            var u = this._decodeExtensions(a.end);

            if (!u) return null;
            if (!u.decodedCodes) return null;
            var c = u.decodedCodes[u.decodedCodes.length - 1],
                s = {
              start: c.start + ((c.end - c.start) / 2 | 0),
              end: c.end
            };
            if (!this._verifyTrailingWhitespace(s)) return null;
            i = {
              supplement: u,
              code: n.join("") + u.code
            };
          }

          return M(M({
            code: n.join(""),
            start: o.start,
            end: a.end,
            startInfo: o,
            decodedCodes: r
          }, i), {}, {
            format: this.FORMAT
          });
        }
      }]), n;
    }(S),
        B = n(26),
        N = n.n(B);

    function W(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var F = new Uint16Array(N()("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. *$/+%").map(function (t) {
      return t.charCodeAt(0);
    })),
        q = new Uint16Array([52, 289, 97, 352, 49, 304, 112, 37, 292, 100, 265, 73, 328, 25, 280, 88, 13, 268, 76, 28, 259, 67, 322, 19, 274, 82, 7, 262, 70, 22, 385, 193, 448, 145, 400, 208, 133, 388, 196, 148, 168, 162, 138, 42]),
        V = function (t) {
      _()(n, t);

      var e = W(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "code_39"), t;
      }

      return p()(n, [{
        key: "_findStart",
        value: function value() {
          for (var t = this._nextSet(this._row), e = t, n = new Uint16Array([0, 0, 0, 0, 0, 0, 0, 0, 0]), r = 0, i = !1, o = t; o < this._row.length; o++) {
            if (this._row[o] ^ (i ? 1 : 0)) n[r]++;else {
              if (r === n.length - 1) {
                if (148 === this._toPattern(n)) {
                  var a = Math.floor(Math.max(0, e - (o - e) / 4));
                  if (this._matchRange(a, e, 0)) return {
                    start: e,
                    end: o
                  };
                }

                e += n[0] + n[1];

                for (var u = 0; u < 7; u++) {
                  n[u] = n[u + 2];
                }

                n[7] = 0, n[8] = 0, r--;
              } else r++;

              n[r] = 1, i = !i;
            }
          }

          return null;
        }
      }, {
        key: "_toPattern",
        value: function value(t) {
          for (var e = t.length, n = 0, r = e, i = 0; r > 3;) {
            n = this._findNextWidth(t, n), r = 0;

            for (var o = 0, a = 0; a < e; a++) {
              t[a] > n && (o |= 1 << e - 1 - a, r++, i += t[a]);
            }

            if (3 === r) {
              for (var u = 0; u < e && r > 0; u++) {
                if (t[u] > n && (r--, 2 * t[u] >= i)) return -1;
              }

              return o;
            }
          }

          return -1;
        }
      }, {
        key: "_findNextWidth",
        value: function value(t, e) {
          for (var n = Number.MAX_VALUE, r = 0; r < t.length; r++) {
            t[r] < n && t[r] > e && (n = t[r]);
          }

          return n;
        }
      }, {
        key: "_patternToChar",
        value: function value(t) {
          for (var e = 0; e < q.length; e++) {
            if (q[e] === t) return String.fromCharCode(F[e]);
          }

          return null;
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t, e, n) {
          var r = R.a.sum(n);
          return 3 * (e - t - r) >= r;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var n = new Uint16Array([0, 0, 0, 0, 0, 0, 0, 0, 0]),
              r = [];
          if (!(e = this._findStart())) return null;

          var i,
              o,
              a = this._nextSet(this._row, e.end);

          do {
            n = this._toCounters(a, n);

            var u = this._toPattern(n);

            if (u < 0) return null;
            if (null === (i = this._patternToChar(u))) return null;
            r.push(i), o = a, a += R.a.sum(n), a = this._nextSet(this._row, a);
          } while ("*" !== i);

          return r.pop(), r.length && this._verifyTrailingWhitespace(o, a, n) ? {
            code: r.join(""),
            start: e.start,
            end: a,
            startInfo: e,
            decodedCodes: r,
            format: this.FORMAT
          } : null;
        }
      }]), n;
    }(S),
        Y = n(16),
        G = n.n(Y);

    function H(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var $ = /[IOQ]/g,
        X = /[A-Z0-9]{17}/,
        Z = function (t) {
      _()(n, t);

      var e = H(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "code_39_vin"), t;
      }

      return p()(n, [{
        key: "_checkChecksum",
        value: function value(t) {
          return !!t;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var r = G()(x()(n.prototype), "_decode", this).call(this, t, e);
          if (!r) return null;
          var i = r.code;
          return i && (i = i.replace($, "")).match(X) && this._checkChecksum(i) ? (r.code = i, r) : null;
        }
      }]), n;
    }(V);

    function Q(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var K = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 45, 36, 58, 47, 46, 43, 65, 66, 67, 68],
        J = [3, 6, 9, 96, 18, 66, 33, 36, 48, 72, 12, 24, 69, 81, 84, 21, 26, 41, 11, 14],
        tt = [26, 41, 11, 14],
        et = function (t) {
      _()(n, t);

      var e = Q(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "_counters", []), A()(g()(t), "FORMAT", "codabar"), t;
      }

      return p()(n, [{
        key: "_computeAlternatingThreshold",
        value: function value(t, e) {
          for (var n = Number.MAX_VALUE, r = 0, i = 0, o = t; o < e; o += 2) {
            (i = this._counters[o]) > r && (r = i), i < n && (n = i);
          }

          return (n + r) / 2 | 0;
        }
      }, {
        key: "_toPattern",
        value: function value(t) {
          var e = t + 7;
          if (e > this._counters.length) return -1;

          for (var n = this._computeAlternatingThreshold(t, e), r = this._computeAlternatingThreshold(t + 1, e), i = 64, o = 0, a = 0, u = 0; u < 7; u++) {
            o = 0 == (1 & u) ? n : r, this._counters[t + u] > o && (a |= i), i >>= 1;
          }

          return a;
        }
      }, {
        key: "_isStartEnd",
        value: function value(t) {
          for (var e = 0; e < tt.length; e++) {
            if (tt[e] === t) return !0;
          }

          return !1;
        }
      }, {
        key: "_sumCounters",
        value: function value(t, e) {
          for (var n = 0, r = t; r < e; r++) {
            n += this._counters[r];
          }

          return n;
        }
      }, {
        key: "_findStart",
        value: function value() {
          for (var t = this._nextUnset(this._row), e = 1; e < this._counters.length; e++) {
            var n = this._toPattern(e);

            if (-1 !== n && this._isStartEnd(n)) return {
              start: t += this._sumCounters(0, e),
              end: t + this._sumCounters(e, e + 8),
              startCounter: e,
              endCounter: e + 8
            };
          }

          return null;
        }
      }, {
        key: "_patternToChar",
        value: function value(t) {
          for (var e = 0; e < J.length; e++) {
            if (J[e] === t) return String.fromCharCode(K[e]);
          }

          return null;
        }
      }, {
        key: "_calculatePatternLength",
        value: function value(t) {
          for (var e = 0, n = t; n < t + 7; n++) {
            e += this._counters[n];
          }

          return e;
        }
      }, {
        key: "_verifyWhitespace",
        value: function value(t, e) {
          return (t - 1 <= 0 || this._counters[t - 1] >= this._calculatePatternLength(t) / 2) && (e + 8 >= this._counters.length || this._counters[e + 7] >= this._calculatePatternLength(e) / 2);
        }
      }, {
        key: "_charToPattern",
        value: function value(t) {
          for (var e = t.charCodeAt(0), n = 0; n < K.length; n++) {
            if (K[n] === e) return J[n];
          }

          return 0;
        }
      }, {
        key: "_thresholdResultPattern",
        value: function value(t, e) {
          for (var n, r = {
            space: {
              narrow: {
                size: 0,
                counts: 0,
                min: 0,
                max: Number.MAX_VALUE
              },
              wide: {
                size: 0,
                counts: 0,
                min: 0,
                max: Number.MAX_VALUE
              }
            },
            bar: {
              narrow: {
                size: 0,
                counts: 0,
                min: 0,
                max: Number.MAX_VALUE
              },
              wide: {
                size: 0,
                counts: 0,
                min: 0,
                max: Number.MAX_VALUE
              }
            }
          }, i = e, o = 0; o < t.length; o++) {
            n = this._charToPattern(t[o]);

            for (var a = 6; a >= 0; a--) {
              var u = 2 == (1 & a) ? r.bar : r.space,
                  c = 1 == (1 & n) ? u.wide : u.narrow;
              c.size += this._counters[i + a], c.counts++, n >>= 1;
            }

            i += 8;
          }

          return ["space", "bar"].forEach(function (t) {
            var e = r[t];
            e.wide.min = Math.floor((e.narrow.size / e.narrow.counts + e.wide.size / e.wide.counts) / 2), e.narrow.max = Math.ceil(e.wide.min), e.wide.max = Math.ceil((2 * e.wide.size + 1.5) / e.wide.counts);
          }), r;
        }
      }, {
        key: "_validateResult",
        value: function value(t, e) {
          for (var n, r = this._thresholdResultPattern(t, e), i = e, o = 0; o < t.length; o++) {
            n = this._charToPattern(t[o]);

            for (var a = 6; a >= 0; a--) {
              var u = 0 == (1 & a) ? r.bar : r.space,
                  c = 1 == (1 & n) ? u.wide : u.narrow,
                  s = this._counters[i + a];
              if (s < c.min || s > c.max) return !1;
              n >>= 1;
            }

            i += 8;
          }

          return !0;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          if (this._counters = this._fillCounters(), !(e = this._findStart())) return null;
          var n,
              r = e.startCounter,
              i = [];

          do {
            if ((n = this._toPattern(r)) < 0) return null;

            var o = this._patternToChar(n);

            if (null === o) return null;
            if (i.push(o), r += 8, i.length > 1 && this._isStartEnd(n)) break;
          } while (r < this._counters.length);

          if (i.length - 2 < 4 || !this._isStartEnd(n)) return null;
          if (!this._verifyWhitespace(e.startCounter, r - 8)) return null;
          if (!this._validateResult(i, e.startCounter)) return null;
          r = r > this._counters.length ? this._counters.length : r;

          var a = e.start + this._sumCounters(e.startCounter, r - 8);

          return {
            code: i.join(""),
            start: e.start,
            end: a,
            startInfo: e,
            decodedCodes: i,
            format: this.FORMAT
          };
        }
      }]), n;
    }(S);

    function nt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var rt = function (t) {
      _()(n, t);

      var e = nt(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "upc_a"), t;
      }

      return p()(n, [{
        key: "_decode",
        value: function value(t, e) {
          var n = z.prototype._decode.call(this);

          return n && n.code && 13 === n.code.length && "0" === n.code.charAt(0) ? (n.code = n.code.substring(1), n) : null;
        }
      }]), n;
    }(z);

    function it(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var ot = function (t) {
      _()(n, t);

      var e = it(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "ean_8"), t;
      }

      return p()(n, [{
        key: "_decodePayload",
        value: function value(t, e, n) {
          for (var r = t, i = 0; i < 4; i++) {
            if (!(r = this._decodeCode(r.end, 10))) return null;
            e.push(r.code), n.push(r);
          }

          if (null === (r = this._findPattern(D, r.end, !0, !1))) return null;
          n.push(r);

          for (var o = 0; o < 4; o++) {
            if (!(r = this._decodeCode(r.end, 10))) return null;
            n.push(r), e.push(r.code);
          }

          return r;
        }
      }]), n;
    }(z);

    function at(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var ut = function (t) {
      _()(n, t);

      var e = at(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "ean_2"), t;
      }

      return p()(n, [{
        key: "_decode",
        value: function value(t, e) {
          t && (this._row = t);
          var n = 0,
              r = e,
              i = this._row.length,
              o = [],
              a = [],
              u = null;
          if (void 0 === r) return null;

          for (var c = 0; c < 2 && r < i; c++) {
            if (!(u = this._decodeCode(r))) return null;
            a.push(u), o.push(u.code % 10), u.code >= 10 && (n |= 1 << 1 - c), 1 !== c && (r = this._nextSet(this._row, u.end), r = this._nextUnset(this._row, r));
          }

          if (2 !== o.length || parseInt(o.join("")) % 4 !== n) return null;

          var s = this._findStart();

          return {
            code: o.join(""),
            decodedCodes: a,
            end: u.end,
            format: this.FORMAT,
            startInfo: s,
            start: s.start
          };
        }
      }]), n;
    }(z);

    function ct(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var st = [24, 20, 18, 17, 12, 6, 3, 10, 9, 5];

    var ft = function (t) {
      _()(n, t);

      var e = ct(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "ean_5"), t;
      }

      return p()(n, [{
        key: "_decode",
        value: function value(t, e) {
          if (void 0 === e) return null;
          t && (this._row = t);

          for (var n = 0, r = e, i = this._row.length, o = null, a = [], u = [], c = 0; c < 5 && r < i; c++) {
            if (!(o = this._decodeCode(r))) return null;
            u.push(o), a.push(o.code % 10), o.code >= 10 && (n |= 1 << 4 - c), 4 !== c && (r = this._nextSet(this._row, o.end), r = this._nextUnset(this._row, r));
          }

          if (5 !== a.length) return null;
          if (function (t) {
            for (var e = t.length, n = 0, r = e - 2; r >= 0; r -= 2) {
              n += t[r];
            }

            n *= 3;

            for (var i = e - 1; i >= 0; i -= 2) {
              n += t[i];
            }

            return (n *= 3) % 10;
          }(a) !== function (t) {
            for (var e = 0; e < 10; e++) {
              if (t === st[e]) return e;
            }

            return null;
          }(n)) return null;

          var s = this._findStart();

          return {
            code: a.join(""),
            decodedCodes: u,
            end: o.end,
            format: this.FORMAT,
            startInfo: s,
            start: s.start
          };
        }
      }]), n;
    }(z);

    function lt(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ht(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var dt = function (t) {
      _()(n, t);

      var e = ht(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "CODE_FREQUENCY", [[56, 52, 50, 49, 44, 38, 35, 42, 41, 37], [7, 11, 13, 14, 19, 25, 28, 21, 22, 26]]), A()(g()(t), "STOP_PATTERN", [1 / 6 * 7, 1 / 6 * 7, 1 / 6 * 7, 1 / 6 * 7, 1 / 6 * 7, 1 / 6 * 7]), A()(g()(t), "FORMAT", "upc_e"), t;
      }

      return p()(n, [{
        key: "_decodePayload",
        value: function value(t, e, n) {
          for (var r = function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? lt(Object(n), !0).forEach(function (e) {
                A()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }

            return t;
          }({}, t), i = 0, o = 0; o < 6; o++) {
            if (!(r = this._decodeCode(r.end))) return null;
            r.code >= 10 && (r.code = r.code - 10, i |= 1 << 5 - o), e.push(r.code), n.push(r);
          }

          return this._determineParity(i, e) ? r : null;
        }
      }, {
        key: "_determineParity",
        value: function value(t, e) {
          for (var n = 0; n < this.CODE_FREQUENCY.length; n++) {
            for (var r = 0; r < this.CODE_FREQUENCY[n].length; r++) {
              if (t === this.CODE_FREQUENCY[n][r]) return e.unshift(n), e.push(r), !0;
            }
          }

          return !1;
        }
      }, {
        key: "_convertToUPCA",
        value: function value(t) {
          var e = [t[0]],
              n = t[t.length - 2];
          return (e = n <= 2 ? e.concat(t.slice(1, 3)).concat([n, 0, 0, 0, 0]).concat(t.slice(3, 6)) : 3 === n ? e.concat(t.slice(1, 4)).concat([0, 0, 0, 0, 0]).concat(t.slice(4, 6)) : 4 === n ? e.concat(t.slice(1, 5)).concat([0, 0, 0, 0, 0, t[5]]) : e.concat(t.slice(1, 6)).concat([0, 0, 0, 0, n])).push(t[t.length - 1]), e;
        }
      }, {
        key: "_checksum",
        value: function value(t) {
          return G()(x()(n.prototype), "_checksum", this).call(this, this._convertToUPCA(t));
        }
      }, {
        key: "_findEnd",
        value: function value(t, e) {
          return G()(x()(n.prototype), "_findEnd", this).call(this, t, !0);
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t) {
          var e = t.end + (t.end - t.start) / 2;
          return e < this._row.length && this._matchRange(t.end, e, 0) ? t : null;
        }
      }]), n;
    }(z);

    function pt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var vt = function (t) {
      _()(n, t);

      var e = pt(n);

      function n(t) {
        var r;
        return h()(this, n), r = e.call(this, Object(C.merge)({
          normalizeBarSpaceWidth: !1
        }, t)), A()(g()(r), "barSpaceRatio", [1, 1]), A()(g()(r), "SINGLE_CODE_ERROR", .78), A()(g()(r), "AVG_CODE_ERROR", .38), A()(g()(r), "START_PATTERN", [1, 1, 1, 1]), A()(g()(r), "STOP_PATTERN", [1, 1, 3]), A()(g()(r), "CODE_PATTERN", [[1, 1, 3, 3, 1], [3, 1, 1, 1, 3], [1, 3, 1, 1, 3], [3, 3, 1, 1, 1], [1, 1, 3, 1, 3], [3, 1, 3, 1, 1], [1, 3, 3, 1, 1], [1, 1, 1, 3, 3], [3, 1, 1, 3, 1], [1, 3, 1, 3, 1]]), A()(g()(r), "MAX_CORRECTION_FACTOR", 5), A()(g()(r), "FORMAT", "i2of5"), t.normalizeBarSpaceWidth && (r.SINGLE_CODE_ERROR = .38, r.AVG_CODE_ERROR = .09), r.config = t, b()(r, g()(r));
      }

      return p()(n, [{
        key: "_matchPattern",
        value: function value(t, e) {
          if (this.config.normalizeBarSpaceWidth) {
            for (var n = [0, 0], r = [0, 0], i = [0, 0], o = this.MAX_CORRECTION_FACTOR, a = 1 / o, u = 0; u < t.length; u++) {
              n[u % 2] += t[u], r[u % 2] += e[u];
            }

            i[0] = r[0] / n[0], i[1] = r[1] / n[1], i[0] = Math.max(Math.min(i[0], o), a), i[1] = Math.max(Math.min(i[1], o), a), this.barSpaceRatio = i;

            for (var c = 0; c < t.length; c++) {
              t[c] *= this.barSpaceRatio[c % 2];
            }
          }

          return S.prototype._matchPattern.call(this, t, e);
        }
      }, {
        key: "_findPattern",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
              i = new Array(t.length).fill(0),
              o = 0,
              a = {
            error: Number.MAX_VALUE,
            code: -1,
            start: 0,
            end: 0
          },
              u = this.AVG_CODE_ERROR;
          n = n || !1, r = r || !1, e || (e = this._nextSet(this._row));

          for (var c = e; c < this._row.length; c++) {
            if (this._row[c] ^ (n ? 1 : 0)) i[o]++;else {
              if (o === i.length - 1) {
                var s = i.reduce(function (t, e) {
                  return t + e;
                }, 0),
                    f = this._matchPattern(i, t);

                if (f < u) return a.error = f, a.start = c - s, a.end = c, a;
                if (!r) return null;

                for (var l = 0; l < i.length - 2; l++) {
                  i[l] = i[l + 2];
                }

                i[i.length - 2] = 0, i[i.length - 1] = 0, o--;
              } else o++;

              i[o] = 1, n = !n;
            }
          }

          return null;
        }
      }, {
        key: "_findStart",
        value: function value() {
          for (var t = 0, e = this._nextSet(this._row), n = null, r = 1; !n;) {
            if (!(n = this._findPattern(this.START_PATTERN, e, !1, !0))) return null;
            if (r = Math.floor((n.end - n.start) / 4), (t = n.start - 10 * r) >= 0 && this._matchRange(t, n.start, 0)) return n;
            e = n.end, n = null;
          }

          return null;
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t) {
          var e = t.end + (t.end - t.start) / 2;
          return e < this._row.length && this._matchRange(t.end, e, 0) ? t : null;
        }
      }, {
        key: "_findEnd",
        value: function value() {
          this._row.reverse();

          var t = this._findPattern(this.STOP_PATTERN);

          if (this._row.reverse(), null === t) return null;
          var e = t.start;
          return t.start = this._row.length - t.end, t.end = this._row.length - e, null !== t ? this._verifyTrailingWhitespace(t) : null;
        }
      }, {
        key: "_decodePair",
        value: function value(t) {
          for (var e = [], n = 0; n < t.length; n++) {
            var r = this._decodeCode(t[n]);

            if (!r) return null;
            e.push(r);
          }

          return e;
        }
      }, {
        key: "_decodeCode",
        value: function value(t) {
          for (var e = this.AVG_CODE_ERROR, n = {
            error: Number.MAX_VALUE,
            code: -1,
            start: 0,
            end: 0
          }, r = 0; r < this.CODE_PATTERN.length; r++) {
            var i = this._matchPattern(t, this.CODE_PATTERN[r]);

            i < n.error && (n.code = r, n.error = i);
          }

          return n.error < e ? n : null;
        }
      }, {
        key: "_decodePayload",
        value: function value(t, e, n) {
          for (var r = 0, i = t.length, o = [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0]], a = null; r < i;) {
            for (var u = 0; u < 5; u++) {
              o[0][u] = t[r] * this.barSpaceRatio[0], o[1][u] = t[r + 1] * this.barSpaceRatio[1], r += 2;
            }

            if (!(a = this._decodePair(o))) return null;

            for (var c = 0; c < a.length; c++) {
              e.push(a[c].code + ""), n.push(a[c]);
            }
          }

          return a;
        }
      }, {
        key: "_verifyCounterLength",
        value: function value(t) {
          return t.length % 10 == 0;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var n = new Array(),
              r = new Array(),
              i = this._findStart();

          if (!i) return null;
          r.push(i);

          var o = this._findEnd();

          if (!o) return null;

          var a = this._fillCounters(i.end, o.start, !1);

          return this._verifyCounterLength(a) && this._decodePayload(a, n, r) ? n.length % 2 != 0 || n.length < 6 ? null : (r.push(o), {
            code: n.join(""),
            start: i.start,
            end: o.end,
            startInfo: i,
            decodedCodes: r,
            format: this.FORMAT
          }) : null;
        }
      }]), n;
    }(S);

    function gt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var yt = [3, 1, 3, 1, 1, 1],
        _t = [3, 1, 1, 1, 3],
        mt = [[1, 1, 3, 3, 1], [3, 1, 1, 1, 3], [1, 3, 1, 1, 3], [3, 3, 1, 1, 1], [1, 1, 3, 1, 3], [3, 1, 3, 1, 1], [1, 3, 3, 1, 1], [1, 1, 1, 3, 3], [3, 1, 1, 3, 1], [1, 3, 1, 3, 1]],
        bt = yt.reduce(function (t, e) {
      return t + e;
    }, 0),
        wt = function (t) {
      _()(n, t);

      var e = gt(n);

      function n() {
        var t;
        h()(this, n);

        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "barSpaceRatio", [1, 1]), A()(g()(t), "FORMAT", "2of5"), A()(g()(t), "SINGLE_CODE_ERROR", .78), A()(g()(t), "AVG_CODE_ERROR", .3), t;
      }

      return p()(n, [{
        key: "_findPattern",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
              i = [],
              o = 0,
              a = {
            error: Number.MAX_VALUE,
            code: -1,
            start: 0,
            end: 0
          },
              u = 0,
              c = 0,
              s = this.AVG_CODE_ERROR;
          e || (e = this._nextSet(this._row));

          for (var f = 0; f < t.length; f++) {
            i[f] = 0;
          }

          for (var l = e; l < this._row.length; l++) {
            if (this._row[l] ^ (n ? 1 : 0)) i[o]++;else {
              if (o === i.length - 1) {
                u = 0;

                for (var h = 0; h < i.length; h++) {
                  u += i[h];
                }

                if ((c = this._matchPattern(i, t)) < s) return a.error = c, a.start = l - u, a.end = l, a;
                if (!r) return null;

                for (var d = 0; d < i.length - 2; d++) {
                  i[d] = i[d + 2];
                }

                i[i.length - 2] = 0, i[i.length - 1] = 0, o--;
              } else o++;

              i[o] = 1, n = !n;
            }
          }

          return null;
        }
      }, {
        key: "_findStart",
        value: function value() {
          for (var t = null, e = this._nextSet(this._row), n = 1, r = 0; !t;) {
            if (!(t = this._findPattern(yt, e, !1, !0))) return null;
            if (n = Math.floor((t.end - t.start) / bt), (r = t.start - 5 * n) >= 0 && this._matchRange(r, t.start, 0)) return t;
            e = t.end, t = null;
          }

          return t;
        }
      }, {
        key: "_verifyTrailingWhitespace",
        value: function value(t) {
          var e = t.end + (t.end - t.start) / 2;
          return e < this._row.length && this._matchRange(t.end, e, 0) ? t : null;
        }
      }, {
        key: "_findEnd",
        value: function value() {
          this._row.reverse();

          var t = this._nextSet(this._row),
              e = this._findPattern(_t, t, !1, !0);

          if (this._row.reverse(), null === e) return null;
          var n = e.start;
          return e.start = this._row.length - e.end, e.end = this._row.length - n, null !== e ? this._verifyTrailingWhitespace(e) : null;
        }
      }, {
        key: "_verifyCounterLength",
        value: function value(t) {
          return t.length % 10 == 0;
        }
      }, {
        key: "_decodeCode",
        value: function value(t) {
          for (var e = this.AVG_CODE_ERROR, n = {
            error: Number.MAX_VALUE,
            code: -1,
            start: 0,
            end: 0
          }, r = 0; r < mt.length; r++) {
            var i = this._matchPattern(t, mt[r]);

            i < n.error && (n.code = r, n.error = i);
          }

          return n.error < e ? n : null;
        }
      }, {
        key: "_decodePayload",
        value: function value(t, e, n) {
          for (var r = 0, i = t.length, o = [0, 0, 0, 0, 0], a = null; r < i;) {
            for (var u = 0; u < 5; u++) {
              o[u] = t[r] * this.barSpaceRatio[0], r += 2;
            }

            if (!(a = this._decodeCode(o))) return null;
            e.push("".concat(a.code)), n.push(a);
          }

          return a;
        }
      }, {
        key: "_decode",
        value: function value(t, e) {
          var n = this._findStart();

          if (!n) return null;

          var r = this._findEnd();

          if (!r) return null;

          var i = this._fillCounters(n.end, r.start, !1);

          if (!this._verifyCounterLength(i)) return null;
          var o = [];
          o.push(n);
          var a = [];
          return this._decodePayload(i, a, o) ? a.length < 5 ? null : (o.push(r), {
            code: a.join(""),
            start: n.start,
            end: r.end,
            startInfo: n,
            decodedCodes: o,
            format: this.FORMAT
          }) : null;
        }
      }]), n;
    }(S);

    function xt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var Et = new Uint16Array(N()("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*").map(function (t) {
      return t.charCodeAt(0);
    })),
        At = new Uint16Array([276, 328, 324, 322, 296, 292, 290, 336, 274, 266, 424, 420, 418, 404, 402, 394, 360, 356, 354, 308, 282, 344, 332, 326, 300, 278, 436, 434, 428, 422, 406, 410, 364, 358, 310, 314, 302, 468, 466, 458, 366, 374, 430, 294, 474, 470, 306, 350]);

    function Rt(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = x()(t);

        if (e) {
          var i = x()(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return b()(this, n);
      };
    }

    var St,
        Ot = /[AEIO]/g,
        kt = /[A-Z0-9]/,
        Ct = [{
      digit_code: 0,
      character_code: "0"
    }, {
      digit_code: 1,
      character_code: "1"
    }, {
      digit_code: 2,
      character_code: "2"
    }, {
      digit_code: 3,
      character_code: "3"
    }, {
      digit_code: 4,
      character_code: "4"
    }, {
      digit_code: 5,
      character_code: "5"
    }, {
      digit_code: 6,
      character_code: "6"
    }, {
      digit_code: 7,
      character_code: "7"
    }, {
      digit_code: 8,
      character_code: "8"
    }, {
      digit_code: 9,
      character_code: "9"
    }, {
      digit_code: 10,
      character_code: "B"
    }, {
      digit_code: 11,
      character_code: "C"
    }, {
      digit_code: 12,
      character_code: "D"
    }, {
      digit_code: 13,
      character_code: "F"
    }, {
      digit_code: 14,
      character_code: "G"
    }, {
      digit_code: 15,
      character_code: "H"
    }, {
      digit_code: 16,
      character_code: "J"
    }, {
      digit_code: 17,
      character_code: "K"
    }, {
      digit_code: 18,
      character_code: "L"
    }, {
      digit_code: 19,
      character_code: "M"
    }, {
      digit_code: 20,
      character_code: "N"
    }, {
      digit_code: 21,
      character_code: "P"
    }, {
      digit_code: 22,
      character_code: "Q"
    }, {
      digit_code: 23,
      character_code: "R"
    }, {
      digit_code: 24,
      character_code: "S"
    }, {
      digit_code: 25,
      character_code: "T"
    }, {
      digit_code: 26,
      character_code: "U"
    }, {
      digit_code: 27,
      character_code: "V"
    }, {
      digit_code: 28,
      character_code: "W"
    }, {
      digit_code: 29,
      character_code: "X"
    }, {
      digit_code: 30,
      character_code: "Y"
    }, {
      digit_code: 31,
      character_code: "Z"
    }],
        jt = {
      code_128_reader: k,
      ean_reader: z,
      ean_5_reader: ft,
      ean_2_reader: ut,
      ean_8_reader: ot,
      code_39_reader: V,
      code_39_vin_reader: Z,
      codabar_reader: et,
      upc_reader: rt,
      upc_e_reader: dt,
      i2of5_reader: vt,
      "2of5_reader": wt,
      code_93_reader: function (t) {
        _()(n, t);

        var e = xt(n);

        function n() {
          var t;
          h()(this, n);

          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
            i[o] = arguments[o];
          }

          return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "code_93"), t;
        }

        return p()(n, [{
          key: "_patternToChar",
          value: function value(t) {
            for (var e = 0; e < At.length; e++) {
              if (At[e] === t) return String.fromCharCode(Et[e]);
            }

            return null;
          }
        }, {
          key: "_toPattern",
          value: function value(t) {
            for (var e = t.length, n = t.reduce(function (t, e) {
              return t + e;
            }, 0), r = 0, i = 0; i < e; i++) {
              var o = Math.round(9 * t[i] / n);
              if (o < 1 || o > 4) return -1;
              if (0 == (1 & i)) for (var a = 0; a < o; a++) {
                r = r << 1 | 1;
              } else r <<= o;
            }

            return r;
          }
        }, {
          key: "_findStart",
          value: function value() {
            for (var t = this._nextSet(this._row), e = t, n = new Uint16Array([0, 0, 0, 0, 0, 0]), r = 0, i = !1, o = t; o < this._row.length; o++) {
              if (this._row[o] ^ (i ? 1 : 0)) n[r]++;else {
                if (r === n.length - 1) {
                  if (350 === this._toPattern(n)) {
                    var a = Math.floor(Math.max(0, e - (o - e) / 4));
                    if (this._matchRange(a, e, 0)) return {
                      start: e,
                      end: o
                    };
                  }

                  e += n[0] + n[1];

                  for (var u = 0; u < 4; u++) {
                    n[u] = n[u + 2];
                  }

                  n[4] = 0, n[5] = 0, r--;
                } else r++;

                n[r] = 1, i = !i;
              }
            }

            return null;
          }
        }, {
          key: "_verifyEnd",
          value: function value(t, e) {
            return !(t === e || !this._row[e]);
          }
        }, {
          key: "_decodeExtended",
          value: function value(t) {
            for (var e = t.length, n = [], r = 0; r < e; r++) {
              var i = t[r];

              if (i >= "a" && i <= "d") {
                if (r > e - 2) return null;
                var o = t[++r],
                    a = o.charCodeAt(0),
                    u = void 0;

                switch (i) {
                  case "a":
                    if (!(o >= "A" && o <= "Z")) return null;
                    u = String.fromCharCode(a - 64);
                    break;

                  case "b":
                    if (o >= "A" && o <= "E") u = String.fromCharCode(a - 38);else if (o >= "F" && o <= "J") u = String.fromCharCode(a - 11);else if (o >= "K" && o <= "O") u = String.fromCharCode(a + 16);else if (o >= "P" && o <= "S") u = String.fromCharCode(a + 43);else {
                      if (!(o >= "T" && o <= "Z")) return null;
                      u = String.fromCharCode(127);
                    }
                    break;

                  case "c":
                    if (o >= "A" && o <= "O") u = String.fromCharCode(a - 32);else {
                      if ("Z" !== o) return null;
                      u = ":";
                    }
                    break;

                  case "d":
                    if (!(o >= "A" && o <= "Z")) return null;
                    u = String.fromCharCode(a + 32);
                    break;

                  default:
                    return console.warn("* code_93_reader _decodeExtended hit default case, this may be an error", u), null;
                }

                n.push(u);
              } else n.push(i);
            }

            return n;
          }
        }, {
          key: "_matchCheckChar",
          value: function value(t, e, n) {
            var r = t.slice(0, e),
                i = r.length,
                o = r.reduce(function (t, e, r) {
              return t + ((-1 * r + (i - 1)) % n + 1) * Et.indexOf(e.charCodeAt(0));
            }, 0);
            return Et[o % 47] === t[e].charCodeAt(0);
          }
        }, {
          key: "_verifyChecksums",
          value: function value(t) {
            return this._matchCheckChar(t, t.length - 2, 20) && this._matchCheckChar(t, t.length - 1, 15);
          }
        }, {
          key: "_decode",
          value: function value(t, e) {
            if (!(e = this._findStart())) return null;

            var n,
                r,
                i = new Uint16Array([0, 0, 0, 0, 0, 0]),
                o = [],
                a = this._nextSet(this._row, e.end);

            do {
              i = this._toCounters(a, i);

              var u = this._toPattern(i);

              if (u < 0) return null;
              if (null === (r = this._patternToChar(u))) return null;
              o.push(r), n = a, a += R.a.sum(i), a = this._nextSet(this._row, a);
            } while ("*" !== r);

            return o.pop(), o.length && this._verifyEnd(n, a) && this._verifyChecksums(o) ? (o = o.slice(0, o.length - 2), null === (o = this._decodeExtended(o)) ? null : {
              code: o.join(""),
              start: e.start,
              end: a,
              startInfo: e,
              decodedCodes: o,
              format: this.FORMAT
            }) : null;
          }
        }]), n;
      }(S),
      code_32_reader: function (t) {
        _()(n, t);

        var e = Rt(n);

        function n() {
          var t;
          h()(this, n);

          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
            i[o] = arguments[o];
          }

          return t = e.call.apply(e, [this].concat(i)), A()(g()(t), "FORMAT", "code_32_reader"), t;
        }

        return p()(n, [{
          key: "_checkChecksum",
          value: function value(t) {
            return !!t;
          }
        }, {
          key: "_decode",
          value: function value(t, e) {
            var r = G()(x()(n.prototype), "_decode", this).call(this, t, e);
            if (!r) return null;
            var i = r.code;
            if (!i) return null;
            if (!(i = i.replace(Ot, "")).match(kt)) return null;
            if (!this._checkChecksum(i)) return null;

            for (var o, a = 0, u = function u(t) {
              var e = i.charAt(t),
                  n = Ct.find(function (t) {
                return t.character_code === e;
              });

              if (void 0 !== n) {
                var r = n.digit_code,
                    o = i.length - t - 1;
                r *= Math.pow(32, o), a += r;
              }
            }, c = 0; c <= i.length; c++) {
              u(c);
            }

            if (a.toString().length < 9) for (var s = 9 - a.toString().length, f = 0; f < s; f++) {
              o = "0" + a;
            }
            return o = "A" + a, r.code = o, r;
          }
        }]), n;
      }(V)
    },
        Mt = {
      registerReader: function registerReader(t, e) {
        jt[t] = e;
      },
      create: function create(t, e) {
        var n = {
          frequency: null,
          pattern: null,
          overlay: null
        },
            r = [];

        function o() {
          t.readers.forEach(function (t) {
            var e,
                n = {},
                o = [];
            "object" === i()(t) ? (e = t.format, n = t.config) : "string" == typeof t && (e = t), n.supplements && (o = n.supplements.map(function (t) {
              return new jt[t]();
            }));

            try {
              var a = new jt[e](n, o);
              r.push(a);
            } catch (t) {
              throw console.error("* Error constructing reader ", e, t), t;
            }
          });
        }

        function a(t) {
          var n,
              i = null,
              o = s.getBarcodeLine(e, t[0], t[1]);

          for (s.toBinaryLine(o), n = 0; n < r.length && null === i; n++) {
            i = r[n].decodePattern(o.line);
          }

          return null === i ? null : {
            codeResult: i,
            barcodeLine: o
          };
        }

        function u(t) {
          var r, i;
          n.overlay;

          var o = function (t) {
            return Math.sqrt(Math.pow(Math.abs(t[1].y - t[0].y), 2) + Math.pow(Math.abs(t[1].x - t[0].x), 2));
          }(r = function (t) {
            return [{
              x: (t[1][0] - t[0][0]) / 2 + t[0][0],
              y: (t[1][1] - t[0][1]) / 2 + t[0][1]
            }, {
              x: (t[3][0] - t[2][0]) / 2 + t[2][0],
              y: (t[3][1] - t[2][1]) / 2 + t[2][1]
            }];
          }(t)),
              u = Math.atan2(r[1].y - r[0].y, r[1].x - r[0].x);

          return null === (r = function (t, n, r) {
            function i(e) {
              var r = e * Math.sin(n),
                  i = e * Math.cos(n);
              t[0].y -= r, t[0].x -= i, t[1].y += r, t[1].x += i;
            }

            for (i(r); r > 1 && (!e.inImageWithBorder(t[0]) || !e.inImageWithBorder(t[1]));) {
              i(-(r -= Math.ceil(r / 2)));
            }

            return t;
          }(r, u, Math.floor(.1 * o))) ? null : (null === (i = a(r)) && (i = function (t, e, n) {
            var r,
                i,
                o,
                u = Math.sqrt(Math.pow(t[1][0] - t[0][0], 2) + Math.pow(t[1][1] - t[0][1], 2)),
                c = null,
                s = Math.sin(n),
                f = Math.cos(n);

            for (r = 1; r < 16 && null === c; r++) {
              o = {
                y: (i = u / 16 * r * (r % 2 == 0 ? -1 : 1)) * s,
                x: i * f
              }, e[0].y += o.x, e[0].x -= o.y, e[1].y += o.x, e[1].x -= o.y, c = a(e);
            }

            return c;
          }(t, r, u)), null === i ? null : {
            codeResult: i.codeResult,
            line: r,
            angle: u,
            pattern: i.barcodeLine.line,
            threshold: i.barcodeLine.threshold
          });
        }

        return o(), {
          decodeFromBoundingBox: function decodeFromBoundingBox(t) {
            return u(t);
          },
          decodeFromBoundingBoxes: function decodeFromBoundingBoxes(e) {
            var n,
                r,
                i = [],
                o = t.multiple;

            for (n = 0; n < e.length; n++) {
              var a = e[n];
              if ((r = u(a) || {}).box = a, o) i.push(r);else if (r.codeResult) return r;
            }

            if (o) return {
              barcodes: i
            };
          },
          decodeFromImage: function decodeFromImage(t) {
            return function (t) {
              for (var e = null, n = 0; n < r.length && null === e; n++) {
                e = r[n].decodeImage ? r[n].decodeImage(t) : null;
              }

              return e;
            }(t);
          },
          registerReader: function registerReader(t, e) {
            if (jt[t]) throw new Error("cannot register existing reader", t);
            jt[t] = e;
          },
          setReaders: function setReaders(e) {
            t.readers = e, r.length = 0, o();
          }
        };
      }
    },
        Tt = function () {
      var t = {};

      function e(e) {
        return t[e] || (t[e] = {
          subscribers: []
        }), t[e];
      }

      function n(t, e) {
        t.async ? setTimeout(function () {
          t.callback(e);
        }, 4) : t.callback(e);
      }

      function r(t, n, r) {
        var i;
        if ("function" == typeof n) i = {
          callback: n,
          async: r
        };else if (!(i = n).callback) throw new Error("Callback was not specified on options");
        e(t).subscribers.push(i);
      }

      return {
        subscribe: function subscribe(t, e, n) {
          return r(t, e, n);
        },
        publish: function publish(t, r) {
          var i = e(t),
              o = i.subscribers;
          o.filter(function (t) {
            return !!t.once;
          }).forEach(function (t) {
            n(t, r);
          }), i.subscribers = o.filter(function (t) {
            return !t.once;
          }), i.subscribers.forEach(function (t) {
            n(t, r);
          });
        },
        once: function once(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          r(t, {
            callback: e,
            async: n,
            once: !0
          });
        },
        unsubscribe: function unsubscribe(n, r) {
          if (n) {
            var i = e(n);
            i.subscribers = i && r ? i.subscribers.filter(function (t) {
              return t.callback !== r;
            }) : [];
          } else t = {};
        }
      };
    }(),
        It = n(17),
        Dt = n.n(It),
        Pt = n(27),
        Lt = n.n(Pt);

    function Ut() {
      try {
        return navigator.mediaDevices.enumerateDevices();
      } catch (t) {
        return Promise.reject(new Error("enumerateDevices is not defined"));
      }
    }

    function zt(t) {
      try {
        return navigator.mediaDevices.getUserMedia(t);
      } catch (t) {
        return Promise.reject(new Error("getUserMedia is not defined"));
      }
    }

    function Bt(t) {
      return new Promise(function (e, n) {
        var r = 10;
        !function i() {
          r > 0 ? t.videoWidth > 10 && t.videoHeight > 10 ? e() : window.setTimeout(i, 500) : n(new Error("Unable to play video stream. Is webcam working?")), r--;
        }();
      });
    }

    function Nt(t, e) {
      return Wt.apply(this, arguments);
    }

    function Wt() {
      return (Wt = Lt()(Dt.a.mark(function t(e, n) {
        var r;
        return Dt.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, zt(n);

              case 2:
                return r = t.sent, St = r, e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e.srcObject = r, e.addEventListener("loadedmetadata", function () {
                  e.play();
                }), t.abrupt("return", Bt(e));

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function Ft(t) {
      var e = Object(C.pick)(t, ["width", "height", "facingMode", "aspectRatio", "deviceId"]);
      return void 0 !== t.minAspectRatio && t.minAspectRatio > 0 && (e.aspectRatio = t.minAspectRatio, console.log("WARNING: Constraint 'minAspectRatio' is deprecated; Use 'aspectRatio' instead")), void 0 !== t.facing && (e.facingMode = t.facing, console.log("WARNING: Constraint 'facing' is deprecated. Use 'facingMode' instead'")), e;
    }

    function qt() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = Ft(t);
      return e && e.deviceId && e.facingMode && delete e.facingMode, Promise.resolve({
        audio: !1,
        video: e
      });
    }

    function Vt() {
      return (Vt = Lt()(Dt.a.mark(function t() {
        var e;
        return Dt.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, Ut();

              case 2:
                return e = t.sent, t.abrupt("return", e.filter(function (t) {
                  return "videoinput" === t.kind;
                }));

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function Yt() {
      if (!St) return null;
      var t = St.getVideoTracks();
      return t && (null == t ? void 0 : t.length) ? t[0] : null;
    }

    var Gt = {
      request: function request(t, e) {
        return Lt()(Dt.a.mark(function n() {
          var r;
          return Dt.a.wrap(function (n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return n.next = 2, qt(e);

                case 2:
                  return r = n.sent, n.abrupt("return", Nt(t, r));

                case 4:
                case "end":
                  return n.stop();
              }
            }
          }, n);
        }))();
      },
      release: function release() {
        var t = St && St.getVideoTracks();
        t && t.length && t[0].stop(), St = null;
      },
      enumerateVideoDevices: function enumerateVideoDevices() {
        return Vt.apply(this, arguments);
      },
      getActiveStreamLabel: function getActiveStreamLabel() {
        var t = Yt();
        return t ? t.label : "";
      },
      getActiveTrack: Yt
    };

    var Ht = {
      create: function create(t) {
        var e,
            n = document.createElement("canvas"),
            r = n.getContext("2d"),
            i = [],
            o = null !== (e = t.capacity) && void 0 !== e ? e : 20,
            a = !0 === t.capture;

        function u(e) {
          return !!o && e && !function (t, e) {
            return e && e.some(function (e) {
              return Object.keys(e).every(function (n) {
                return e[n] === t[n];
              });
            });
          }(e, t.blacklist) && function (t, e) {
            return "function" != typeof e || e(t);
          }(e, t.filter);
        }

        return {
          addResult: function addResult(t, e, c) {
            var s = {};
            u(c) && (o--, s.codeResult = c, a && (n.width = e.x, n.height = e.y, f.a.drawImage(t, e, r), s.frame = n.toDataURL()), i.push(s));
          },
          getResults: function getResults() {
            return i;
          }
        };
      }
    },
        $t = {
      inputStream: {
        name: "Live",
        type: "LiveStream",
        constraints: {
          width: 640,
          height: 480,
          facingMode: "environment"
        },
        area: {
          top: "0%",
          right: "0%",
          left: "0%",
          bottom: "0%"
        },
        singleChannel: !1
      },
      locate: !0,
      numOfWorkers: 4,
      decoder: {
        readers: ["code_128_reader"]
      },
      locator: {
        halfSample: !0,
        patchSize: "medium"
      }
    },
        Xt = n(7),
        Zt = function t() {
      h()(this, t), A()(this, "config", void 0), A()(this, "inputStream", void 0), A()(this, "framegrabber", void 0), A()(this, "inputImageWrapper", void 0), A()(this, "stopped", !1), A()(this, "boxSize", void 0), A()(this, "resultCollector", void 0), A()(this, "decoder", void 0), A()(this, "workerPool", []), A()(this, "onUIThread", !0), A()(this, "canvasContainer", new Kt());
    },
        Qt = function t() {
      h()(this, t), A()(this, "image", void 0), A()(this, "overlay", void 0);
    },
        Kt = function t() {
      h()(this, t), A()(this, "ctx", void 0), A()(this, "dom", void 0), this.ctx = new Qt(), this.dom = new Qt();
    },
        Jt = n(23);

    function te(t) {
      if ("undefined" == typeof document) return null;
      if (t instanceof HTMLElement && t.nodeName && 1 === t.nodeType) return t;
      var e = "string" == typeof t ? t : "#interactive.viewport";
      return document.querySelector(e);
    }

    function ee(t, e) {
      var n = function (t, e) {
        var n = document.querySelector(t);
        return n || ((n = document.createElement("canvas")).className = e), n;
      }(t, e),
          r = n.getContext("2d");

      return {
        canvas: n,
        context: r
      };
    }

    function ne(t) {
      var e,
          n,
          r,
          i,
          o = te(null == t || null === (e = t.config) || void 0 === e || null === (n = e.inputStream) || void 0 === n ? void 0 : n.target),
          a = null == t || null === (r = t.config) || void 0 === r || null === (i = r.inputStream) || void 0 === i ? void 0 : i.type;
      if (!a) return null;

      var u = function (t) {
        if ("undefined" != typeof document) {
          var e = ee("canvas.imgBuffer", "imgBuffer"),
              n = ee("canvas.drawingBuffer", "drawingBuffer");
          return e.canvas.width = n.canvas.width = t.x, e.canvas.height = n.canvas.height = t.y, {
            dom: {
              image: e.canvas,
              overlay: n.canvas
            },
            ctx: {
              image: e.context,
              overlay: n.context
            }
          };
        }

        return null;
      }(t.inputStream.getCanvasSize());

      if (!u) return {
        dom: {
          image: null,
          overlay: null
        },
        ctx: {
          image: null,
          overlay: null
        }
      };
      var c = u.dom;
      return "undefined" != typeof document && o && ("ImageStream" !== a || o.contains(c.image) || o.appendChild(c.image), o.contains(c.overlay) || o.appendChild(c.overlay)), u;
    }

    var re = {
      274: "orientation"
    },
        ie = Object.keys(re).map(function (t) {
      return re[t];
    });

    function oe(t) {
      return new Promise(function (e) {
        var n = new FileReader();
        n.onload = function (t) {
          return e(t.target.result);
        }, n.readAsArrayBuffer(t);
      });
    }

    function ae(t) {
      return new Promise(function (e, n) {
        var r = new XMLHttpRequest();
        r.open("GET", t, !0), r.responseType = "blob", r.onreadystatechange = function () {
          r.readyState !== XMLHttpRequest.DONE || 200 !== r.status && 0 !== r.status || e(this.response);
        }, r.onerror = n, r.send();
      });
    }

    function ue(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ie,
          n = new DataView(t),
          r = t.byteLength,
          i = e.reduce(function (t, e) {
        var n = Object.keys(re).filter(function (t) {
          return re[t] === e;
        })[0];
        return n && (t[n] = e), t;
      }, {}),
          o = 2;
      if (255 !== n.getUint8(0) || 216 !== n.getUint8(1)) return !1;

      for (; o < r;) {
        if (255 !== n.getUint8(o)) return !1;
        if (225 === n.getUint8(o + 1)) return ce(n, o + 4, i);
        o += 2 + n.getUint16(o + 2);
      }

      return !1;
    }

    function ce(t, e, n) {
      if ("Exif" !== function (t, e, n) {
        for (var r = "", i = e; i < e + n; i++) {
          r += String.fromCharCode(t.getUint8(i));
        }

        return r;
      }(t, e, 4)) return !1;
      var r,
          i = e + 6;
      if (18761 === t.getUint16(i)) r = !1;else {
        if (19789 !== t.getUint16(i)) return !1;
        r = !0;
      }
      if (42 !== t.getUint16(i + 2, !r)) return !1;
      var o = t.getUint32(i + 4, !r);
      return !(o < 8) && function (t, e, n, r, i) {
        for (var o = t.getUint16(n, !i), a = {}, u = 0; u < o; u++) {
          var c = n + 12 * u + 2,
              s = r[t.getUint16(c, !i)];
          s && (a[s] = se(t, c, e, n, i));
        }

        return a;
      }(t, i, i + o, n, r);
    }

    function se(t, e, n, r, i) {
      var o = t.getUint16(e + 2, !i),
          a = t.getUint32(e + 4, !i);

      switch (o) {
        case 3:
          if (1 === a) return t.getUint16(e + 8, !i);
      }

      return null;
    }

    var fe = {};

    function le(t, e) {
      t.onload = function () {
        e.loaded(this);
      };
    }

    fe.load = function (t, e, n, r, i) {
      var o,
          a,
          u,
          c = new Array(r),
          s = new Array(c.length);
      if (!1 === i) c[0] = t;else for (o = 0; o < c.length; o++) {
        u = n + o, c[o] = "".concat(t, "image-").concat("00".concat(u).slice(-3), ".jpg");
      }

      for (s.notLoaded = [], s.addImage = function (t) {
        s.notLoaded.push(t);
      }, s.loaded = function (n) {
        for (var r = s.notLoaded, o = 0; o < r.length; o++) {
          if (r[o] === n) {
            r.splice(o, 1);

            for (var a = 0; a < c.length; a++) {
              var u = c[a].substr(c[a].lastIndexOf("/"));

              if (-1 !== n.src.lastIndexOf(u)) {
                s[a] = {
                  img: n
                };
                break;
              }
            }

            break;
          }
        }

        0 === r.length && (!1 === i ? function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ie;
          return /^blob:/i.test(t) ? ae(t).then(oe).then(function (t) {
            return ue(t, e);
          }) : Promise.resolve(null);
        }(t, ["orientation"]).then(function (t) {
          s[0].tags = t, e(s);
        }).catch(function (t) {
          console.log(t), e(s);
        }) : e(s));
      }, o = 0; o < c.length; o++) {
        a = new Image(), s.addImage(a), le(a, s), a.src = c[o];
      }
    };

    var he = fe,
        de = {
      createVideoStream: function createVideoStream(t) {
        var e,
            n,
            r = null,
            i = ["canrecord", "ended"],
            o = {},
            a = {
          x: 0,
          y: 0,
          type: "Point"
        },
            u = {
          x: 0,
          y: 0,
          type: "XYSize"
        };
        var c = {
          getRealWidth: function getRealWidth() {
            return t.videoWidth;
          },
          getRealHeight: function getRealHeight() {
            return t.videoHeight;
          },
          getWidth: function getWidth() {
            return e;
          },
          getHeight: function getHeight() {
            return n;
          },
          setWidth: function setWidth(t) {
            e = t;
          },
          setHeight: function setHeight(t) {
            n = t;
          },
          setInputStream: function setInputStream(t) {
            r = t, this.setAttribute("src", void 0 !== t.src ? t.src : "");
          },
          ended: function ended() {
            return t.ended;
          },
          getConfig: function getConfig() {
            return r;
          },
          setAttribute: function setAttribute(e, n) {
            t && t.setAttribute(e, n);
          },
          pause: function pause() {
            t.pause();
          },
          play: function play() {
            t.play();
          },
          setCurrentTime: function setCurrentTime(t) {
            var e;
            "LiveStream" !== (null === (e = r) || void 0 === e ? void 0 : e.type) && this.setAttribute("currentTime", t.toString());
          },
          addEventListener: function addEventListener(e, n, r) {
            -1 !== i.indexOf(e) ? (o[e] || (o[e] = []), o[e].push(n)) : t.addEventListener(e, n, r);
          },
          clearEventHandlers: function clearEventHandlers() {
            i.forEach(function (e) {
              var n = o[e];
              n && n.length > 0 && n.forEach(function (n) {
                t.removeEventListener(e, n);
              });
            });
          },
          trigger: function trigger(i, a) {
            var s,
                f,
                l,
                h,
                d,
                p = o[i];
            if ("canrecord" === i && (h = t.videoWidth, d = t.videoHeight, e = (null === (f = r) || void 0 === f ? void 0 : f.size) ? h / d > 1 ? r.size : Math.floor(h / d * r.size) : h, n = (null === (l = r) || void 0 === l ? void 0 : l.size) ? h / d > 1 ? Math.floor(d / h * r.size) : r.size : d, u.x = e, u.y = n), p && p.length > 0) for (s = 0; s < p.length; s++) {
              p[s].apply(c, a);
            }
          },
          setTopRight: function setTopRight(t) {
            a.x = t.x, a.y = t.y;
          },
          getTopRight: function getTopRight() {
            return a;
          },
          setCanvasSize: function setCanvasSize(t) {
            u.x = t.x, u.y = t.y;
          },
          getCanvasSize: function getCanvasSize() {
            return u;
          },
          getFrame: function getFrame() {
            return t;
          }
        };
        return c;
      },
      createLiveStream: function createLiveStream(t) {
        t && t.setAttribute("autoplay", "true");
        var e = de.createVideoStream(t);
        return e.ended = function () {
          return !1;
        }, e;
      },
      createImageStream: function createImageStream() {
        var t,
            e,
            n = null,
            r = 0,
            i = 0,
            o = 0,
            a = !0,
            u = !1,
            c = null,
            s = 0,
            f = null,
            l = !1,
            h = ["canrecord", "ended"],
            d = {},
            p = {
          x: 0,
          y: 0,
          type: "Point"
        },
            v = {
          x: 0,
          y: 0,
          type: "XYSize"
        };

        function g(t, e) {
          var n,
              r = d[t];
          if (r && r.length > 0) for (n = 0; n < r.length; n++) {
            r[n].apply(y, e);
          }
        }

        var y = {
          trigger: g,
          getWidth: function getWidth() {
            return t;
          },
          getHeight: function getHeight() {
            return e;
          },
          setWidth: function setWidth(e) {
            t = e;
          },
          setHeight: function setHeight(t) {
            e = t;
          },
          getRealWidth: function getRealWidth() {
            return r;
          },
          getRealHeight: function getRealHeight() {
            return i;
          },
          setInputStream: function setInputStream(a) {
            var l;
            n = a, !1 === a.sequence ? (f = a.src, s = 1) : (f = a.src, s = a.length), u = !1, he.load(f, function (a) {
              var s, f;
              if (c = a, a[0].tags && a[0].tags.orientation) switch (a[0].tags.orientation) {
                case 6:
                case 8:
                  r = a[0].img.height, i = a[0].img.width;
                  break;

                default:
                  r = a[0].img.width, i = a[0].img.height;
              } else r = a[0].img.width, i = a[0].img.height;
              t = (null === (s = n) || void 0 === s ? void 0 : s.size) ? r / i > 1 ? n.size : Math.floor(r / i * n.size) : r, e = (null === (f = n) || void 0 === f ? void 0 : f.size) ? r / i > 1 ? Math.floor(i / r * n.size) : n.size : i, v.x = t, v.y = e, u = !0, o = 0, setTimeout(function () {
                g("canrecord", []);
              }, 0);
            }, 1, s, null === (l = n) || void 0 === l ? void 0 : l.sequence);
          },
          ended: function ended() {
            return l;
          },
          setAttribute: function setAttribute() {},
          getConfig: function getConfig() {
            return n;
          },
          pause: function pause() {
            a = !0;
          },
          play: function play() {
            a = !1;
          },
          setCurrentTime: function setCurrentTime(t) {
            o = t;
          },
          addEventListener: function addEventListener(t, e) {
            -1 !== h.indexOf(t) && (d[t] || (d[t] = []), d[t].push(e));
          },
          clearEventHandlers: function clearEventHandlers() {
            Object.keys(d).forEach(function (t) {
              return delete d[t];
            });
          },
          setTopRight: function setTopRight(t) {
            p.x = t.x, p.y = t.y;
          },
          getTopRight: function getTopRight() {
            return p;
          },
          setCanvasSize: function setCanvasSize(t) {
            v.x = t.x, v.y = t.y;
          },
          getCanvasSize: function getCanvasSize() {
            return v;
          },
          getFrame: function getFrame() {
            var t, e;
            if (!u) return null;
            a || (t = null === (e = c) || void 0 === e ? void 0 : e[o], o < s - 1 ? o++ : setTimeout(function () {
              l = !0, g("ended", []);
            }, 0));
            return t;
          }
        };
        return y;
      }
    },
        pe = de,
        ve = n(25),
        ge = n.n(ve),
        ye = n(66),
        _e = n.n(ye),
        me = {
      createVideoStream: function createVideoStream() {
        throw new Error("createVideoStream not available");
      },
      createLiveStream: function createLiveStream() {
        throw new Error("createLiveStream not available");
      },
      createImageStream: function createImageStream() {
        var t,
            e,
            n,
            r = null,
            i = 0,
            o = 0,
            a = !1,
            u = null,
            c = ["canrecord", "ended"],
            s = {},
            f = {
          x: 0,
          y: 0,
          type: "Point"
        },
            l = {
          x: 0,
          y: 0,
          type: "XYSize"
        };

        function h(t, e) {
          var n = s[t];
          if (n && n.length > 0) for (var r = 0; r < n.length; r++) {
            n[r].apply(d, e);
          }
        }

        var d = {
          trigger: h,
          getWidth: function getWidth() {
            return e;
          },
          getHeight: function getHeight() {
            return n;
          },
          setWidth: function setWidth(t) {
            e = t;
          },
          setHeight: function setHeight(t) {
            n = t;
          },
          getRealWidth: function getRealWidth() {
            return i;
          },
          getRealHeight: function getRealHeight() {
            return o;
          },
          setInputStream: function setInputStream(c) {
            var s, f;
            t = null === (s = r = c) || void 0 === s ? void 0 : s.src, 1, a = !1, _e()(t, null === (f = r) || void 0 === f ? void 0 : f.mime, function (t, c) {
              var s, f;
              if (t) throw console.error("**** quagga loadImages error:", t), new Error("error decoding pixels in loadImages");
              a = !0, u = c;
              var d = ge()(c.shape, 2);
              i = d[0], o = d[1], e = (null === (s = r) || void 0 === s ? void 0 : s.size) ? i / o > 1 ? r.size : Math.floor(i / o * r.size) : i, n = (null === (f = r) || void 0 === f ? void 0 : f.size) ? i / o > 1 ? Math.floor(o / i * r.size) : r.size : o, l.x = e, l.y = n, setTimeout(function () {
                h("canrecord", []);
              }, 0);
            });
          },
          ended: function ended() {
            return !1;
          },
          setAttribute: function setAttribute() {},
          getConfig: function getConfig() {
            return r;
          },
          pause: function pause() {
            !0;
          },
          play: function play() {
            !1;
          },
          setCurrentTime: function setCurrentTime(t) {
            t;
          },
          addEventListener: function addEventListener(t, e) {
            -1 !== c.indexOf(t) && (s[t] || (s[t] = []), s[t].push(e));
          },
          clearEventHandlers: function clearEventHandlers() {
            Object.keys(s).forEach(function (t) {
              return delete s[t];
            });
          },
          setTopRight: function setTopRight(t) {
            f.x = t.x, f.y = t.y;
          },
          getTopRight: function getTopRight() {
            return f;
          },
          setCanvasSize: function setCanvasSize(t) {
            l.x = t.x, l.y = t.y;
          },
          getCanvasSize: function getCanvasSize() {
            return l;
          },
          getFrame: function getFrame() {
            return a ? u : null;
          }
        };
        return d;
      }
    },
        be = pe,
        we = n(62),
        xe = n.n(we),
        Ee = n(8),
        Ae = Math.PI / 180;

    var Re = {
      create: function create(t, e) {
        var n,
            r = {},
            i = t.getConfig(),
            o = (Object(Ee.imageRef)(t.getRealWidth(), t.getRealHeight()), t.getCanvasSize()),
            a = Object(Ee.imageRef)(t.getWidth(), t.getHeight()),
            u = t.getTopRight(),
            c = u.x,
            s = u.y,
            f = null,
            l = null;
        return (n = e || document.createElement("canvas")).width = o.x, n.height = o.y, f = n.getContext("2d"), l = new Uint8Array(a.x * a.y), r.attachData = function (t) {
          l = t;
        }, r.getData = function () {
          return l;
        }, r.grab = function () {
          var e,
              r = i.halfSample,
              u = t.getFrame(),
              h = u,
              d = 0;

          if (h) {
            if (function (t, e) {
              t.width !== e.x && (t.width = e.x), t.height !== e.y && (t.height = e.y);
            }(n, o), "ImageStream" === i.type && (h = u.img, u.tags && u.tags.orientation)) switch (u.tags.orientation) {
              case 6:
                d = 90 * Ae;
                break;

              case 8:
                d = -90 * Ae;
            }
            return 0 !== d ? (f.translate(o.x / 2, o.y / 2), f.rotate(d), f.drawImage(h, -o.y / 2, -o.x / 2, o.y, o.x), f.rotate(-d), f.translate(-o.x / 2, -o.y / 2)) : f.drawImage(h, 0, 0, o.x, o.y), e = f.getImageData(c, s, a.x, a.y).data, r ? Object(Ee.grayAndHalfSampleFromCanvasData)(e, a, l) : Object(Ee.computeGray)(e, l, i), !0;
          }

          return !1;
        }, r.getSize = function () {
          return a;
        }, r;
      }
    },
        Se = Re;

    function Oe(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ke(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Oe(Object(n), !0).forEach(function (e) {
          A()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Oe(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    var Ce = [];

    function je(t) {
      return ke(ke({}, t), {}, {
        inputStream: ke(ke({}, t.inputStream), {}, {
          target: null
        })
      });
    }

    function Me(t) {
      if (t) {
        var e = t().default;
        if (!e) return void self.postMessage({
          event: "error",
          message: "Quagga could not be created"
        });
      }

      var n;

      function r(t) {
        self.postMessage({
          event: "processed",
          imageData: n.data,
          result: t
        }, [n.data.buffer]);
      }

      function i() {
        self.postMessage({
          event: "initialized",
          imageData: n.data
        }, [n.data.buffer]);
      }

      self.onmessage = function (t) {
        if ("init" === t.data.cmd) {
          var o = t.data.config;
          o.numOfWorkers = 0, n = new e.ImageWrapper({
            x: t.data.size.x,
            y: t.data.size.y
          }, new Uint8Array(t.data.imageData)), e.init(o, i, n), e.onProcessed(r);
        } else "process" === t.data.cmd ? (n.data = new Uint8Array(t.data.imageData), e.start()) : "setReaders" === t.data.cmd ? e.setReaders(t.data.readers) : "registerReader" === t.data.cmd && e.registerReader(t.data.name, t.data.reader);
      };
    }

    function Te(t, e, n) {
      var r,
          i,
          o = ("undefined" != typeof __factorySource__ && (i = __factorySource__), r = new Blob(["(" + Me.toString() + ")(" + i + ");"], {
        type: "text/javascript"
      }), window.URL.createObjectURL(r)),
          a = {
        worker: new Worker(o),
        imageData: new Uint8Array(e.getWidth() * e.getHeight()),
        busy: !0
      };
      a.worker.onmessage = function (t) {
        "initialized" === t.data.event ? (URL.revokeObjectURL(o), a.busy = !1, a.imageData = new Uint8Array(t.data.imageData), n(a)) : "processed" === t.data.event ? (a.imageData = new Uint8Array(t.data.imageData), a.busy = !1) : t.data.event;
      }, a.worker.postMessage({
        cmd: "init",
        size: {
          x: e.getWidth(),
          y: e.getHeight()
        },
        imageData: a.imageData,
        config: je(t)
      }, [a.imageData.buffer]);
    }

    function Ie(t, e, n, r) {
      var i = t - Ce.length;
      if (0 === i && r) r();else if (i < 0) {
        Ce.slice(i).forEach(function (t) {
          t.worker.terminate();
        }), Ce = Ce.slice(0, i), r && r();
      } else {
        var o = function o(e) {
          Ce.push(e), Ce.length >= t && r && r();
        };

        if (e) for (var a = 0; a < i; a++) {
          Te(e, n, o);
        }
      }
    }

    function De(t, e, n) {
      for (var r = t.length; r--;) {
        t[r][0] += e, t[r][1] += n;
      }
    }

    var Pe = "undefined" == typeof window ? me : be,
        Le = "undefined" == typeof window ? xe.a : Se,
        Ue = function () {
      function t() {
        var e = this;
        h()(this, t), A()(this, "context", new Zt()), A()(this, "canRecord", function (t) {
          var n;
          e.context.config && (Jt.a.checkImageConstraints(e.context.inputStream, null === (n = e.context.config) || void 0 === n ? void 0 : n.locator), e.initCanvas(), e.context.framegrabber = Le.create(e.context.inputStream, e.context.canvasContainer.dom.image), void 0 === e.context.config.numOfWorkers && (e.context.config.numOfWorkers = 0), Ie(e.context.config.numOfWorkers, e.context.config, e.context.inputStream, function () {
            var n;
            0 === (null === (n = e.context.config) || void 0 === n ? void 0 : n.numOfWorkers) && e.initializeData(), e.ready(t);
          }));
        }), A()(this, "update", function () {
          if (e.context.onUIThread) {
            var t,
                n = (i = e.context.framegrabber, Ce.length ? !!(o = Ce.filter(function (t) {
              return !t.busy;
            })[0]) && (i.attachData(o.imageData), i.grab() && (o.busy = !0, o.worker.postMessage({
              cmd: "process",
              imageData: o.imageData
            }, [o.imageData.buffer])), !0) : null);
            if (!n) e.context.framegrabber.attachData(null === (t = e.context.inputImageWrapper) || void 0 === t ? void 0 : t.data), e.context.framegrabber.grab() && (n || e.locateAndDecode());
          } else {
            var r;
            e.context.framegrabber.attachData(null === (r = e.context.inputImageWrapper) || void 0 === r ? void 0 : r.data), e.context.framegrabber.grab(), e.locateAndDecode();
          }

          var i, o;
        });
      }

      return p()(t, [{
        key: "initBuffers",
        value: function value(t) {
          if (this.context.config) {
            var e = function (t, e, n) {
              var r = e || new o.a({
                x: t.getWidth(),
                y: t.getHeight(),
                type: "XYSize"
              }),
                  i = [Object(Xt.clone)([0, 0]), Object(Xt.clone)([0, r.size.y]), Object(Xt.clone)([r.size.x, r.size.y]), Object(Xt.clone)([r.size.x, 0])];
              return Jt.a.init(r, n), {
                inputImageWrapper: r,
                boxSize: i
              };
            }(this.context.inputStream, t, this.context.config.locator),
                n = e.inputImageWrapper,
                r = e.boxSize;

            this.context.inputImageWrapper = n, this.context.boxSize = r;
          }
        }
      }, {
        key: "initializeData",
        value: function value(t) {
          this.context.config && (this.initBuffers(t), this.context.decoder = Mt.create(this.context.config.decoder, this.context.inputImageWrapper));
        }
      }, {
        key: "getViewPort",
        value: function value() {
          return this.context.config && this.context.config.inputStream ? te(this.context.config.inputStream.target) : null;
        }
      }, {
        key: "ready",
        value: function value(t) {
          this.context.inputStream.play(), t();
        }
      }, {
        key: "initCanvas",
        value: function value() {
          var t = ne(this.context);

          if (t) {
            var e = t.ctx,
                n = t.dom;
            this.context.canvasContainer.dom.image = n.image, this.context.canvasContainer.dom.overlay = n.overlay, this.context.canvasContainer.ctx.image = e.image, this.context.canvasContainer.ctx.overlay = e.overlay;
          }
        }
      }, {
        key: "initInputStream",
        value: function value(t) {
          if (this.context.config && this.context.config.inputStream) {
            var e = this.context.config.inputStream,
                n = e.type,
                r = e.constraints,
                i = function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "LiveStream",
                  e = arguments.length > 1 ? arguments[1] : void 0,
                  n = arguments.length > 2 ? arguments[2] : void 0;

              switch (t) {
                case "VideoStream":
                  var r = document.createElement("video");
                  return {
                    video: r,
                    inputStream: n.createVideoStream(r)
                  };

                case "ImageStream":
                  return {
                    inputStream: n.createImageStream()
                  };

                case "LiveStream":
                  var i = null;
                  return e && ((i = e.querySelector("video")) || (i = document.createElement("video"), e.appendChild(i))), {
                    video: i,
                    inputStream: n.createLiveStream(i)
                  };

                default:
                  return console.error("* setupInputStream invalid type ".concat(t)), {
                    video: null,
                    inputStream: null
                  };
              }
            }(n, this.getViewPort(), Pe),
                o = i.video,
                a = i.inputStream;

            "LiveStream" === n && o && Gt.request(o, r).then(function () {
              return a.trigger("canrecord");
            }).catch(function (e) {
              return t(e);
            }), a.setAttribute("preload", "auto"), a.setInputStream(this.context.config.inputStream), a.addEventListener("canrecord", this.canRecord.bind(void 0, t)), this.context.inputStream = a;
          }
        }
      }, {
        key: "getBoundingBoxes",
        value: function value() {
          var t;
          return (null === (t = this.context.config) || void 0 === t ? void 0 : t.locate) ? Jt.a.locate() : [[Object(Xt.clone)(this.context.boxSize[0]), Object(Xt.clone)(this.context.boxSize[1]), Object(Xt.clone)(this.context.boxSize[2]), Object(Xt.clone)(this.context.boxSize[3])]];
        }
      }, {
        key: "transformResult",
        value: function value(t) {
          var e = this,
              n = this.context.inputStream.getTopRight(),
              r = n.x,
              i = n.y;
          if ((0 !== r || 0 !== i) && (t.barcodes && t.barcodes.forEach(function (t) {
            return e.transformResult(t);
          }), t.line && 2 === t.line.length && function (t, e, n) {
            t[0].x += e, t[0].y += n, t[1].x += e, t[1].y += n;
          }(t.line, r, i), t.box && De(t.box, r, i), t.boxes && t.boxes.length > 0)) for (var o = 0; o < t.boxes.length; o++) {
            De(t.boxes[o], r, i);
          }
        }
      }, {
        key: "addResult",
        value: function value(t, e) {
          var n = this;
          e && this.context.resultCollector && (t.barcodes ? t.barcodes.filter(function (t) {
            return t.codeResult;
          }).forEach(function (t) {
            return n.addResult(t, e);
          }) : t.codeResult && this.context.resultCollector.addResult(e, this.context.inputStream.getCanvasSize(), t.codeResult));
        }
      }, {
        key: "hasCodeResult",
        value: function value(t) {
          return !(!t || !(t.barcodes ? t.barcodes.some(function (t) {
            return t.codeResult;
          }) : t.codeResult));
        }
      }, {
        key: "publishResult",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              e = arguments.length > 1 ? arguments[1] : void 0,
              n = t;
          t && this.context.onUIThread && (this.transformResult(t), this.addResult(t, e), n = t.barcodes || t), Tt.publish("processed", n), this.hasCodeResult(t) && Tt.publish("detected", n);
        }
      }, {
        key: "locateAndDecode",
        value: function value() {
          var t = this.getBoundingBoxes();

          if (t) {
            var e,
                n = this.context.decoder.decodeFromBoundingBoxes(t) || {};
            n.boxes = t, this.publishResult(n, null === (e = this.context.inputImageWrapper) || void 0 === e ? void 0 : e.data);
          } else {
            var r,
                i = this.context.decoder.decodeFromImage(this.context.inputImageWrapper);
            if (i) this.publishResult(i, null === (r = this.context.inputImageWrapper) || void 0 === r ? void 0 : r.data);else this.publishResult();
          }
        }
      }, {
        key: "startContinuousUpdate",
        value: function value() {
          var t,
              e = this,
              n = null,
              r = 1e3 / ((null === (t = this.context.config) || void 0 === t ? void 0 : t.frequency) || 60);
          this.context.stopped = !1;
          var i = this.context;
          !function t(o) {
            n = n || o, i.stopped || (o >= n && (n += r, e.update()), window.requestAnimationFrame(t));
          }(performance.now());
        }
      }, {
        key: "start",
        value: function value() {
          var t, e;
          this.context.onUIThread && "LiveStream" === (null === (t = this.context.config) || void 0 === t || null === (e = t.inputStream) || void 0 === e ? void 0 : e.type) ? this.startContinuousUpdate() : this.update();
        }
      }, {
        key: "stop",
        value: function value() {
          var t;
          this.context.stopped = !0, Ie(0), (null === (t = this.context.config) || void 0 === t ? void 0 : t.inputStream) && "LiveStream" === this.context.config.inputStream.type && (Gt.release(), this.context.inputStream.clearEventHandlers());
        }
      }, {
        key: "setReaders",
        value: function value(t) {
          this.context.decoder && this.context.decoder.setReaders(t), function (t) {
            Ce.forEach(function (e) {
              return e.worker.postMessage({
                cmd: "setReaders",
                readers: t
              });
            });
          }(t);
        }
      }, {
        key: "registerReader",
        value: function value(t, e) {
          Mt.registerReader(t, e), this.context.decoder && this.context.decoder.registerReader(t, e), function (t, e) {
            Ce.forEach(function (n) {
              return n.worker.postMessage({
                cmd: "registerReader",
                name: t,
                reader: e
              });
            });
          }(t, e);
        }
      }]), t;
    }(),
        ze = new Ue(),
        Be = ze.context,
        Ne = {
      init: function init(t, e, n) {
        var r,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ze;
        return e || (r = new Promise(function (t, n) {
          e = function e(_e2) {
            _e2 ? n(_e2) : t();
          };
        })), i.context.config = Object(C.merge)({}, $t, t), i.context.config.numOfWorkers > 0 && (i.context.config.numOfWorkers = 0), n ? (i.context.onUIThread = !1, i.initializeData(n), e && e()) : i.initInputStream(e), r;
      },
      start: function start() {
        ze.start();
      },
      stop: function stop() {
        ze.stop();
      },
      pause: function pause() {
        Be.stopped = !0;
      },
      onDetected: function onDetected(t) {
        t && ("function" == typeof t || "object" === i()(t) && t.callback) ? Tt.subscribe("detected", t) : console.trace("* warning: Quagga.onDetected called with invalid callback, ignoring");
      },
      offDetected: function offDetected(t) {
        Tt.unsubscribe("detected", t);
      },
      onProcessed: function onProcessed(t) {
        t && ("function" == typeof t || "object" === i()(t) && t.callback) ? Tt.subscribe("processed", t) : console.trace("* warning: Quagga.onProcessed called with invalid callback, ignoring");
      },
      offProcessed: function offProcessed(t) {
        Tt.unsubscribe("processed", t);
      },
      setReaders: function setReaders(t) {
        t ? ze.setReaders(t) : console.trace("* warning: Quagga.setReaders called with no readers, ignoring");
      },
      registerReader: function registerReader(t, e) {
        t ? e ? ze.registerReader(t, e) : console.trace("* warning: Quagga.registerReader called with no reader, ignoring") : console.trace("* warning: Quagga.registerReader called with no name, ignoring");
      },
      registerResultCollector: function registerResultCollector(t) {
        t && "function" == typeof t.addResult && (Be.resultCollector = t);
      },

      get canvas() {
        return Be.canvasContainer;
      },

      decodeSingle: function decodeSingle(t, e) {
        var n = this,
            r = new Ue();
        return (t = Object(C.merge)({
          inputStream: {
            type: "ImageStream",
            sequence: !1,
            size: 800,
            src: t.src
          },
          numOfWorkers: 1,
          locator: {
            halfSample: !1
          }
        }, t)).numOfWorkers > 0 && (t.numOfWorkers = 0), t.numOfWorkers > 0 && ("undefined" == typeof Blob || "undefined" == typeof Worker) && (console.warn("* no Worker and/or Blob support - forcing numOfWorkers to 0"), t.numOfWorkers = 0), new Promise(function (i, o) {
          try {
            n.init(t, function () {
              Tt.once("processed", function (t) {
                r.stop(), e && e.call(null, t), i(t);
              }, !0), r.start();
            }, null, r);
          } catch (t) {
            o(t);
          }
        });
      },

      get default() {
        return Ne;
      },

      BarcodeReader: S,
      CameraAccess: Gt,
      ImageDebug: f.a,
      ImageWrapper: o.a,
      ResultCollector: Ht
    };

    e.default = Ne;
  }]).default;
});